// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../node_modules/flatpickr/dist/flatpickr.min.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg width=%2724%27 height=%2724%27 stroke=%27black%27 viewBox=%270 0 24 24%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cg transform-origin=%27center%27%3E%3Ccircle cx=%2712%27 cy=%2712%27 r=%279.5%27 fill=%27none%27 stroke-width=%273%27 stroke-linecap=%27round%27%3E%3CanimateTransform attributeName=%27transform%27 type=%27rotate%27 from=%270 12 12%27 to=%27360 12 12%27 dur=%272s%27 repeatCount=%27indefinite%27/%3E%3Canimate attributeName=%27stroke-dasharray%27 values=%270,150;42,150;42,150%27 keyTimes=%270;0.475;1%27 dur=%271.5s%27 repeatCount=%27indefinite%27/%3E%3Canimate attributeName=%27stroke-dashoffset%27 values=%270;-16;-59%27 keyTimes=%270;0.475;1%27 dur=%271.5s%27 repeatCount=%27indefinite%27/%3E%3C/circle%3E%3C/g%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Ccircle cx=%274%27 cy=%2712%27 r=%273%27%3E%3Canimate attributeName=%27cy%27 values=%2712;6;12;12%27 keyTimes=%270;0.286;0.571;1%27 dur=%271.05s%27 repeatCount=%27indefinite%27 keySplines=%27.33,0,.66,.33;.33,.66,.66,1%27/%3E%3C/circle%3E%3Ccircle cx=%2712%27 cy=%2712%27 r=%273%27%3E%3Canimate attributeName=%27cy%27 values=%2712;6;12;12%27 keyTimes=%270;0.286;0.571;1%27 dur=%271.05s%27 repeatCount=%27indefinite%27 keySplines=%27.33,0,.66,.33;.33,.66,.66,1%27 begin=%270.1s%27/%3E%3C/circle%3E%3Ccircle cx=%2720%27 cy=%2712%27 r=%273%27%3E%3Canimate attributeName=%27cy%27 values=%2712;6;12;12%27 keyTimes=%270;0.286;0.571;1%27 dur=%271.05s%27 repeatCount=%27indefinite%27 keySplines=%27.33,0,.66,.33;.33,.66,.66,1%27 begin=%270.2s%27/%3E%3C/circle%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3Csvg width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Crect x=%271%27 y=%271%27 width=%276%27 height=%2722%27%3E%3Canimate attributeName=%27y%27 values=%271;5;1%27 keyTimes=%270;0.938;1%27 dur=%27.8s%27 repeatCount=%27indefinite%27/%3E%3Canimate attributeName=%27height%27 values=%2722;14;22%27 keyTimes=%270;0.938;1%27 dur=%27.8s%27 repeatCount=%27indefinite%27/%3E%3Canimate attributeName=%27opacity%27 values=%271;0.2;1%27 keyTimes=%270;0.938;1%27 dur=%27.8s%27 repeatCount=%27indefinite%27/%3E%3C/rect%3E%3Crect x=%279%27 y=%271%27 width=%276%27 height=%2722%27%3E%3Canimate attributeName=%27y%27 values=%271;5;1%27 keyTimes=%270;0.938;1%27 dur=%27.8s%27 repeatCount=%27indefinite%27 begin=%27-0.65s%27/%3E%3Canimate attributeName=%27height%27 values=%2722;14;22%27 keyTimes=%270;0.938;1%27 dur=%27.8s%27 repeatCount=%27indefinite%27 begin=%27-0.65s%27/%3E%3Canimate attributeName=%27opacity%27 values=%271;0.2;1%27 keyTimes=%270;0.938;1%27 dur=%27.8s%27 repeatCount=%27indefinite%27 begin=%27-0.65s%27/%3E%3C/rect%3E%3Crect x=%2717%27 y=%271%27 width=%276%27 height=%2722%27%3E%3Canimate attributeName=%27y%27 values=%271;5;1%27 keyTimes=%270;0.938;1%27 dur=%27.8s%27 repeatCount=%27indefinite%27 begin=%27-0.5s%27/%3E%3Canimate attributeName=%27height%27 values=%2722;14;22%27 keyTimes=%270;0.938;1%27 dur=%27.8s%27 repeatCount=%27indefinite%27 begin=%27-0.5s%27/%3E%3Canimate attributeName=%27opacity%27 values=%271;0.2;1%27 keyTimes=%270;0.938;1%27 dur=%27.8s%27 repeatCount=%27indefinite%27 begin=%27-0.5s%27/%3E%3C/rect%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../public/side-bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../public/about-us.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@100;200;300;400;500;600;700;800;900&display=swap);"]);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
/*
! tailwindcss v3.4.17 | MIT License | https://tailwindcss.com
*/
/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/
*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}
::before,
::after {
  --tw-content: '';
}
/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/
html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}
/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/
body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}
/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/
hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}
/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/
abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}
/*
Remove the default font size and weight for headings.
*/
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}
/*
Reset links to optimize for opt-in styling instead of opt-out.
*/
a {
  color: inherit;
  text-decoration: inherit;
}
/*
Add the correct font weight in Edge and Safari.
*/
b,
strong {
  font-weight: bolder;
}
/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/
code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}
/*
Add the correct font size in all browsers.
*/
small {
  font-size: 80%;
}
/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}
sub {
  bottom: -0.25em;
}
sup {
  top: -0.5em;
}
/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/
table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}
/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/
button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}
/*
Remove the inheritance of text transform in Edge and Firefox.
*/
button,
select {
  text-transform: none;
}
/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/
button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}
/*
Use the modern Firefox focus style for all focusable elements.
*/
:-moz-focusring {
  outline: auto;
}
/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/
:-moz-ui-invalid {
  box-shadow: none;
}
/*
Add the correct vertical alignment in Chrome and Firefox.
*/
progress {
  vertical-align: baseline;
}
/*
Correct the cursor style of increment and decrement buttons in Safari.
*/
::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}
/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/
[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}
/*
Remove the inner padding in Chrome and Safari on macOS.
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}
/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/
::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}
/*
Add the correct display in Chrome and Safari.
*/
summary {
  display: list-item;
}
/*
Removes the default spacing and border for appropriate elements.
*/
blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}
fieldset {
  margin: 0;
  padding: 0;
}
legend {
  padding: 0;
}
ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}
/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}
/*
Prevent resizing textareas horizontally by default.
*/
textarea {
  resize: vertical;
}
/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/
input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}
/*
Set the default cursor for buttons.
*/
button,
[role="button"] {
  cursor: pointer;
}
/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}
/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/
img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}
/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/
img,
video {
  max-width: 100%;
  height: auto;
}
/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
:root,
[data-theme]{
  background-color: var(--fallback-b1,oklch(var(--b1)/1));
  color: var(--fallback-bc,oklch(var(--bc)/1));
}
@supports not (color: oklch(0% 0 0)){
  :root{
    color-scheme: light;
    --fallback-p: #491eff;
    --fallback-pc: #d4dbff;
    --fallback-s: #ff41c7;
    --fallback-sc: #fff9fc;
    --fallback-a: #00cfbd;
    --fallback-ac: #00100d;
    --fallback-n: #2b3440;
    --fallback-nc: #d7dde4;
    --fallback-b1: #ffffff;
    --fallback-b2: #e5e6e6;
    --fallback-b3: #e5e6e6;
    --fallback-bc: #1f2937;
    --fallback-in: #00b3f0;
    --fallback-inc: #000000;
    --fallback-su: #00ca92;
    --fallback-suc: #000000;
    --fallback-wa: #ffc22d;
    --fallback-wac: #000000;
    --fallback-er: #ff6f70;
    --fallback-erc: #000000;
  }
  @media (prefers-color-scheme: dark){
    :root{
      color-scheme: dark;
      --fallback-p: #7582ff;
      --fallback-pc: #050617;
      --fallback-s: #ff71cf;
      --fallback-sc: #190211;
      --fallback-a: #00c7b5;
      --fallback-ac: #000e0c;
      --fallback-n: #2a323c;
      --fallback-nc: #a6adbb;
      --fallback-b1: #1d232a;
      --fallback-b2: #191e24;
      --fallback-b3: #15191e;
      --fallback-bc: #a6adbb;
      --fallback-in: #00b3f0;
      --fallback-inc: #000000;
      --fallback-su: #00ca92;
      --fallback-suc: #000000;
      --fallback-wa: #ffc22d;
      --fallback-wac: #000000;
      --fallback-er: #ff6f70;
      --fallback-erc: #000000;
    }
  }
}
html{
  -webkit-tap-highlight-color: transparent;
}
*{
  scrollbar-color: color-mix(in oklch, currentColor 35%, transparent) transparent;
}
*:hover{
  scrollbar-color: color-mix(in oklch, currentColor 60%, transparent) transparent;
}
:root{
  color-scheme: light;
  --in: 72.06% 0.191 231.6;
  --su: 64.8% 0.150 160;
  --wa: 84.71% 0.199 83.87;
  --er: 71.76% 0.221 22.18;
  --pc: 89.824% 0.06192 275.75;
  --ac: 15.352% 0.0368 183.61;
  --inc: 0% 0 0;
  --suc: 0% 0 0;
  --wac: 0% 0 0;
  --erc: 0% 0 0;
  --rounded-box: 1rem;
  --rounded-btn: 0.5rem;
  --rounded-badge: 1.9rem;
  --animation-btn: 0.25s;
  --animation-input: .2s;
  --btn-focus-scale: 0.95;
  --border-btn: 1px;
  --tab-border: 1px;
  --tab-radius: 0.5rem;
  --p: 49.12% 0.3096 275.75;
  --s: 69.71% 0.329 342.55;
  --sc: 98.71% 0.0106 342.55;
  --a: 76.76% 0.184 183.61;
  --n: 32.1785% 0.02476 255.701624;
  --nc: 89.4994% 0.011585 252.096176;
  --b1: 100% 0 0;
  --b2: 96.1151% 0 0;
  --b3: 92.4169% 0.00108 197.137559;
  --bc: 27.8078% 0.029596 256.847952;
}
@media (prefers-color-scheme: dark){
  :root{
    color-scheme: dark;
    --in: 72.06% 0.191 231.6;
    --su: 64.8% 0.150 160;
    --wa: 84.71% 0.199 83.87;
    --er: 71.76% 0.221 22.18;
    --pc: 13.138% 0.0392 275.75;
    --sc: 14.96% 0.052 342.55;
    --ac: 14.902% 0.0334 183.61;
    --inc: 0% 0 0;
    --suc: 0% 0 0;
    --wac: 0% 0 0;
    --erc: 0% 0 0;
    --rounded-box: 1rem;
    --rounded-btn: 0.5rem;
    --rounded-badge: 1.9rem;
    --animation-btn: 0.25s;
    --animation-input: .2s;
    --btn-focus-scale: 0.95;
    --border-btn: 1px;
    --tab-border: 1px;
    --tab-radius: 0.5rem;
    --p: 65.69% 0.196 275.75;
    --s: 74.8% 0.26 342.55;
    --a: 74.51% 0.167 183.61;
    --n: 31.3815% 0.021108 254.139175;
    --nc: 74.6477% 0.0216 264.435964;
    --b1: 25.3267% 0.015896 252.417568;
    --b2: 23.2607% 0.013807 253.100675;
    --b3: 21.1484% 0.01165 254.087939;
    --bc: 74.6477% 0.0216 264.435964;
  }
}
[data-theme=light]{
  color-scheme: light;
  --in: 72.06% 0.191 231.6;
  --su: 64.8% 0.150 160;
  --wa: 84.71% 0.199 83.87;
  --er: 71.76% 0.221 22.18;
  --pc: 89.824% 0.06192 275.75;
  --ac: 15.352% 0.0368 183.61;
  --inc: 0% 0 0;
  --suc: 0% 0 0;
  --wac: 0% 0 0;
  --erc: 0% 0 0;
  --rounded-box: 1rem;
  --rounded-btn: 0.5rem;
  --rounded-badge: 1.9rem;
  --animation-btn: 0.25s;
  --animation-input: .2s;
  --btn-focus-scale: 0.95;
  --border-btn: 1px;
  --tab-border: 1px;
  --tab-radius: 0.5rem;
  --p: 49.12% 0.3096 275.75;
  --s: 69.71% 0.329 342.55;
  --sc: 98.71% 0.0106 342.55;
  --a: 76.76% 0.184 183.61;
  --n: 32.1785% 0.02476 255.701624;
  --nc: 89.4994% 0.011585 252.096176;
  --b1: 100% 0 0;
  --b2: 96.1151% 0 0;
  --b3: 92.4169% 0.00108 197.137559;
  --bc: 27.8078% 0.029596 256.847952;
}
[data-theme=dark]{
  color-scheme: dark;
  --in: 72.06% 0.191 231.6;
  --su: 64.8% 0.150 160;
  --wa: 84.71% 0.199 83.87;
  --er: 71.76% 0.221 22.18;
  --pc: 13.138% 0.0392 275.75;
  --sc: 14.96% 0.052 342.55;
  --ac: 14.902% 0.0334 183.61;
  --inc: 0% 0 0;
  --suc: 0% 0 0;
  --wac: 0% 0 0;
  --erc: 0% 0 0;
  --rounded-box: 1rem;
  --rounded-btn: 0.5rem;
  --rounded-badge: 1.9rem;
  --animation-btn: 0.25s;
  --animation-input: .2s;
  --btn-focus-scale: 0.95;
  --border-btn: 1px;
  --tab-border: 1px;
  --tab-radius: 0.5rem;
  --p: 65.69% 0.196 275.75;
  --s: 74.8% 0.26 342.55;
  --a: 74.51% 0.167 183.61;
  --n: 31.3815% 0.021108 254.139175;
  --nc: 74.6477% 0.0216 264.435964;
  --b1: 25.3267% 0.015896 252.417568;
  --b2: 23.2607% 0.013807 253.100675;
  --b3: 21.1484% 0.01165 254.087939;
  --bc: 74.6477% 0.0216 264.435964;
}
.container{
  width: 100%;
}
@media (min-width: 640px){
  .container{
    max-width: 640px;
  }
}
@media (min-width: 768px){
  .container{
    max-width: 768px;
  }
}
@media (min-width: 1024px){
  .container{
    max-width: 1024px;
  }
}
@media (min-width: 1280px){
  .container{
    max-width: 1280px;
  }
}
@media (min-width: 1536px){
  .container{
    max-width: 1536px;
  }
}
.alert{
  display: grid;
  width: 100%;
  grid-auto-flow: row;
  align-content: flex-start;
  align-items: center;
  justify-items: center;
  gap: 1rem;
  text-align: center;
  border-radius: var(--rounded-box, 1rem);
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: var(--fallback-b2,oklch(var(--b2)/var(--tw-border-opacity)));
  padding: 1rem;
  --tw-text-opacity: 1;
  color: var(--fallback-bc,oklch(var(--bc)/var(--tw-text-opacity)));
  --alert-bg: var(--fallback-b2,oklch(var(--b2)/1));
  --alert-bg-mix: var(--fallback-b1,oklch(var(--b1)/1));
  background-color: var(--alert-bg);
}
@media (min-width: 640px){
  .alert{
    grid-auto-flow: column;
    grid-template-columns: auto minmax(auto,1fr);
    justify-items: start;
    text-align: start;
  }
}
.avatar.placeholder > div{
  display: flex;
  align-items: center;
  justify-content: center;
}
.badge{
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
  transition-duration: 200ms;
  height: 1.25rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  width: fit-content;
  padding-left: 0.563rem;
  padding-right: 0.563rem;
  border-radius: var(--rounded-badge, 1.9rem);
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: var(--fallback-b2,oklch(var(--b2)/var(--tw-border-opacity)));
  --tw-bg-opacity: 1;
  background-color: var(--fallback-b1,oklch(var(--b1)/var(--tw-bg-opacity)));
  --tw-text-opacity: 1;
  color: var(--fallback-bc,oklch(var(--bc)/var(--tw-text-opacity)));
}
@media (hover:hover){
  .label a:hover{
    --tw-text-opacity: 1;
    color: var(--fallback-bc,oklch(var(--bc)/var(--tw-text-opacity)));
  }
  .menu li > *:not(ul, .menu-title, details, .btn):active,
.menu li > *:not(ul, .menu-title, details, .btn).active,
.menu li > details > summary:active{
    --tw-bg-opacity: 1;
    background-color: var(--fallback-n,oklch(var(--n)/var(--tw-bg-opacity)));
    --tw-text-opacity: 1;
    color: var(--fallback-nc,oklch(var(--nc)/var(--tw-text-opacity)));
  }
  .radio-success:hover{
    --tw-border-opacity: 1;
    border-color: var(--fallback-su,oklch(var(--su)/var(--tw-border-opacity)));
  }
  .radio-warning:hover{
    --tw-border-opacity: 1;
    border-color: var(--fallback-wa,oklch(var(--wa)/var(--tw-border-opacity)));
  }
  .radio-info:hover{
    --tw-border-opacity: 1;
    border-color: var(--fallback-in,oklch(var(--in)/var(--tw-border-opacity)));
  }
  .radio-error:hover{
    --tw-border-opacity: 1;
    border-color: var(--fallback-er,oklch(var(--er)/var(--tw-border-opacity)));
  }
  .tab:hover{
    --tw-text-opacity: 1;
  }
  .table tr.hover:hover,
  .table tr.hover:nth-child(even):hover{
    --tw-bg-opacity: 1;
    background-color: var(--fallback-b2,oklch(var(--b2)/var(--tw-bg-opacity)));
  }
  .table-zebra tr.hover:hover,
  .table-zebra tr.hover:nth-child(even):hover{
    --tw-bg-opacity: 1;
    background-color: var(--fallback-b3,oklch(var(--b3)/var(--tw-bg-opacity)));
  }
}
.card{
  position: relative;
  display: flex;
  flex-direction: column;
  border-radius: var(--rounded-box, 1rem);
}
.card:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.card-body{
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  padding: var(--padding-card, 2rem);
  gap: 0.5rem;
}
.card-body :where(p){
  flex-grow: 1;
}
.card figure{
  display: flex;
  align-items: center;
  justify-content: center;
}
.card.image-full{
  display: grid;
}
.card.image-full:before{
  position: relative;
  content: "";
  z-index: 10;
  border-radius: var(--rounded-box, 1rem);
  --tw-bg-opacity: 1;
  background-color: var(--fallback-n,oklch(var(--n)/var(--tw-bg-opacity)));
  opacity: 0.75;
}
.card.image-full:before,
    .card.image-full > *{
  grid-column-start: 1;
  grid-row-start: 1;
}
.card.image-full > figure img{
  height: 100%;
  object-fit: cover;
}
.card.image-full > .card-body{
  position: relative;
  z-index: 20;
  --tw-text-opacity: 1;
  color: var(--fallback-nc,oklch(var(--nc)/var(--tw-text-opacity)));
}
.checkbox{
  flex-shrink: 0;
  --chkbg: var(--fallback-bc,oklch(var(--bc)/1));
  --chkfg: var(--fallback-b1,oklch(var(--b1)/1));
  height: 1.5rem;
  width: 1.5rem;
  cursor: pointer;
  appearance: none;
  border-radius: var(--rounded-btn, 0.5rem);
  border-width: 1px;
  border-color: var(--fallback-bc,oklch(var(--bc)/var(--tw-border-opacity)));
  --tw-border-opacity: 0.2;
}
.collapse:not(td):not(tr):not(colgroup){
  visibility: visible;
}
.collapse{
  position: relative;
  display: grid;
  overflow: hidden;
  grid-template-rows: max-content 0fr;
  transition: grid-template-rows 0.2s;
  width: 100%;
  border-radius: var(--rounded-box, 1rem);
}
.collapse-title,
.collapse > input[type="checkbox"],
.collapse > input[type="radio"],
.collapse-content{
  grid-column-start: 1;
  grid-row-start: 1;
}
.collapse > input[type="checkbox"],
.collapse > input[type="radio"]{
  appearance: none;
  opacity: 0;
}
:where(.collapse > input[type="checkbox"]),
:where(.collapse > input[type="radio"]){
  height: 100%;
  width: 100%;
  z-index: 1;
}
.collapse[open],
.collapse-open,
.collapse:focus:not(.collapse-close){
  grid-template-rows: max-content 1fr;
}
.collapse:not(.collapse-close):has(> input[type="checkbox"]:checked),
.collapse:not(.collapse-close):has(> input[type="radio"]:checked){
  grid-template-rows: max-content 1fr;
}
.collapse[open] > .collapse-content,
.collapse-open > .collapse-content,
.collapse:focus:not(.collapse-close) > .collapse-content,
.collapse:not(.collapse-close) > input[type="checkbox"]:checked ~ .collapse-content,
.collapse:not(.collapse-close) > input[type="radio"]:checked ~ .collapse-content{
  visibility: visible;
  min-height: fit-content;
}
:root .countdown{
  line-height: 1em;
}
.countdown{
  display: inline-flex;
}
.countdown > *{
  height: 1em;
  display: inline-block;
  overflow-y: hidden;
}
.countdown > *:before{
  position: relative;
  content: "00\\A 01\\A 02\\A 03\\A 04\\A 05\\A 06\\A 07\\A 08\\A 09\\A 10\\A 11\\A 12\\A 13\\A 14\\A 15\\A 16\\A 17\\A 18\\A 19\\A 20\\A 21\\A 22\\A 23\\A 24\\A 25\\A 26\\A 27\\A 28\\A 29\\A 30\\A 31\\A 32\\A 33\\A 34\\A 35\\A 36\\A 37\\A 38\\A 39\\A 40\\A 41\\A 42\\A 43\\A 44\\A 45\\A 46\\A 47\\A 48\\A 49\\A 50\\A 51\\A 52\\A 53\\A 54\\A 55\\A 56\\A 57\\A 58\\A 59\\A 60\\A 61\\A 62\\A 63\\A 64\\A 65\\A 66\\A 67\\A 68\\A 69\\A 70\\A 71\\A 72\\A 73\\A 74\\A 75\\A 76\\A 77\\A 78\\A 79\\A 80\\A 81\\A 82\\A 83\\A 84\\A 85\\A 86\\A 87\\A 88\\A 89\\A 90\\A 91\\A 92\\A 93\\A 94\\A 95\\A 96\\A 97\\A 98\\A 99\\A";
  white-space: pre;
  top: calc(var(--value) * -1em);
  text-align: center;
  transition: all 1s cubic-bezier(1, 0, 0, 1);
}
.diff{
  position: relative;
  display: grid;
  width: 100%;
  overflow: hidden;
  direction: ltr;
  container-type: inline-size;
  grid-template-columns: auto 1fr;
}
.divider{
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
  margin-top: 1rem;
  margin-bottom: 1rem;
  height: 1rem;
  white-space: nowrap;
}
.divider:before,
  .divider:after{
  height: 0.125rem;
  width: 100%;
  flex-grow: 1;
  --tw-content: '';
  content: var(--tw-content);
  background-color: var(--fallback-bc,oklch(var(--bc)/0.1));
}
.dropdown{
  position: relative;
  display: inline-block;
}
.dropdown > *:not(summary):focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.dropdown .dropdown-content{
  position: absolute;
}
.dropdown:is(:not(details)) .dropdown-content{
  visibility: hidden;
  opacity: 0;
  transform-origin: top;
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
  transition-duration: 200ms;
}
.dropdown.dropdown-open .dropdown-content,
.dropdown:not(.dropdown-hover):focus .dropdown-content,
.dropdown:focus-within .dropdown-content{
  visibility: visible;
  opacity: 1;
}
@media (hover: hover){
  .dropdown.dropdown-hover:hover .dropdown-content{
    visibility: visible;
    opacity: 1;
  }
  .btm-nav > *.disabled:hover,
      .btm-nav > *[disabled]:hover{
    pointer-events: none;
    --tw-border-opacity: 0;
    background-color: var(--fallback-n,oklch(var(--n)/var(--tw-bg-opacity)));
    --tw-bg-opacity: 0.1;
    color: var(--fallback-bc,oklch(var(--bc)/var(--tw-text-opacity)));
    --tw-text-opacity: 0.2;
  }
  .dropdown.dropdown-hover:hover .dropdown-content{
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
  :where(.menu li:not(.menu-title, .disabled) > *:not(ul, details, .menu-title)):not(.active, .btn):hover, :where(.menu li:not(.menu-title, .disabled) > details > summary:not(.menu-title)):not(.active, .btn):hover{
    cursor: pointer;
    outline: 2px solid transparent;
    outline-offset: 2px;
  }
  @supports (color: oklch(0% 0 0)){
    :where(.menu li:not(.menu-title, .disabled) > *:not(ul, details, .menu-title)):not(.active, .btn):hover, :where(.menu li:not(.menu-title, .disabled) > details > summary:not(.menu-title)):not(.active, .btn):hover{
      background-color: var(--fallback-bc,oklch(var(--bc)/0.1));
    }
  }
  .tab[disabled],
    .tab[disabled]:hover{
    cursor: not-allowed;
    color: var(--fallback-bc,oklch(var(--bc)/var(--tw-text-opacity)));
    --tw-text-opacity: 0.2;
  }
}
.dropdown:is(details) summary::-webkit-details-marker{
  display: none;
}
.footer{
  display: grid;
  width: 100%;
  grid-auto-flow: row;
  place-items: start;
  column-gap: 1rem;
  row-gap: 2.5rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.footer > *{
  display: grid;
  place-items: start;
  gap: 0.5rem;
}
@media (min-width: 48rem){
  .footer{
    grid-auto-flow: column;
  }
  .footer-center{
    grid-auto-flow: row dense;
  }
}
.form-control{
  display: flex;
  flex-direction: column;
}
.label{
  display: flex;
  -webkit-user-select: none;
          user-select: none;
  align-items: center;
  justify-content: space-between;
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.indicator{
  position: relative;
  display: inline-flex;
  width: max-content;
}
.indicator :where(.indicator-item){
  z-index: 1;
  position: absolute;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  white-space: nowrap;
}
.input{
  flex-shrink: 1;
  appearance: none;
  height: 3rem;
  padding-left: 1rem;
  padding-right: 1rem;
  font-size: 1rem;
  line-height: 2;
  line-height: 1.5rem;
  border-radius: var(--rounded-btn, 0.5rem);
  border-width: 1px;
  border-color: transparent;
  --tw-bg-opacity: 1;
  background-color: var(--fallback-b1,oklch(var(--b1)/var(--tw-bg-opacity)));
}
.input[type="number"]::-webkit-inner-spin-button,
.input-md[type="number"]::-webkit-inner-spin-button{
  margin-top: -1rem;
  margin-bottom: -1rem;
  margin-inline-end: -1rem;
}
.join{
  display: inline-flex;
  align-items: stretch;
  border-radius: var(--rounded-btn, 0.5rem);
}
.join :where(.join-item){
  border-start-end-radius: 0;
  border-end-end-radius: 0;
  border-end-start-radius: 0;
  border-start-start-radius: 0;
}
.join .join-item:not(:first-child):not(:last-child),
  .join *:not(:first-child):not(:last-child) .join-item{
  border-start-end-radius: 0;
  border-end-end-radius: 0;
  border-end-start-radius: 0;
  border-start-start-radius: 0;
}
.join .join-item:first-child:not(:last-child),
  .join *:first-child:not(:last-child) .join-item{
  border-start-end-radius: 0;
  border-end-end-radius: 0;
}
.join .dropdown .join-item:first-child:not(:last-child),
  .join *:first-child:not(:last-child) .dropdown .join-item{
  border-start-end-radius: inherit;
  border-end-end-radius: inherit;
}
.join :where(.join-item:first-child:not(:last-child)),
  .join :where(*:first-child:not(:last-child) .join-item){
  border-end-start-radius: inherit;
  border-start-start-radius: inherit;
}
.join .join-item:last-child:not(:first-child),
  .join *:last-child:not(:first-child) .join-item{
  border-end-start-radius: 0;
  border-start-start-radius: 0;
}
.join :where(.join-item:last-child:not(:first-child)),
  .join :where(*:last-child:not(:first-child) .join-item){
  border-start-end-radius: inherit;
  border-end-end-radius: inherit;
}
@supports not selector(:has(*)){
  :where(.join *){
    border-radius: inherit;
  }
}
@supports selector(:has(*)){
  :where(.join *:has(.join-item)){
    border-radius: inherit;
  }
}
.link{
  cursor: pointer;
  text-decoration-line: underline;
}
.menu{
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  font-size: 0.875rem;
  line-height: 1.25rem;
  padding: 0.5rem;
}
.menu :where(li ul){
  position: relative;
  white-space: nowrap;
  margin-inline-start: 1rem;
  padding-inline-start: 0.5rem;
}
.menu :where(li:not(.menu-title) > *:not(ul, details, .menu-title, .btn)), .menu :where(li:not(.menu-title) > details > summary:not(.menu-title)){
  display: grid;
  grid-auto-flow: column;
  align-content: flex-start;
  align-items: center;
  gap: 0.5rem;
  grid-auto-columns: minmax(auto, max-content) auto max-content;
  -webkit-user-select: none;
          user-select: none;
}
.menu li.disabled{
  cursor: not-allowed;
  -webkit-user-select: none;
          user-select: none;
  color: var(--fallback-bc,oklch(var(--bc)/0.3));
}
.menu :where(li > .menu-dropdown:not(.menu-dropdown-show)){
  display: none;
}
:where(.menu li){
  position: relative;
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: stretch;
}
:where(.menu li) .badge{
  justify-self: end;
}
.modal{
  pointer-events: none;
  position: fixed;
  inset: 0px;
  margin: 0px;
  display: grid;
  height: 100%;
  max-height: none;
  width: 100%;
  max-width: none;
  justify-items: center;
  padding: 0px;
  opacity: 0;
  overscroll-behavior: contain;
  z-index: 999;
  background-color: transparent;
  color: inherit;
  transition-duration: 200ms;
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
  transition-property: transform, opacity, visibility;
  overflow-y: hidden;
}
:where(.modal){
  align-items: center;
}
.modal-open,
.modal:target,
.modal-toggle:checked + .modal,
.modal[open]{
  pointer-events: auto;
  visibility: visible;
  opacity: 1;
}
:root:has(:is(.modal-open, .modal:target, .modal-toggle:checked + .modal, .modal[open])){
  overflow: hidden;
  scrollbar-gutter: stable;
}
.progress{
  position: relative;
  width: 100%;
  appearance: none;
  overflow: hidden;
  height: 0.5rem;
  border-radius: var(--rounded-box, 1rem);
  background-color: var(--fallback-bc,oklch(var(--bc)/0.2));
}
.radio{
  flex-shrink: 0;
  --chkbg: var(--bc);
  height: 1.5rem;
  width: 1.5rem;
  cursor: pointer;
  appearance: none;
  border-radius: 9999px;
  border-width: 1px;
  border-color: var(--fallback-bc,oklch(var(--bc)/var(--tw-border-opacity)));
  --tw-border-opacity: 0.2;
}
.range{
  height: 1.5rem;
  width: 100%;
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
  --range-shdw: var(--fallback-bc,oklch(var(--bc)/1));
  overflow: hidden;
  border-radius: var(--rounded-box, 1rem);
  background-color: transparent;
}
.range:focus{
  outline: none;
}
.select{
  display: inline-flex;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  appearance: none;
  height: 3rem;
  min-height: 3rem;
  padding-inline-start: 1rem;
  padding-inline-end: 2.5rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  line-height: 2;
  border-radius: var(--rounded-btn, 0.5rem);
  border-width: 1px;
  border-color: transparent;
  --tw-bg-opacity: 1;
  background-color: var(--fallback-b1,oklch(var(--b1)/var(--tw-bg-opacity)));
  background-image: linear-gradient(45deg, transparent 50%, currentColor 50%),
    linear-gradient(135deg, currentColor 50%, transparent 50%);
  background-position: calc(100% - 20px) calc(1px + 50%),
    calc(100% - 16.1px) calc(1px + 50%);
  background-size: 4px 4px,
    4px 4px;
  background-repeat: no-repeat;
}
.select[multiple]{
  height: auto;
}
.stats{
  display: inline-grid;
  border-radius: var(--rounded-box, 1rem);
  --tw-bg-opacity: 1;
  background-color: var(--fallback-b1,oklch(var(--b1)/var(--tw-bg-opacity)));
  --tw-text-opacity: 1;
  color: var(--fallback-bc,oklch(var(--bc)/var(--tw-text-opacity)));
}
:where(.stats){
  grid-auto-flow: column;
  overflow-x: auto;
}
.stat{
  display: inline-grid;
  width: 100%;
  grid-template-columns: repeat(1, 1fr);
  column-gap: 1rem;
  border-color: var(--fallback-bc,oklch(var(--bc)/var(--tw-border-opacity)));
  --tw-border-opacity: 0.1;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.steps .step{
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  grid-template-columns: auto;
  grid-template-rows: repeat(2, minmax(0, 1fr));
  grid-template-rows: 40px 1fr;
  place-items: center;
  text-align: center;
  min-width: 4rem;
}
.tabs{
  display: grid;
  align-items: flex-end;
}
.tabs-lifted:has(.tab-content[class^="rounded-"])
    .tab:first-child:not(:is(.tab-active, [aria-selected="true"])), .tabs-lifted:has(.tab-content[class*=" rounded-"])
    .tab:first-child:not(:is(.tab-active, [aria-selected="true"])){
  border-bottom-color: transparent;
}
.tab{
  position: relative;
  grid-row-start: 1;
  display: inline-flex;
  height: 2rem;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  appearance: none;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 0.875rem;
  line-height: 1.25rem;
  line-height: 2;
  --tab-padding: 1rem;
  --tw-text-opacity: 0.5;
  --tab-color: var(--fallback-bc,oklch(var(--bc)/1));
  --tab-bg: var(--fallback-b1,oklch(var(--b1)/1));
  --tab-border-color: var(--fallback-b3,oklch(var(--b3)/1));
  color: var(--tab-color);
  padding-inline-start: var(--tab-padding, 1rem);
  padding-inline-end: var(--tab-padding, 1rem);
}
.tab:is(input[type="radio"]){
  width: auto;
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
}
.tab:is(input[type="radio"]):after{
  --tw-content: attr(aria-label);
  content: var(--tw-content);
}
.tab:not(input):empty{
  cursor: default;
  grid-column-start: span 9999;
}
input.tab:checked + .tab-content,
:is(.tab-active, [aria-selected="true"]) + .tab-content{
  display: block;
}
.table{
  position: relative;
  width: 100%;
  border-radius: var(--rounded-box, 1rem);
  text-align: left;
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.table :where(.table-pin-rows thead tr){
  position: sticky;
  top: 0px;
  z-index: 1;
  --tw-bg-opacity: 1;
  background-color: var(--fallback-b1,oklch(var(--b1)/var(--tw-bg-opacity)));
}
.table :where(.table-pin-rows tfoot tr){
  position: sticky;
  bottom: 0px;
  z-index: 1;
  --tw-bg-opacity: 1;
  background-color: var(--fallback-b1,oklch(var(--b1)/var(--tw-bg-opacity)));
}
.table :where(.table-pin-cols tr th){
  position: sticky;
  left: 0px;
  right: 0px;
  --tw-bg-opacity: 1;
  background-color: var(--fallback-b1,oklch(var(--b1)/var(--tw-bg-opacity)));
}
.textarea{
  min-height: 3rem;
  flex-shrink: 1;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  line-height: 2;
  border-radius: var(--rounded-btn, 0.5rem);
  border-width: 1px;
  border-color: transparent;
  --tw-bg-opacity: 1;
  background-color: var(--fallback-b1,oklch(var(--b1)/var(--tw-bg-opacity)));
}
.toast{
  position: fixed;
  display: flex;
  min-width: fit-content;
  flex-direction: column;
  white-space: nowrap;
  gap: 0.5rem;
  padding: 1rem;
}
.toggle{
  flex-shrink: 0;
  --tglbg: var(--fallback-b1,oklch(var(--b1)/1));
  --handleoffset: 1.5rem;
  --handleoffsetcalculator: calc(var(--handleoffset) * -1);
  --togglehandleborder: 0 0;
  height: 1.5rem;
  width: 3rem;
  cursor: pointer;
  appearance: none;
  border-radius: var(--rounded-badge, 1.9rem);
  border-width: 1px;
  border-color: currentColor;
  background-color: currentColor;
  color: var(--fallback-bc,oklch(var(--bc)/0.5));
  transition: background,
    box-shadow var(--animation-input, 0.2s) ease-out;
  box-shadow: var(--handleoffsetcalculator) 0 0 2px var(--tglbg) inset,
    0 0 0 2px var(--tglbg) inset,
    var(--togglehandleborder);
}
.btm-nav > *:where(.active){
  border-top-width: 2px;
  --tw-bg-opacity: 1;
  background-color: var(--fallback-b1,oklch(var(--b1)/var(--tw-bg-opacity)));
}
.btm-nav > *.disabled,
    .btm-nav > *[disabled]{
  pointer-events: none;
  --tw-border-opacity: 0;
  background-color: var(--fallback-n,oklch(var(--n)/var(--tw-bg-opacity)));
  --tw-bg-opacity: 0.1;
  color: var(--fallback-bc,oklch(var(--bc)/var(--tw-text-opacity)));
  --tw-text-opacity: 0.2;
}
.btm-nav > * .label{
  font-size: 1rem;
  line-height: 1.5rem;
}
@keyframes button-pop{
  0%{
    transform: scale(var(--btn-focus-scale, 0.98));
  }
  40%{
    transform: scale(1.02);
  }
  100%{
    transform: scale(1);
  }
}
.card :where(figure:first-child){
  overflow: hidden;
  border-start-start-radius: inherit;
  border-start-end-radius: inherit;
  border-end-start-radius: unset;
  border-end-end-radius: unset;
}
.card :where(figure:last-child){
  overflow: hidden;
  border-start-start-radius: unset;
  border-start-end-radius: unset;
  border-end-start-radius: inherit;
  border-end-end-radius: inherit;
}
.card:focus-visible{
  outline: 2px solid currentColor;
  outline-offset: 2px;
}
.card.bordered{
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: var(--fallback-b2,oklch(var(--b2)/var(--tw-border-opacity)));
}
.card.compact .card-body{
  padding: 1rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.card-title{
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1.25rem;
  line-height: 1.75rem;
  font-weight: 600;
}
.card.image-full :where(figure){
  overflow: hidden;
  border-radius: inherit;
}
.checkbox:focus{
  box-shadow: none;
}
.checkbox:focus-visible{
  outline-style: solid;
  outline-width: 2px;
  outline-offset: 2px;
  outline-color: var(--fallback-bc,oklch(var(--bc)/1));
}
.checkbox:disabled{
  border-width: 0px;
  cursor: not-allowed;
  border-color: transparent;
  --tw-bg-opacity: 1;
  background-color: var(--fallback-bc,oklch(var(--bc)/var(--tw-bg-opacity)));
  opacity: 0.2;
}
.checkbox:checked,
  .checkbox[aria-checked="true"]{
  background-repeat: no-repeat;
  animation: checkmark var(--animation-input, 0.2s) ease-out;
  background-color: var(--chkbg);
  background-image: linear-gradient(-45deg, transparent 65%, var(--chkbg) 65.99%),
      linear-gradient(45deg, transparent 75%, var(--chkbg) 75.99%),
      linear-gradient(-45deg, var(--chkbg) 40%, transparent 40.99%),
      linear-gradient(
        45deg,
        var(--chkbg) 30%,
        var(--chkfg) 30.99%,
        var(--chkfg) 40%,
        transparent 40.99%
      ),
      linear-gradient(-45deg, var(--chkfg) 50%, var(--chkbg) 50.99%);
}
.checkbox:indeterminate{
  --tw-bg-opacity: 1;
  background-color: var(--fallback-bc,oklch(var(--bc)/var(--tw-bg-opacity)));
  background-repeat: no-repeat;
  animation: checkmark var(--animation-input, 0.2s) ease-out;
  background-image: linear-gradient(90deg, transparent 80%, var(--chkbg) 80%),
      linear-gradient(-90deg, transparent 80%, var(--chkbg) 80%),
      linear-gradient(0deg, var(--chkbg) 43%, var(--chkfg) 43%, var(--chkfg) 57%, var(--chkbg) 57%);
}
@keyframes checkmark{
  0%{
    background-position-y: 5px;
  }
  50%{
    background-position-y: -2px;
  }
  100%{
    background-position-y: 0;
  }
}
details.collapse{
  width: 100%;
}
details.collapse summary{
  position: relative;
  display: block;
  outline: 2px solid transparent;
  outline-offset: 2px;
}
details.collapse summary::-webkit-details-marker{
  display: none;
}
.collapse:focus-visible{
  outline-style: solid;
  outline-width: 2px;
  outline-offset: 2px;
  outline-color: var(--fallback-bc,oklch(var(--bc)/1));
}
.collapse:has(.collapse-title:focus-visible),
.collapse:has(> input[type="checkbox"]:focus-visible),
.collapse:has(> input[type="radio"]:focus-visible){
  outline-style: solid;
  outline-width: 2px;
  outline-offset: 2px;
  outline-color: var(--fallback-bc,oklch(var(--bc)/1));
}
.collapse:not(.collapse-open):not(.collapse-close) > input[type="checkbox"],
.collapse:not(.collapse-open):not(.collapse-close) > input[type="radio"]:not(:checked),
.collapse:not(.collapse-open):not(.collapse-close) > .collapse-title{
  cursor: pointer;
}
.collapse:focus:not(.collapse-open):not(.collapse-close):not(.collapse[open]) > .collapse-title{
  cursor: unset;
}
.collapse-title,
:where(.collapse > input[type="checkbox"]),
:where(.collapse > input[type="radio"]){
  padding: 1rem;
  padding-inline-end: 3rem;
  min-height: 3.75rem;
  transition: background-color 0.2s ease-out;
}
.collapse[open] > :where(.collapse-content),
.collapse-open > :where(.collapse-content),
.collapse:focus:not(.collapse-close) > :where(.collapse-content),
.collapse:not(.collapse-close) > :where(input[type="checkbox"]:checked ~ .collapse-content),
.collapse:not(.collapse-close) > :where(input[type="radio"]:checked ~ .collapse-content){
  padding-bottom: 1rem;
  transition: padding 0.2s ease-out,
    background-color 0.2s ease-out;
}
.collapse[open].collapse-arrow > .collapse-title:after,
.collapse-open.collapse-arrow > .collapse-title:after,
.collapse-arrow:focus:not(.collapse-close) > .collapse-title:after,
.collapse-arrow:not(.collapse-close) > input[type="checkbox"]:checked ~ .collapse-title:after,
.collapse-arrow:not(.collapse-close) > input[type="radio"]:checked ~ .collapse-title:after{
  --tw-translate-y: -50%;
  --tw-rotate: 225deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.collapse[open].collapse-plus > .collapse-title:after,
.collapse-open.collapse-plus > .collapse-title:after,
.collapse-plus:focus:not(.collapse-close) > .collapse-title:after,
.collapse-plus:not(.collapse-close) > input[type="checkbox"]:checked ~ .collapse-title:after,
.collapse-plus:not(.collapse-close) > input[type="radio"]:checked ~ .collapse-title:after{
  content: "−";
}
.divider:not(:empty){
  gap: 1rem;
}
.dropdown.dropdown-open .dropdown-content,
.dropdown:focus .dropdown-content,
.dropdown:focus-within .dropdown-content{
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.input input{
  --tw-bg-opacity: 1;
  background-color: var(--fallback-p,oklch(var(--p)/var(--tw-bg-opacity)));
  background-color: transparent;
}
.input input:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.input[list]::-webkit-calendar-picker-indicator{
  line-height: 1em;
}
.input:focus,
  .input:focus-within{
  box-shadow: none;
  border-color: var(--fallback-bc,oklch(var(--bc)/0.2));
  outline-style: solid;
  outline-width: 2px;
  outline-offset: 2px;
  outline-color: var(--fallback-bc,oklch(var(--bc)/0.2));
}
.input:has(> input[disabled]),
  .input-disabled,
  .input:disabled,
  .input[disabled]{
  cursor: not-allowed;
  --tw-border-opacity: 1;
  border-color: var(--fallback-b2,oklch(var(--b2)/var(--tw-border-opacity)));
  --tw-bg-opacity: 1;
  background-color: var(--fallback-b2,oklch(var(--b2)/var(--tw-bg-opacity)));
  color: var(--fallback-bc,oklch(var(--bc)/0.4));
}
.input:has(> input[disabled])::placeholder,
  .input-disabled::placeholder,
  .input:disabled::placeholder,
  .input[disabled]::placeholder{
  color: var(--fallback-bc,oklch(var(--bc)/var(--tw-placeholder-opacity)));
  --tw-placeholder-opacity: 0.2;
}
.input:has(> input[disabled]) > input[disabled]{
  cursor: not-allowed;
}
.input::-webkit-date-and-time-value{
  text-align: inherit;
}
.join > :where(*:not(:first-child)){
  margin-top: 0px;
  margin-bottom: 0px;
  margin-inline-start: -1px;
}
.join > :where(*:not(:first-child)):is(.btn){
  margin-inline-start: calc(var(--border-btn) * -1);
}
.link:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.link:focus-visible{
  outline: 2px solid currentColor;
  outline-offset: 2px;
}
.\\!loading{
  pointer-events: none !important;
  display: inline-block !important;
  aspect-ratio: 1 / 1 !important;
  width: 1.5rem !important;
  background-color: currentColor !important;
  mask-size: 100% !important;
  mask-repeat: no-repeat !important;
  mask-position: center !important;
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
}
.loading{
  pointer-events: none;
  display: inline-block;
  aspect-ratio: 1 / 1;
  width: 1.5rem;
  background-color: currentColor;
  mask-size: 100%;
  mask-repeat: no-repeat;
  mask-position: center;
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.loading-dots{
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.loading-bars{
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.loading-xs{
  width: 1rem;
}
.loading-sm{
  width: 1.25rem;
}
.loading-md{
  width: 1.5rem;
}
:where(.menu li:empty){
  --tw-bg-opacity: 1;
  background-color: var(--fallback-bc,oklch(var(--bc)/var(--tw-bg-opacity)));
  opacity: 0.1;
  margin: 0.5rem 1rem;
  height: 1px;
}
.menu :where(li ul):before{
  position: absolute;
  bottom: 0.75rem;
  inset-inline-start: 0px;
  top: 0.75rem;
  width: 1px;
  --tw-bg-opacity: 1;
  background-color: var(--fallback-bc,oklch(var(--bc)/var(--tw-bg-opacity)));
  opacity: 0.1;
  content: "";
}
.menu :where(li:not(.menu-title) > *:not(ul, details, .menu-title, .btn)),
.menu :where(li:not(.menu-title) > details > summary:not(.menu-title)){
  border-radius: var(--rounded-btn, 0.5rem);
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  text-align: start;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
  transition-duration: 200ms;
  text-wrap: balance;
}
:where(.menu li:not(.menu-title, .disabled) > *:not(ul, details, .menu-title)):not(summary, .active, .btn).focus, :where(.menu li:not(.menu-title, .disabled) > *:not(ul, details, .menu-title)):not(summary, .active, .btn):focus, :where(.menu li:not(.menu-title, .disabled) > *:not(ul, details, .menu-title)):is(summary):not(.active, .btn):focus-visible, :where(.menu li:not(.menu-title, .disabled) > details > summary:not(.menu-title)):not(summary, .active, .btn).focus, :where(.menu li:not(.menu-title, .disabled) > details > summary:not(.menu-title)):not(summary, .active, .btn):focus, :where(.menu li:not(.menu-title, .disabled) > details > summary:not(.menu-title)):is(summary):not(.active, .btn):focus-visible{
  cursor: pointer;
  background-color: var(--fallback-bc,oklch(var(--bc)/0.1));
  --tw-text-opacity: 1;
  color: var(--fallback-bc,oklch(var(--bc)/var(--tw-text-opacity)));
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.menu li > *:not(ul, .menu-title, details, .btn):active,
.menu li > *:not(ul, .menu-title, details, .btn).active,
.menu li > details > summary:active{
  --tw-bg-opacity: 1;
  background-color: var(--fallback-n,oklch(var(--n)/var(--tw-bg-opacity)));
  --tw-text-opacity: 1;
  color: var(--fallback-nc,oklch(var(--nc)/var(--tw-text-opacity)));
}
.menu :where(li > details > summary)::-webkit-details-marker{
  display: none;
}
.menu :where(li > details > summary):after,
.menu :where(li > .menu-dropdown-toggle):after{
  justify-self: end;
  display: block;
  margin-top: -0.5rem;
  height: 0.5rem;
  width: 0.5rem;
  transform: rotate(45deg);
  transition-property: transform, margin-top;
  transition-duration: 0.3s;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  content: "";
  transform-origin: 75% 75%;
  box-shadow: 2px 2px;
  pointer-events: none;
}
.menu :where(li > details[open] > summary):after,
.menu :where(li > .menu-dropdown-toggle.menu-dropdown-show):after{
  transform: rotate(225deg);
  margin-top: 0;
}
.mockup-phone .display{
  overflow: hidden;
  border-radius: 40px;
  margin-top: -25px;
}
.mockup-browser .mockup-browser-toolbar .input{
  position: relative;
  margin-left: auto;
  margin-right: auto;
  display: block;
  height: 1.75rem;
  width: 24rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  --tw-bg-opacity: 1;
  background-color: var(--fallback-b2,oklch(var(--b2)/var(--tw-bg-opacity)));
  padding-left: 2rem;
  direction: ltr;
}
.mockup-browser .mockup-browser-toolbar .input:before{
  content: "";
  position: absolute;
  left: 0.5rem;
  top: 50%;
  aspect-ratio: 1 / 1;
  height: 0.75rem;
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  border-radius: 9999px;
  border-width: 2px;
  border-color: currentColor;
  opacity: 0.6;
}
.mockup-browser .mockup-browser-toolbar .input:after{
  content: "";
  position: absolute;
  left: 1.25rem;
  top: 50%;
  height: 0.5rem;
  --tw-translate-y: 25%;
  --tw-rotate: -45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  border-radius: 9999px;
  border-width: 1px;
  border-color: currentColor;
  opacity: 0.6;
}
.modal:not(dialog:not(.modal-open)),
  .modal::backdrop{
  background-color: #0006;
  animation: modal-pop 0.2s ease-out;
}
.modal-open .modal-box,
.modal-toggle:checked + .modal .modal-box,
.modal:target .modal-box,
.modal[open] .modal-box{
  --tw-translate-y: 0px;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes modal-pop{
  0%{
    opacity: 0;
  }
}
.progress::-moz-progress-bar{
  border-radius: var(--rounded-box, 1rem);
  background-color: currentColor;
}
.progress:indeterminate{
  --progress-color: var(--fallback-bc,oklch(var(--bc)/1));
  background-image: repeating-linear-gradient(
    90deg,
    var(--progress-color) -1%,
    var(--progress-color) 10%,
    transparent 10%,
    transparent 90%
  );
  background-size: 200%;
  background-position-x: 15%;
  animation: progress-loading 5s ease-in-out infinite;
}
.progress::-webkit-progress-bar{
  border-radius: var(--rounded-box, 1rem);
  background-color: transparent;
}
.progress::-webkit-progress-value{
  border-radius: var(--rounded-box, 1rem);
  background-color: currentColor;
}
.progress:indeterminate::-moz-progress-bar{
  background-color: transparent;
  background-image: repeating-linear-gradient(
    90deg,
    var(--progress-color) -1%,
    var(--progress-color) 10%,
    transparent 10%,
    transparent 90%
  );
  background-size: 200%;
  background-position-x: 15%;
  animation: progress-loading 5s ease-in-out infinite;
}
@keyframes progress-loading{
  50%{
    background-position-x: -115%;
  }
}
.radio:focus{
  box-shadow: none;
}
.radio:focus-visible{
  outline-style: solid;
  outline-width: 2px;
  outline-offset: 2px;
  outline-color: var(--fallback-bc,oklch(var(--bc)/1));
}
.radio:checked,
  .radio[aria-checked="true"]{
  --tw-bg-opacity: 1;
  background-color: var(--fallback-bc,oklch(var(--bc)/var(--tw-bg-opacity)));
  background-image: none;
  animation: radiomark var(--animation-input, 0.2s) ease-out;
  box-shadow: 0 0 0 4px var(--fallback-b1,oklch(var(--b1)/1)) inset,
      0 0 0 4px var(--fallback-b1,oklch(var(--b1)/1)) inset;
}
.radio-success{
  --chkbg: var(--su);
  --tw-border-opacity: 1;
  border-color: var(--fallback-su,oklch(var(--su)/var(--tw-border-opacity)));
}
.radio-success:focus-visible{
  outline-color: var(--fallback-su,oklch(var(--su)/1));
}
.radio-success:checked,
    .radio-success[aria-checked="true"]{
  --tw-border-opacity: 1;
  border-color: var(--fallback-su,oklch(var(--su)/var(--tw-border-opacity)));
  --tw-bg-opacity: 1;
  background-color: var(--fallback-su,oklch(var(--su)/var(--tw-bg-opacity)));
  --tw-text-opacity: 1;
  color: var(--fallback-suc,oklch(var(--suc)/var(--tw-text-opacity)));
}
.radio-warning{
  --chkbg: var(--wa);
  --tw-border-opacity: 1;
  border-color: var(--fallback-wa,oklch(var(--wa)/var(--tw-border-opacity)));
}
.radio-warning:focus-visible{
  outline-color: var(--fallback-wa,oklch(var(--wa)/1));
}
.radio-warning:checked,
    .radio-warning[aria-checked="true"]{
  --tw-border-opacity: 1;
  border-color: var(--fallback-wa,oklch(var(--wa)/var(--tw-border-opacity)));
  --tw-bg-opacity: 1;
  background-color: var(--fallback-wa,oklch(var(--wa)/var(--tw-bg-opacity)));
  --tw-text-opacity: 1;
  color: var(--fallback-wac,oklch(var(--wac)/var(--tw-text-opacity)));
}
.radio-info{
  --chkbg: var(--in);
  --tw-border-opacity: 1;
  border-color: var(--fallback-in,oklch(var(--in)/var(--tw-border-opacity)));
}
.radio-info:focus-visible{
  outline-color: var(--fallback-in,oklch(var(--in)/1));
}
.radio-info:checked,
    .radio-info[aria-checked="true"]{
  --tw-border-opacity: 1;
  border-color: var(--fallback-in,oklch(var(--in)/var(--tw-border-opacity)));
  --tw-bg-opacity: 1;
  background-color: var(--fallback-in,oklch(var(--in)/var(--tw-bg-opacity)));
  --tw-text-opacity: 1;
  color: var(--fallback-inc,oklch(var(--inc)/var(--tw-text-opacity)));
}
.radio-error{
  --chkbg: var(--er);
  --tw-border-opacity: 1;
  border-color: var(--fallback-er,oklch(var(--er)/var(--tw-border-opacity)));
}
.radio-error:focus-visible{
  outline-color: var(--fallback-er,oklch(var(--er)/1));
}
.radio-error:checked,
    .radio-error[aria-checked="true"]{
  --tw-border-opacity: 1;
  border-color: var(--fallback-er,oklch(var(--er)/var(--tw-border-opacity)));
  --tw-bg-opacity: 1;
  background-color: var(--fallback-er,oklch(var(--er)/var(--tw-bg-opacity)));
  --tw-text-opacity: 1;
  color: var(--fallback-erc,oklch(var(--erc)/var(--tw-text-opacity)));
}
.radio:disabled{
  cursor: not-allowed;
  opacity: 0.2;
}
@keyframes radiomark{
  0%{
    box-shadow: 0 0 0 12px var(--fallback-b1,oklch(var(--b1)/1)) inset,
      0 0 0 12px var(--fallback-b1,oklch(var(--b1)/1)) inset;
  }
  50%{
    box-shadow: 0 0 0 3px var(--fallback-b1,oklch(var(--b1)/1)) inset,
      0 0 0 3px var(--fallback-b1,oklch(var(--b1)/1)) inset;
  }
  100%{
    box-shadow: 0 0 0 4px var(--fallback-b1,oklch(var(--b1)/1)) inset,
      0 0 0 4px var(--fallback-b1,oklch(var(--b1)/1)) inset;
  }
}
.range:focus-visible::-webkit-slider-thumb{
  --focus-shadow: 0 0 0 6px var(--fallback-b1,oklch(var(--b1)/1)) inset, 0 0 0 2rem var(--range-shdw) inset;
}
.range:focus-visible::-moz-range-thumb{
  --focus-shadow: 0 0 0 6px var(--fallback-b1,oklch(var(--b1)/1)) inset, 0 0 0 2rem var(--range-shdw) inset;
}
.range::-webkit-slider-runnable-track{
  height: 0.5rem;
  width: 100%;
  border-radius: var(--rounded-box, 1rem);
  background-color: var(--fallback-bc,oklch(var(--bc)/0.1));
}
.range::-moz-range-track{
  height: 0.5rem;
  width: 100%;
  border-radius: var(--rounded-box, 1rem);
  background-color: var(--fallback-bc,oklch(var(--bc)/0.1));
}
.range::-webkit-slider-thumb{
  position: relative;
  height: 1.5rem;
  width: 1.5rem;
  border-radius: var(--rounded-box, 1rem);
  border-style: none;
  --tw-bg-opacity: 1;
  background-color: var(--fallback-b1,oklch(var(--b1)/var(--tw-bg-opacity)));
  appearance: none;
  -webkit-appearance: none;
  top: 50%;
  color: var(--range-shdw);
  transform: translateY(-50%);
  --filler-size: 100rem;
  --filler-offset: 0.6rem;
  box-shadow: 0 0 0 3px var(--range-shdw) inset,
      var(--focus-shadow, 0 0),
      calc(var(--filler-size) * -1 - var(--filler-offset)) 0 0 var(--filler-size);
}
.range::-moz-range-thumb{
  position: relative;
  height: 1.5rem;
  width: 1.5rem;
  border-radius: var(--rounded-box, 1rem);
  border-style: none;
  --tw-bg-opacity: 1;
  background-color: var(--fallback-b1,oklch(var(--b1)/var(--tw-bg-opacity)));
  top: 50%;
  color: var(--range-shdw);
  --filler-size: 100rem;
  --filler-offset: 0.5rem;
  box-shadow: 0 0 0 3px var(--range-shdw) inset,
      var(--focus-shadow, 0 0),
      calc(var(--filler-size) * -1 - var(--filler-offset)) 0 0 var(--filler-size);
}
@keyframes rating-pop{
  0%{
    transform: translateY(-0.125em);
  }
  40%{
    transform: translateY(-0.125em);
  }
  100%{
    transform: translateY(0);
  }
}
.select-bordered{
  border-color: var(--fallback-bc,oklch(var(--bc)/0.2));
}
.select:focus{
  box-shadow: none;
  border-color: var(--fallback-bc,oklch(var(--bc)/0.2));
  outline-style: solid;
  outline-width: 2px;
  outline-offset: 2px;
  outline-color: var(--fallback-bc,oklch(var(--bc)/0.2));
}
.select-disabled,
  .select:disabled,
  .select[disabled]{
  cursor: not-allowed;
  --tw-border-opacity: 1;
  border-color: var(--fallback-b2,oklch(var(--b2)/var(--tw-border-opacity)));
  --tw-bg-opacity: 1;
  background-color: var(--fallback-b2,oklch(var(--b2)/var(--tw-bg-opacity)));
  color: var(--fallback-bc,oklch(var(--bc)/0.4));
}
.select-disabled::placeholder,
  .select:disabled::placeholder,
  .select[disabled]::placeholder{
  color: var(--fallback-bc,oklch(var(--bc)/var(--tw-placeholder-opacity)));
  --tw-placeholder-opacity: 0.2;
}
.select-multiple,
  .select[multiple],
  .select[size].select:not([size="1"]){
  background-image: none;
  padding-right: 1rem;
}
[dir="rtl"] .select{
  background-position: calc(0% + 12px) calc(1px + 50%),
    calc(0% + 16px) calc(1px + 50%);
}
.skeleton{
  border-radius: var(--rounded-box, 1rem);
  --tw-bg-opacity: 1;
  background-color: var(--fallback-b3,oklch(var(--b3)/var(--tw-bg-opacity)));
  will-change: background-position;
  animation: skeleton 1.8s ease-in-out infinite;
  background-image: linear-gradient(
    105deg,
    transparent 0%,
    transparent 40%,
    var(--fallback-b1,oklch(var(--b1)/1)) 50%,
    transparent 60%,
    transparent 100%
  );
  background-size: 200% auto;
  background-repeat: no-repeat;
  background-position-x: -50%;
}
@media (prefers-reduced-motion){
  .skeleton{
    animation-duration: 15s;
  }
}
@keyframes skeleton{
  from{
    background-position: 150%;
  }
  to{
    background-position: -50%;
  }
}
:where(.stats) > :not([hidden]) ~ :not([hidden]){
  --tw-divide-x-reverse: 0;
  border-right-width: calc(1px * var(--tw-divide-x-reverse));
  border-left-width: calc(1px * calc(1 - var(--tw-divide-x-reverse)));
  --tw-divide-y-reverse: 0;
  border-top-width: calc(0px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(0px * var(--tw-divide-y-reverse));
}
[dir="rtl"] .stats > *:not([hidden]) ~ *:not([hidden]){
  --tw-divide-x-reverse: 1;
}
.steps .step:before{
  top: 0px;
  grid-column-start: 1;
  grid-row-start: 1;
  height: 0.5rem;
  width: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  --tw-bg-opacity: 1;
  background-color: var(--fallback-b3,oklch(var(--b3)/var(--tw-bg-opacity)));
  --tw-text-opacity: 1;
  color: var(--fallback-bc,oklch(var(--bc)/var(--tw-text-opacity)));
  content: "";
  margin-inline-start: -100%;
}
.steps .step:after{
  content: counter(step);
  counter-increment: step;
  z-index: 1;
  position: relative;
  grid-column-start: 1;
  grid-row-start: 1;
  display: grid;
  height: 2rem;
  width: 2rem;
  place-items: center;
  place-self: center;
  border-radius: 9999px;
  --tw-bg-opacity: 1;
  background-color: var(--fallback-b3,oklch(var(--b3)/var(--tw-bg-opacity)));
  --tw-text-opacity: 1;
  color: var(--fallback-bc,oklch(var(--bc)/var(--tw-text-opacity)));
}
.steps .step:first-child:before{
  content: none;
}
.steps .step[data-content]:after{
  content: attr(data-content);
}
.tabs-lifted > .tab:focus-visible{
  border-end-end-radius: 0;
  border-end-start-radius: 0;
}
.tab:is(.tab-active, [aria-selected="true"]):not(.tab-disabled):not([disabled]), .tab:is(input:checked){
  border-color: var(--fallback-bc,oklch(var(--bc)/var(--tw-border-opacity)));
  --tw-border-opacity: 1;
  --tw-text-opacity: 1;
}
.tab:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.tab:focus-visible{
  outline: 2px solid currentColor;
  outline-offset: -5px;
}
.tab-disabled,
  .tab[disabled]{
  cursor: not-allowed;
  color: var(--fallback-bc,oklch(var(--bc)/var(--tw-text-opacity)));
  --tw-text-opacity: 0.2;
}
.tabs-bordered > .tab{
  border-color: var(--fallback-bc,oklch(var(--bc)/var(--tw-border-opacity)));
  --tw-border-opacity: 0.2;
  border-style: solid;
  border-bottom-width: calc(var(--tab-border, 1px) + 1px);
}
.tabs-lifted > .tab{
  border: var(--tab-border, 1px) solid transparent;
  border-width: 0 0 var(--tab-border, 1px) 0;
  border-start-start-radius: var(--tab-radius, 0.5rem);
  border-start-end-radius: var(--tab-radius, 0.5rem);
  border-bottom-color: var(--tab-border-color);
  padding-inline-start: var(--tab-padding, 1rem);
  padding-inline-end: var(--tab-padding, 1rem);
  padding-top: var(--tab-border, 1px);
}
.tabs-lifted > .tab:is(.tab-active, [aria-selected="true"]):not(.tab-disabled):not([disabled]), .tabs-lifted > .tab:is(input:checked){
  background-color: var(--tab-bg);
  border-width: var(--tab-border, 1px) var(--tab-border, 1px) 0 var(--tab-border, 1px);
  border-inline-start-color: var(--tab-border-color);
  border-inline-end-color: var(--tab-border-color);
  border-top-color: var(--tab-border-color);
  padding-inline-start: calc(var(--tab-padding, 1rem) - var(--tab-border, 1px));
  padding-inline-end: calc(var(--tab-padding, 1rem) - var(--tab-border, 1px));
  padding-bottom: var(--tab-border, 1px);
  padding-top: 0;
}
.tabs-lifted > .tab:is(.tab-active, [aria-selected="true"]):not(.tab-disabled):not([disabled]):before, .tabs-lifted > .tab:is(input:checked):before{
  z-index: 1;
  content: "";
  display: block;
  position: absolute;
  width: calc(100% + var(--tab-radius, 0.5rem) * 2);
  height: var(--tab-radius, 0.5rem);
  bottom: 0;
  background-size: var(--tab-radius, 0.5rem);
  background-position: top left,
        top right;
  background-repeat: no-repeat;
  --tab-grad: calc(69% - var(--tab-border, 1px));
  --radius-start: radial-gradient(
        circle at top left,
        transparent var(--tab-grad),
        var(--tab-border-color) calc(var(--tab-grad) + 0.25px),
        var(--tab-border-color) calc(var(--tab-grad) + var(--tab-border, 1px)),
        var(--tab-bg) calc(var(--tab-grad) + var(--tab-border, 1px) + 0.25px)
      );
  --radius-end: radial-gradient(
        circle at top right,
        transparent var(--tab-grad),
        var(--tab-border-color) calc(var(--tab-grad) + 0.25px),
        var(--tab-border-color) calc(var(--tab-grad) + var(--tab-border, 1px)),
        var(--tab-bg) calc(var(--tab-grad) + var(--tab-border, 1px) + 0.25px)
      );
  background-image: var(--radius-start), var(--radius-end);
}
.tabs-lifted > .tab:is(.tab-active, [aria-selected="true"]):not(.tab-disabled):not([disabled]):first-child:before, .tabs-lifted > .tab:is(input:checked):first-child:before{
  background-image: var(--radius-end);
  background-position: top right;
}
[dir="rtl"] .tabs-lifted > .tab:is(.tab-active, [aria-selected="true"]):not(.tab-disabled):not([disabled]):first-child:before, [dir="rtl"] .tabs-lifted > .tab:is(input:checked):first-child:before{
  background-image: var(--radius-start);
  background-position: top left;
}
.tabs-lifted > .tab:is(.tab-active, [aria-selected="true"]):not(.tab-disabled):not([disabled]):last-child:before, .tabs-lifted > .tab:is(input:checked):last-child:before{
  background-image: var(--radius-start);
  background-position: top left;
}
[dir="rtl"] .tabs-lifted > .tab:is(.tab-active, [aria-selected="true"]):not(.tab-disabled):not([disabled]):last-child:before, [dir="rtl"] .tabs-lifted > .tab:is(input:checked):last-child:before{
  background-image: var(--radius-end);
  background-position: top right;
}
.tabs-lifted
  > :is(.tab-active, [aria-selected="true"]):not(.tab-disabled):not([disabled])
  + .tabs-lifted
  :is(.tab-active, [aria-selected="true"]):not(.tab-disabled):not([disabled]):before, .tabs-lifted > .tab:is(input:checked) + .tabs-lifted .tab:is(input:checked):before{
  background-image: var(--radius-end);
  background-position: top right;
}
.tabs-boxed .tab{
  border-radius: var(--rounded-btn, 0.5rem);
}
.table:where([dir="rtl"], [dir="rtl"] *){
  text-align: right;
}
.table :where(th, td){
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  vertical-align: middle;
}
.table tr.active,
  .table tr.active:nth-child(even),
  .table-zebra tbody tr:nth-child(even){
  --tw-bg-opacity: 1;
  background-color: var(--fallback-b2,oklch(var(--b2)/var(--tw-bg-opacity)));
}
.table-zebra tr.active,
    .table-zebra tr.active:nth-child(even),
    .table-zebra-zebra tbody tr:nth-child(even){
  --tw-bg-opacity: 1;
  background-color: var(--fallback-b3,oklch(var(--b3)/var(--tw-bg-opacity)));
}
.table :where(thead tr, tbody tr:not(:last-child), tbody tr:first-child:last-child){
  border-bottom-width: 1px;
  --tw-border-opacity: 1;
  border-bottom-color: var(--fallback-b2,oklch(var(--b2)/var(--tw-border-opacity)));
}
.table :where(thead, tfoot){
  white-space: nowrap;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 700;
  color: var(--fallback-bc,oklch(var(--bc)/0.6));
}
.table :where(tfoot){
  border-top-width: 1px;
  --tw-border-opacity: 1;
  border-top-color: var(--fallback-b2,oklch(var(--b2)/var(--tw-border-opacity)));
}
.textarea:focus{
  box-shadow: none;
  border-color: var(--fallback-bc,oklch(var(--bc)/0.2));
  outline-style: solid;
  outline-width: 2px;
  outline-offset: 2px;
  outline-color: var(--fallback-bc,oklch(var(--bc)/0.2));
}
.textarea-disabled,
  .textarea:disabled,
  .textarea[disabled]{
  cursor: not-allowed;
  --tw-border-opacity: 1;
  border-color: var(--fallback-b2,oklch(var(--b2)/var(--tw-border-opacity)));
  --tw-bg-opacity: 1;
  background-color: var(--fallback-b2,oklch(var(--b2)/var(--tw-bg-opacity)));
  color: var(--fallback-bc,oklch(var(--bc)/0.4));
}
.textarea-disabled::placeholder,
  .textarea:disabled::placeholder,
  .textarea[disabled]::placeholder{
  color: var(--fallback-bc,oklch(var(--bc)/var(--tw-placeholder-opacity)));
  --tw-placeholder-opacity: 0.2;
}
.toast > *{
  animation: toast-pop 0.25s ease-out;
}
@keyframes toast-pop{
  0%{
    transform: scale(0.9);
    opacity: 0;
  }
  100%{
    transform: scale(1);
    opacity: 1;
  }
}
[dir="rtl"] .toggle{
  --handleoffsetcalculator: calc(var(--handleoffset) * 1);
}
.toggle:focus-visible{
  outline-style: solid;
  outline-width: 2px;
  outline-offset: 2px;
  outline-color: var(--fallback-bc,oklch(var(--bc)/0.2));
}
.toggle:hover{
  background-color: currentColor;
}
.toggle:checked,
  .toggle[aria-checked="true"]{
  background-image: none;
  --handleoffsetcalculator: var(--handleoffset);
  --tw-text-opacity: 1;
  color: var(--fallback-bc,oklch(var(--bc)/var(--tw-text-opacity)));
}
[dir="rtl"] .toggle:checked, [dir="rtl"] .toggle[aria-checked="true"]{
  --handleoffsetcalculator: calc(var(--handleoffset) * -1);
}
.toggle:indeterminate{
  --tw-text-opacity: 1;
  color: var(--fallback-bc,oklch(var(--bc)/var(--tw-text-opacity)));
  box-shadow: calc(var(--handleoffset) / 2) 0 0 2px var(--tglbg) inset,
      calc(var(--handleoffset) / -2) 0 0 2px var(--tglbg) inset,
      0 0 0 2px var(--tglbg) inset;
}
[dir="rtl"] .toggle:indeterminate{
  box-shadow: calc(var(--handleoffset) / 2) 0 0 2px var(--tglbg) inset,
        calc(var(--handleoffset) / -2) 0 0 2px var(--tglbg) inset,
        0 0 0 2px var(--tglbg) inset;
}
.toggle:disabled{
  cursor: not-allowed;
  --tw-border-opacity: 1;
  border-color: var(--fallback-bc,oklch(var(--bc)/var(--tw-border-opacity)));
  background-color: transparent;
  opacity: 0.3;
  --togglehandleborder: 0 0 0 3px var(--fallback-bc,oklch(var(--bc)/1)) inset,
      var(--handleoffsetcalculator) 0 0 3px var(--fallback-bc,oklch(var(--bc)/1)) inset;
}
.artboard.phone{
  width: 320px;
}
.btm-nav-xs > *:where(.active){
  border-top-width: 1px;
}
.btm-nav-sm > *:where(.active){
  border-top-width: 2px;
}
.btm-nav-md > *:where(.active){
  border-top-width: 2px;
}
.btm-nav-lg > *:where(.active){
  border-top-width: 4px;
}
.indicator :where(.indicator-item){
  bottom: auto;
  inset-inline-end: 0px;
  inset-inline-start: auto;
  top: 0px;
  --tw-translate-y: -50%;
  --tw-translate-x: 50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.indicator :where(.indicator-item):where([dir="rtl"], [dir="rtl"] *){
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.indicator :where(.indicator-item.indicator-start){
  inset-inline-end: auto;
  inset-inline-start: 0px;
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.indicator :where(.indicator-item.indicator-start):where([dir="rtl"], [dir="rtl"] *){
  --tw-translate-x: 50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.indicator :where(.indicator-item.indicator-center){
  inset-inline-end: 50%;
  inset-inline-start: 50%;
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.indicator :where(.indicator-item.indicator-center):where([dir="rtl"], [dir="rtl"] *){
  --tw-translate-x: 50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.indicator :where(.indicator-item.indicator-end){
  inset-inline-end: 0px;
  inset-inline-start: auto;
  --tw-translate-x: 50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.indicator :where(.indicator-item.indicator-end):where([dir="rtl"], [dir="rtl"] *){
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.indicator :where(.indicator-item.indicator-bottom){
  bottom: 0px;
  top: auto;
  --tw-translate-y: 50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.indicator :where(.indicator-item.indicator-middle){
  bottom: 50%;
  top: 50%;
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.indicator :where(.indicator-item.indicator-top){
  bottom: auto;
  top: 0px;
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.join.join-vertical{
  flex-direction: column;
}
.join.join-vertical .join-item:first-child:not(:last-child),
  .join.join-vertical *:first-child:not(:last-child) .join-item{
  border-end-start-radius: 0;
  border-end-end-radius: 0;
  border-start-start-radius: inherit;
  border-start-end-radius: inherit;
}
.join.join-vertical .join-item:last-child:not(:first-child),
  .join.join-vertical *:last-child:not(:first-child) .join-item{
  border-start-start-radius: 0;
  border-start-end-radius: 0;
  border-end-start-radius: inherit;
  border-end-end-radius: inherit;
}
.join.join-horizontal{
  flex-direction: row;
}
.join.join-horizontal .join-item:first-child:not(:last-child),
  .join.join-horizontal *:first-child:not(:last-child) .join-item{
  border-end-end-radius: 0;
  border-start-end-radius: 0;
  border-end-start-radius: inherit;
  border-start-start-radius: inherit;
}
.join.join-horizontal .join-item:last-child:not(:first-child),
  .join.join-horizontal *:last-child:not(:first-child) .join-item{
  border-end-start-radius: 0;
  border-start-start-radius: 0;
  border-end-end-radius: inherit;
  border-start-end-radius: inherit;
}
.steps-horizontal .step{
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  grid-template-rows: repeat(2, minmax(0, 1fr));
  place-items: center;
  text-align: center;
}
.steps-vertical .step{
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-template-rows: repeat(1, minmax(0, 1fr));
}
.tabs-md :where(.tab){
  height: 2rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  line-height: 2;
  --tab-padding: 1rem;
}
.tabs-lg :where(.tab){
  height: 3rem;
  font-size: 1.125rem;
  line-height: 1.75rem;
  line-height: 2;
  --tab-padding: 1.25rem;
}
.tabs-sm :where(.tab){
  height: 1.5rem;
  font-size: 0.875rem;
  line-height: .75rem;
  --tab-padding: 0.75rem;
}
.tabs-xs :where(.tab){
  height: 1.25rem;
  font-size: 0.75rem;
  line-height: .75rem;
  --tab-padding: 0.5rem;
}
:where(.toast){
  bottom: 0px;
  inset-inline-end: 0px;
  inset-inline-start: auto;
  top: auto;
  --tw-translate-x: 0px;
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.toast:where(.toast-start){
  inset-inline-end: auto;
  inset-inline-start: 0px;
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.toast:where(.toast-center){
  inset-inline-end: 50%;
  inset-inline-start: 50%;
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.toast:where(.toast-center):where([dir="rtl"], [dir="rtl"] *){
  --tw-translate-x: 50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.toast:where(.toast-end){
  inset-inline-end: 0px;
  inset-inline-start: auto;
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.toast:where(.toast-bottom){
  bottom: 0px;
  top: auto;
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.toast:where(.toast-middle){
  bottom: auto;
  top: 50%;
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.toast:where(.toast-top){
  bottom: auto;
  top: 0px;
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tooltip{
  position: relative;
  display: inline-block;
  --tooltip-offset: calc(100% + 1px + var(--tooltip-tail, 0px));
}
.tooltip:before{
  position: absolute;
  pointer-events: none;
  z-index: 1;
  content: var(--tw-content);
  --tw-content: attr(data-tip);
}
.tooltip:before, .tooltip-top:before{
  transform: translateX(-50%);
  top: auto;
  left: 50%;
  right: auto;
  bottom: var(--tooltip-offset);
}
.avatar.online:before{
  content: "";
  position: absolute;
  z-index: 10;
  display: block;
  border-radius: 9999px;
  --tw-bg-opacity: 1;
  background-color: var(--fallback-su,oklch(var(--su)/var(--tw-bg-opacity)));
  outline-style: solid;
  outline-width: 2px;
  outline-color: var(--fallback-b1,oklch(var(--b1)/1));
  width: 15%;
  height: 15%;
  top: 7%;
  right: 7%;
}
.avatar.offline:before{
  content: "";
  position: absolute;
  z-index: 10;
  display: block;
  border-radius: 9999px;
  --tw-bg-opacity: 1;
  background-color: var(--fallback-b3,oklch(var(--b3)/var(--tw-bg-opacity)));
  outline-style: solid;
  outline-width: 2px;
  outline-color: var(--fallback-b1,oklch(var(--b1)/1));
  width: 15%;
  height: 15%;
  top: 7%;
  right: 7%;
}
.card-compact .card-body{
  padding: 1rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.card-compact .card-title{
  margin-bottom: 0.25rem;
}
.card-normal .card-body{
  padding: var(--padding-card, 2rem);
  font-size: 1rem;
  line-height: 1.5rem;
}
.card-normal .card-title{
  margin-bottom: 0.75rem;
}
.join.join-vertical > :where(*:not(:first-child)){
  margin-left: 0px;
  margin-right: 0px;
  margin-top: -1px;
}
.join.join-vertical > :where(*:not(:first-child)):is(.btn){
  margin-top: calc(var(--border-btn) * -1);
}
.join.join-horizontal > :where(*:not(:first-child)){
  margin-top: 0px;
  margin-bottom: 0px;
  margin-inline-start: -1px;
}
.join.join-horizontal > :where(*:not(:first-child)):is(.btn){
  margin-inline-start: calc(var(--border-btn) * -1);
  margin-top: 0px;
}
.steps-horizontal .step{
  grid-template-rows: 40px 1fr;
  grid-template-columns: auto;
  min-width: 4rem;
}
.steps-horizontal .step:before{
  height: 0.5rem;
  width: 100%;
  --tw-translate-x: 0px;
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  content: "";
  margin-inline-start: -100%;
}
.steps-horizontal .step:where([dir="rtl"], [dir="rtl"] *):before{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.steps-vertical .step{
  gap: 0.5rem;
  grid-template-columns: 40px 1fr;
  grid-template-rows: auto;
  min-height: 4rem;
  justify-items: start;
}
.steps-vertical .step:before{
  height: 100%;
  width: 0.5rem;
  --tw-translate-x: -50%;
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  margin-inline-start: 50%;
}
.steps-vertical .step:where([dir="rtl"], [dir="rtl"] *):before{
  --tw-translate-x: 50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tooltip{
  position: relative;
  display: inline-block;
  text-align: center;
  --tooltip-tail: 0.1875rem;
  --tooltip-color: var(--fallback-n,oklch(var(--n)/1));
  --tooltip-text-color: var(--fallback-nc,oklch(var(--nc)/1));
  --tooltip-tail-offset: calc(100% + 0.0625rem - var(--tooltip-tail));
}
.tooltip:before,
.tooltip:after{
  opacity: 0;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-delay: 100ms;
  transition-duration: 200ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.tooltip:after{
  position: absolute;
  content: "";
  border-style: solid;
  border-width: var(--tooltip-tail, 0);
  width: 0;
  height: 0;
  display: block;
}
.tooltip:before{
  max-width: 20rem;
  white-space: normal;
  border-radius: 0.25rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  background-color: var(--tooltip-color);
  color: var(--tooltip-text-color);
  width: max-content;
}
.tooltip.tooltip-open:before{
  opacity: 1;
  transition-delay: 75ms;
}
.tooltip.tooltip-open:after{
  opacity: 1;
  transition-delay: 75ms;
}
.tooltip:hover:before{
  opacity: 1;
  transition-delay: 75ms;
}
.tooltip:hover:after{
  opacity: 1;
  transition-delay: 75ms;
}
.tooltip:has(:focus-visible):after,
.tooltip:has(:focus-visible):before{
  opacity: 1;
  transition-delay: 75ms;
}
.tooltip:not([data-tip]):hover:before,
.tooltip:not([data-tip]):hover:after{
  visibility: hidden;
  opacity: 0;
}
.tooltip:after, .tooltip-top:after{
  transform: translateX(-50%);
  border-color: var(--tooltip-color) transparent transparent transparent;
  top: auto;
  left: 50%;
  right: auto;
  bottom: var(--tooltip-tail-offset);
}
.sr-only{
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none{
  pointer-events: none;
}
.visible{
  visibility: visible;
}
.collapse{
  visibility: collapse;
}
.static{
  position: static;
}
.fixed{
  position: fixed;
}
.absolute{
  position: absolute;
}
.relative{
  position: relative;
}
.sticky{
  position: sticky;
}
.inset-0{
  inset: 0px;
}
.inset-y-0{
  top: 0px;
  bottom: 0px;
}
.-bottom-1{
  bottom: -0.25rem;
}
.-left-20{
  left: -5rem;
}
.-top-16{
  top: -4rem;
}
.bottom-0{
  bottom: 0px;
}
.bottom-2{
  bottom: 0.5rem;
}
.bottom-8{
  bottom: 2rem;
}
.bottom-\\[-20px\\]{
  bottom: -20px;
}
.bottom-\\[-2px\\]{
  bottom: -2px;
}
.bottom-\\[-50px\\]{
  bottom: -50px;
}
.bottom-\\[0\\%\\]{
  bottom: 0%;
}
.bottom-\\[4\\%\\]{
  bottom: 4%;
}
.bottom-\\[40px\\]{
  bottom: 40px;
}
.bottom-full{
  bottom: 100%;
}
.left-0{
  left: 0px;
}
.left-1{
  left: 0.25rem;
}
.left-1\\/2{
  left: 50%;
}
.left-10{
  left: 2.5rem;
}
.left-2{
  left: 0.5rem;
}
.left-2\\.5{
  left: 0.625rem;
}
.left-3{
  left: 0.75rem;
}
.left-3\\.5{
  left: 0.875rem;
}
.left-6{
  left: 1.5rem;
}
.left-7{
  left: 1.75rem;
}
.left-\\[-20px\\]{
  left: -20px;
}
.left-\\[-2px\\]{
  left: -2px;
}
.left-\\[0\\%\\]{
  left: 0%;
}
.left-\\[1\\%\\]{
  left: 1%;
}
.left-\\[10px\\]{
  left: 10px;
}
.left-\\[160px\\]{
  left: 160px;
}
.left-\\[166px\\]{
  left: 166px;
}
.left-\\[2\\%\\]{
  left: 2%;
}
.left-\\[20\\%\\]{
  left: 20%;
}
.left-\\[240px\\]{
  left: 240px;
}
.left-\\[35px\\]{
  left: 35px;
}
.left-\\[40\\%\\]{
  left: 40%;
}
.left-\\[5\\%\\]{
  left: 5%;
}
.left-\\[50\\%\\]{
  left: 50%;
}
.left-\\[52\\%\\]{
  left: 52%;
}
.left-\\[60\\%\\]{
  left: 60%;
}
.left-\\[90px\\]{
  left: 90px;
}
.right-0{
  right: 0px;
}
.right-1{
  right: 0.25rem;
}
.right-10{
  right: 2.5rem;
}
.right-11{
  right: 2.75rem;
}
.right-2{
  right: 0.5rem;
}
.right-3{
  right: 0.75rem;
}
.right-4{
  right: 1rem;
}
.right-5{
  right: 1.25rem;
}
.right-9{
  right: 2.25rem;
}
.right-\\[-70px\\]{
  right: -70px;
}
.right-\\[0\\%\\]{
  right: 0%;
}
.right-\\[0px\\]{
  right: 0px;
}
.right-\\[1\\%\\]{
  right: 1%;
}
.right-\\[10\\%\\]{
  right: 10%;
}
.right-\\[100px\\]{
  right: 100px;
}
.right-\\[10px\\]{
  right: 10px;
}
.right-\\[150px\\]{
  right: 150px;
}
.right-\\[17\\%\\]{
  right: 17%;
}
.right-\\[2\\%\\]{
  right: 2%;
}
.right-\\[20\\%\\]{
  right: 20%;
}
.right-\\[200px\\]{
  right: 200px;
}
.right-\\[25px\\]{
  right: 25px;
}
.right-\\[2px\\]{
  right: 2px;
}
.right-\\[4\\%\\]{
  right: 4%;
}
.right-\\[5\\%\\]{
  right: 5%;
}
.right-\\[50px\\]{
  right: 50px;
}
.start-0{
  inset-inline-start: 0px;
}
.top-0{
  top: 0px;
}
.top-1\\/2{
  top: 50%;
}
.top-10{
  top: 2.5rem;
}
.top-12{
  top: 3rem;
}
.top-2{
  top: 0.5rem;
}
.top-2\\.5{
  top: 0.625rem;
}
.top-20{
  top: 5rem;
}
.top-3{
  top: 0.75rem;
}
.top-4{
  top: 1rem;
}
.top-5{
  top: 1.25rem;
}
.top-6{
  top: 1.5rem;
}
.top-8{
  top: 2rem;
}
.top-\\[-40px\\]{
  top: -40px;
}
.top-\\[-8px\\]{
  top: -8px;
}
.top-\\[0\\%\\]{
  top: 0%;
}
.top-\\[0px\\]{
  top: 0px;
}
.top-\\[1\\%\\]{
  top: 1%;
}
.top-\\[100\\%\\]{
  top: 100%;
}
.top-\\[100px\\]{
  top: 100px;
}
.top-\\[10px\\]{
  top: 10px;
}
.top-\\[2\\%\\]{
  top: 2%;
}
.top-\\[200px\\]{
  top: 200px;
}
.top-\\[26\\%\\]{
  top: 26%;
}
.top-\\[3\\%\\]{
  top: 3%;
}
.top-\\[5\\%\\]{
  top: 5%;
}
.top-\\[50\\%\\]{
  top: 50%;
}
.top-\\[6\\%\\]{
  top: 6%;
}
.top-\\[70px\\]{
  top: 70px;
}
.isolate{
  isolation: isolate;
}
.z-0{
  z-index: 0;
}
.z-10{
  z-index: 10;
}
.z-20{
  z-index: 20;
}
.z-40{
  z-index: 40;
}
.z-50{
  z-index: 50;
}
.z-\\[0\\]{
  z-index: 0;
}
.z-\\[1000\\]{
  z-index: 1000;
}
.z-\\[100\\]{
  z-index: 100;
}
.z-\\[1\\]{
  z-index: 1;
}
.col-span-1{
  grid-column: span 1 / span 1;
}
.col-span-4{
  grid-column: span 4 / span 4;
}
.col-span-full{
  grid-column: 1 / -1;
}
.-m-1\\.5{
  margin: -0.375rem;
}
.m-0{
  margin: 0px;
}
.m-4{
  margin: 1rem;
}
.m-5{
  margin: 1.25rem;
}
.m-\\[10px\\]{
  margin: 10px;
}
.m-auto{
  margin: auto;
}
.\\!my-3{
  margin-top: 0.75rem !important;
  margin-bottom: 0.75rem !important;
}
.mx-1{
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-2{
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-3{
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}
.mx-4{
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-5{
  margin-left: 1.25rem;
  margin-right: 1.25rem;
}
.mx-\\[50px\\]{
  margin-left: 50px;
  margin-right: 50px;
}
.mx-\\[auto\\]{
  margin-left: auto;
  margin-right: auto;
}
.mx-auto{
  margin-left: auto;
  margin-right: auto;
}
.my-0{
  margin-top: 0px;
  margin-bottom: 0px;
}
.my-1{
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-3{
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.my-4{
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-5{
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
}
.my-6{
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.my-8{
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.my-\\[10px\\]{
  margin-top: 10px;
  margin-bottom: 10px;
}
.my-\\[20px\\]{
  margin-top: 20px;
  margin-bottom: 20px;
}
.my-\\[30px\\]{
  margin-top: 30px;
  margin-bottom: 30px;
}
.\\!mt-10{
  margin-top: 2.5rem !important;
}
.\\!mt-2{
  margin-top: 0.5rem !important;
}
.\\!mt-3{
  margin-top: 0.75rem !important;
}
.\\!mt-4{
  margin-top: 1rem !important;
}
.\\!mt-\\[10px\\]{
  margin-top: 10px !important;
}
.-mb-px{
  margin-bottom: -1px;
}
.-ml-1{
  margin-left: -0.25rem;
}
.-mt-16{
  margin-top: -4rem;
}
.mb-0{
  margin-bottom: 0px;
}
.mb-1{
  margin-bottom: 0.25rem;
}
.mb-10{
  margin-bottom: 2.5rem;
}
.mb-12{
  margin-bottom: 3rem;
}
.mb-2{
  margin-bottom: 0.5rem;
}
.mb-20{
  margin-bottom: 5rem;
}
.mb-3{
  margin-bottom: 0.75rem;
}
.mb-4{
  margin-bottom: 1rem;
}
.mb-5{
  margin-bottom: 1.25rem;
}
.mb-6{
  margin-bottom: 1.5rem;
}
.mb-8{
  margin-bottom: 2rem;
}
.mb-\\[1\\.5rem\\]{
  margin-bottom: 1.5rem;
}
.mb-\\[10px\\]{
  margin-bottom: 10px;
}
.mb-\\[15px\\]{
  margin-bottom: 15px;
}
.mb-\\[200px\\]{
  margin-bottom: 200px;
}
.mb-\\[20px\\]{
  margin-bottom: 20px;
}
.mb-\\[30px\\]{
  margin-bottom: 30px;
}
.mb-\\[50px\\]{
  margin-bottom: 50px;
}
.mb-\\[5px\\]{
  margin-bottom: 5px;
}
.mb-\\[5rem\\]{
  margin-bottom: 5rem;
}
.me-2{
  margin-inline-end: 0.5rem;
}
.me-3{
  margin-inline-end: 0.75rem;
}
.ml-0{
  margin-left: 0px;
}
.ml-1{
  margin-left: 0.25rem;
}
.ml-10{
  margin-left: 2.5rem;
}
.ml-2{
  margin-left: 0.5rem;
}
.ml-3{
  margin-left: 0.75rem;
}
.ml-4{
  margin-left: 1rem;
}
.ml-5{
  margin-left: 1.25rem;
}
.ml-\\[10px\\]{
  margin-left: 10px;
}
.ml-auto{
  margin-left: auto;
}
.mr-1{
  margin-right: 0.25rem;
}
.mr-1\\.5{
  margin-right: 0.375rem;
}
.mr-2{
  margin-right: 0.5rem;
}
.mr-3{
  margin-right: 0.75rem;
}
.mr-4{
  margin-right: 1rem;
}
.mr-8{
  margin-right: 2rem;
}
.ms-3{
  margin-inline-start: 0.75rem;
}
.ms-5{
  margin-inline-start: 1.25rem;
}
.mt-0\\.5{
  margin-top: 0.125rem;
}
.mt-1{
  margin-top: 0.25rem;
}
.mt-10{
  margin-top: 2.5rem;
}
.mt-14{
  margin-top: 3.5rem;
}
.mt-16{
  margin-top: 4rem;
}
.mt-2{
  margin-top: 0.5rem;
}
.mt-20{
  margin-top: 5rem;
}
.mt-3{
  margin-top: 0.75rem;
}
.mt-4{
  margin-top: 1rem;
}
.mt-5{
  margin-top: 1.25rem;
}
.mt-6{
  margin-top: 1.5rem;
}
.mt-7{
  margin-top: 1.75rem;
}
.mt-8{
  margin-top: 2rem;
}
.mt-\\[100px\\]{
  margin-top: 100px;
}
.mt-\\[10px\\]{
  margin-top: 10px;
}
.mt-\\[15px\\]{
  margin-top: 15px;
}
.mt-\\[1rem\\]{
  margin-top: 1rem;
}
.mt-\\[20px\\]{
  margin-top: 20px;
}
.mt-\\[2rem\\]{
  margin-top: 2rem;
}
.mt-\\[30px\\]{
  margin-top: 30px;
}
.mt-\\[4px\\]{
  margin-top: 4px;
}
.mt-\\[50px\\]{
  margin-top: 50px;
}
.mt-\\[5px\\]{
  margin-top: 5px;
}
.mt-\\[60px\\]{
  margin-top: 60px;
}
.box-border{
  box-sizing: border-box;
}
.line-clamp-2{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.block{
  display: block;
}
.inline-block{
  display: inline-block;
}
.inline{
  display: inline;
}
.flex{
  display: flex;
}
.inline-flex{
  display: inline-flex;
}
.table{
  display: table;
}
.table-cell{
  display: table-cell;
}
.grid{
  display: grid;
}
.contents{
  display: contents;
}
.hidden{
  display: none;
}
.aspect-video{
  aspect-ratio: 16 / 9;
}
.size-5{
  width: 1.25rem;
  height: 1.25rem;
}
.size-6{
  width: 1.5rem;
  height: 1.5rem;
}
.size-8{
  width: 2rem;
  height: 2rem;
}
.\\!h-10{
  height: 2.5rem !important;
}
.\\!h-8{
  height: 2rem !important;
}
.\\!h-\\[25px\\]{
  height: 25px !important;
}
.\\!h-\\[30px\\]{
  height: 30px !important;
}
.\\!h-\\[40px\\]{
  height: 40px !important;
}
.\\!h-\\[614px\\]{
  height: 614px !important;
}
.h-10{
  height: 2.5rem;
}
.h-12{
  height: 3rem;
}
.h-16{
  height: 4rem;
}
.h-2{
  height: 0.5rem;
}
.h-2\\.5{
  height: 0.625rem;
}
.h-20{
  height: 5rem;
}
.h-24{
  height: 6rem;
}
.h-3{
  height: 0.75rem;
}
.h-3\\.5{
  height: 0.875rem;
}
.h-32{
  height: 8rem;
}
.h-4{
  height: 1rem;
}
.h-40{
  height: 10rem;
}
.h-48{
  height: 12rem;
}
.h-5{
  height: 1.25rem;
}
.h-6{
  height: 1.5rem;
}
.h-64{
  height: 16rem;
}
.h-7{
  height: 1.75rem;
}
.h-8{
  height: 2rem;
}
.h-\\[100\\%\\]{
  height: 100%;
}
.h-\\[100px\\]{
  height: 100px;
}
.h-\\[100vh\\]{
  height: 100vh;
}
.h-\\[180px\\]{
  height: 180px;
}
.h-\\[184px\\]{
  height: 184px;
}
.h-\\[200px\\]{
  height: 200px;
}
.h-\\[200vh\\]{
  height: 200vh;
}
.h-\\[20px\\]{
  height: 20px;
}
.h-\\[20vh\\]{
  height: 20vh;
}
.h-\\[250px\\]{
  height: 250px;
}
.h-\\[25vh\\]{
  height: 25vh;
}
.h-\\[274px\\]{
  height: 274px;
}
.h-\\[300px\\]{
  height: 300px;
}
.h-\\[30px\\]{
  height: 30px;
}
.h-\\[30rem\\]{
  height: 30rem;
}
.h-\\[330px\\]{
  height: 330px;
}
.h-\\[350px\\]{
  height: 350px;
}
.h-\\[365px\\]{
  height: 365px;
}
.h-\\[370px\\]{
  height: 370px;
}
.h-\\[380px\\]{
  height: 380px;
}
.h-\\[400px\\]{
  height: 400px;
}
.h-\\[40px\\]{
  height: 40px;
}
.h-\\[40vh\\]{
  height: 40vh;
}
.h-\\[42px\\]{
  height: 42px;
}
.h-\\[500px\\]{
  height: 500px;
}
.h-\\[50px\\]{
  height: 50px;
}
.h-\\[50vh\\]{
  height: 50vh;
}
.h-\\[6\\%\\]{
  height: 6%;
}
.h-\\[60px\\]{
  height: 60px;
}
.h-\\[60vh\\]{
  height: 60vh;
}
.h-\\[614px\\]{
  height: 614px;
}
.h-\\[680px\\]{
  height: 680px;
}
.h-\\[68px\\]{
  height: 68px;
}
.h-\\[70px\\]{
  height: 70px;
}
.h-\\[70vh\\]{
  height: 70vh;
}
.h-\\[80px\\]{
  height: 80px;
}
.h-\\[80vh\\]{
  height: 80vh;
}
.h-\\[85vh\\]{
  height: 85vh;
}
.h-\\[88\\.5vh\\]{
  height: 88.5vh;
}
.h-\\[90\\%\\]{
  height: 90%;
}
.h-\\[90vh\\]{
  height: 90vh;
}
.h-\\[95vh\\]{
  height: 95vh;
}
.h-\\[96vh\\]{
  height: 96vh;
}
.h-\\[calc\\(100\\%-20px\\)\\]{
  height: calc(100% - 20px);
}
.h-auto{
  height: auto;
}
.h-full{
  height: 100%;
}
.h-px{
  height: 1px;
}
.h-screen{
  height: 100vh;
}
.max-h-0{
  max-height: 0px;
}
.max-h-24{
  max-height: 6rem;
}
.max-h-60{
  max-height: 15rem;
}
.max-h-64{
  max-height: 16rem;
}
.max-h-96{
  max-height: 24rem;
}
.max-h-\\[100px\\]{
  max-height: 100px;
}
.max-h-\\[200px\\]{
  max-height: 200px;
}
.max-h-\\[40px\\]{
  max-height: 40px;
}
.max-h-\\[50\\%\\]{
  max-height: 50%;
}
.max-h-\\[500px\\]{
  max-height: 500px;
}
.max-h-\\[80vh\\]{
  max-height: 80vh;
}
.max-h-\\[90vh\\]{
  max-height: 90vh;
}
.max-h-\\[91vh\\]{
  max-height: 91vh;
}
.max-h-\\[calc\\(90vh-120px\\)\\]{
  max-height: calc(90vh - 120px);
}
.max-h-\\[calc\\(90vh-200px\\)\\]{
  max-height: calc(90vh - 200px);
}
.max-h-full{
  max-height: 100%;
}
.max-h-screen{
  max-height: 100vh;
}
.min-h-\\[100px\\]{
  min-height: 100px;
}
.min-h-\\[10px\\]{
  min-height: 10px;
}
.min-h-\\[200px\\]{
  min-height: 200px;
}
.min-h-\\[300px\\]{
  min-height: 300px;
}
.min-h-\\[400px\\]{
  min-height: 400px;
}
.min-h-\\[500px\\]{
  min-height: 500px;
}
.min-h-\\[50vh\\]{
  min-height: 50vh;
}
.min-h-\\[55vh\\]{
  min-height: 55vh;
}
.min-h-\\[60\\%\\]{
  min-height: 60%;
}
.min-h-\\[600px\\]{
  min-height: 600px;
}
.min-h-\\[80px\\]{
  min-height: 80px;
}
.min-h-\\[84px\\]{
  min-height: 84px;
}
.min-h-\\[90vh\\]{
  min-height: 90vh;
}
.min-h-screen{
  min-height: 100vh;
}
.\\!w-1\\/2{
  width: 50% !important;
}
.\\!w-16{
  width: 4rem !important;
}
.\\!w-\\[40px\\]{
  width: 40px !important;
}
.\\!w-\\[50px\\]{
  width: 50px !important;
}
.\\!w-\\[70px\\]{
  width: 70px !important;
}
.\\!w-\\[80px\\]{
  width: 80px !important;
}
.\\!w-\\[90px\\]{
  width: 90px !important;
}
.\\!w-full{
  width: 100% !important;
}
.w-0{
  width: 0px;
}
.w-1\\/2{
  width: 50%;
}
.w-1\\/3{
  width: 33.333333%;
}
.w-1\\/4{
  width: 25%;
}
.w-10{
  width: 2.5rem;
}
.w-12{
  width: 3rem;
}
.w-14{
  width: 3.5rem;
}
.w-16{
  width: 4rem;
}
.w-2{
  width: 0.5rem;
}
.w-2\\.5{
  width: 0.625rem;
}
.w-20{
  width: 5rem;
}
.w-24{
  width: 6rem;
}
.w-28{
  width: 7rem;
}
.w-3{
  width: 0.75rem;
}
.w-3\\.5{
  width: 0.875rem;
}
.w-3\\/4{
  width: 75%;
}
.w-32{
  width: 8rem;
}
.w-36{
  width: 9rem;
}
.w-4{
  width: 1rem;
}
.w-40{
  width: 10rem;
}
.w-44{
  width: 11rem;
}
.w-48{
  width: 12rem;
}
.w-5{
  width: 1.25rem;
}
.w-5\\/6{
  width: 83.333333%;
}
.w-56{
  width: 14rem;
}
.w-6{
  width: 1.5rem;
}
.w-64{
  width: 16rem;
}
.w-72{
  width: 18rem;
}
.w-8{
  width: 2rem;
}
.w-9\\/12{
  width: 75%;
}
.w-\\[100\\%\\]{
  width: 100%;
}
.w-\\[100px\\]{
  width: 100px;
}
.w-\\[100vw\\]{
  width: 100vw;
}
.w-\\[120px\\]{
  width: 120px;
}
.w-\\[125px\\]{
  width: 125px;
}
.w-\\[140px\\]{
  width: 140px;
}
.w-\\[150px\\]{
  width: 150px;
}
.w-\\[16px\\]{
  width: 16px;
}
.w-\\[170px\\]{
  width: 170px;
}
.w-\\[180px\\]{
  width: 180px;
}
.w-\\[200px\\]{
  width: 200px;
}
.w-\\[20px\\]{
  width: 20px;
}
.w-\\[20vw\\]{
  width: 20vw;
}
.w-\\[250px\\]{
  width: 250px;
}
.w-\\[253px\\]{
  width: 253px;
}
.w-\\[25px\\]{
  width: 25px;
}
.w-\\[26px\\]{
  width: 26px;
}
.w-\\[280px\\]{
  width: 280px;
}
.w-\\[288px\\]{
  width: 288px;
}
.w-\\[30\\%\\]{
  width: 30%;
}
.w-\\[300px\\]{
  width: 300px;
}
.w-\\[307px\\]{
  width: 307px;
}
.w-\\[30rem\\]{
  width: 30rem;
}
.w-\\[32px\\]{
  width: 32px;
}
.w-\\[350px\\]{
  width: 350px;
}
.w-\\[35vw\\]{
  width: 35vw;
}
.w-\\[400px\\]{
  width: 400px;
}
.w-\\[40px\\]{
  width: 40px;
}
.w-\\[40vw\\]{
  width: 40vw;
}
.w-\\[42\\.5\\%\\]{
  width: 42.5%;
}
.w-\\[50\\%\\]{
  width: 50%;
}
.w-\\[500px\\]{
  width: 500px;
}
.w-\\[50px\\]{
  width: 50px;
}
.w-\\[55px\\]{
  width: 55px;
}
.w-\\[580px\\]{
  width: 580px;
}
.w-\\[60px\\]{
  width: 60px;
}
.w-\\[67vw\\]{
  width: 67vw;
}
.w-\\[69\\%\\]{
  width: 69%;
}
.w-\\[70\\%\\]{
  width: 70%;
}
.w-\\[700px\\]{
  width: 700px;
}
.w-\\[70px\\]{
  width: 70px;
}
.w-\\[70vw\\]{
  width: 70vw;
}
.w-\\[80\\%\\]{
  width: 80%;
}
.w-\\[80\\]{
  width: 80;
}
.w-\\[80px\\]{
  width: 80px;
}
.w-\\[80vw\\]{
  width: 80vw;
}
.w-\\[90\\%\\]{
  width: 90%;
}
.w-\\[90vw\\]{
  width: 90vw;
}
.w-\\[92vw\\]{
  width: 92vw;
}
.w-\\[95\\%\\]{
  width: 95%;
}
.w-\\[95vw\\]{
  width: 95vw;
}
.w-\\[calc\\(100\\%-200px\\)\\]{
  width: calc(100% - 200px);
}
.w-\\[calc\\(100\\%-20px\\)\\]{
  width: calc(100% - 20px);
}
.w-\\[calc\\(100\\%-400px\\)\\]{
  width: calc(100% - 400px);
}
.w-\\[calc\\(50\\%-10px\\)\\]{
  width: calc(50% - 10px);
}
.w-auto{
  width: auto;
}
.w-fit{
  width: fit-content;
}
.w-full{
  width: 100%;
}
.w-max{
  width: max-content;
}
.min-w-0{
  min-width: 0px;
}
.min-w-12{
  min-width: 3rem;
}
.min-w-20{
  min-width: 5rem;
}
.min-w-48{
  min-width: 12rem;
}
.min-w-\\[100px\\]{
  min-width: 100px;
}
.min-w-\\[120px\\]{
  min-width: 120px;
}
.min-w-\\[180px\\]{
  min-width: 180px;
}
.min-w-\\[200px\\]{
  min-width: 200px;
}
.min-w-\\[250px\\]{
  min-width: 250px;
}
.min-w-\\[280px\\]{
  min-width: 280px;
}
.min-w-\\[288px\\]{
  min-width: 288px;
}
.min-w-\\[400px\\]{
  min-width: 400px;
}
.min-w-\\[50px\\]{
  min-width: 50px;
}
.min-w-\\[50vw\\]{
  min-width: 50vw;
}
.min-w-full{
  min-width: 100%;
}
.\\!max-w-\\[200px\\]{
  max-width: 200px !important;
}
.max-w-2xl{
  max-width: 42rem;
}
.max-w-3xl{
  max-width: 48rem;
}
.max-w-4xl{
  max-width: 56rem;
}
.max-w-6xl{
  max-width: 72rem;
}
.max-w-7xl{
  max-width: 80rem;
}
.max-w-\\[100px\\]{
  max-width: 100px;
}
.max-w-\\[1150px\\]{
  max-width: 1150px;
}
.max-w-\\[1200px\\]{
  max-width: 1200px;
}
.max-w-\\[150px\\]{
  max-width: 150px;
}
.max-w-\\[157px\\]{
  max-width: 157px;
}
.max-w-\\[160px\\]{
  max-width: 160px;
}
.max-w-\\[180px\\]{
  max-width: 180px;
}
.max-w-\\[200px\\]{
  max-width: 200px;
}
.max-w-\\[273px\\]{
  max-width: 273px;
}
.max-w-\\[282px\\]{
  max-width: 282px;
}
.max-w-\\[288px\\]{
  max-width: 288px;
}
.max-w-\\[40px\\]{
  max-width: 40px;
}
.max-w-\\[780px\\]{
  max-width: 780px;
}
.max-w-\\[80\\%\\]{
  max-width: 80%;
}
.max-w-\\[800px\\]{
  max-width: 800px;
}
.max-w-\\[90vw\\]{
  max-width: 90vw;
}
.max-w-\\[95vw\\]{
  max-width: 95vw;
}
.max-w-\\[980px\\]{
  max-width: 980px;
}
.max-w-full{
  max-width: 100%;
}
.max-w-lg{
  max-width: 32rem;
}
.max-w-md{
  max-width: 28rem;
}
.max-w-sm{
  max-width: 24rem;
}
.max-w-xl{
  max-width: 36rem;
}
.max-w-xs{
  max-width: 20rem;
}
.flex-1{
  flex: 1 1;
}
.flex-auto{
  flex: 1 1 auto;
}
.flex-shrink-0{
  flex-shrink: 0;
}
.shrink{
  flex-shrink: 1;
}
.shrink-0{
  flex-shrink: 0;
}
.flex-grow{
  flex-grow: 1;
}
.grow{
  flex-grow: 1;
}
.grow-0{
  flex-grow: 0;
}
.table-auto{
  table-layout: auto;
}
.border-collapse{
  border-collapse: collapse;
}
.border-separate{
  border-collapse: separate;
}
.border-spacing-5{
  --tw-border-spacing-x: 1.25rem;
  --tw-border-spacing-y: 1.25rem;
  border-spacing: var(--tw-border-spacing-x) var(--tw-border-spacing-y);
}
.origin-top-right{
  transform-origin: top right;
}
.-translate-x-1\\/2{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-full{
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-full{
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-\\[-50\\%\\]{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-12{
  --tw-rotate: 12deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-45{
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-100{
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes pulse{
  50%{
    opacity: .5;
  }
}
.animate-pulse{
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin{
  to{
    transform: rotate(360deg);
  }
}
.animate-spin{
  animation: spin 1s linear infinite;
}
.cursor-default{
  cursor: default;
}
.cursor-help{
  cursor: help;
}
.cursor-not-allowed{
  cursor: not-allowed;
}
.cursor-pointer{
  cursor: pointer;
}
.cursor-text{
  cursor: text;
}
.select-none{
  -webkit-user-select: none;
          user-select: none;
}
.resize-none{
  resize: none;
}
.resize{
  resize: both;
}
.list-inside{
  list-style-position: inside;
}
.list-decimal{
  list-style-type: decimal;
}
.list-disc{
  list-style-type: disc;
}
.\\!appearance-none{
  appearance: none !important;
}
.appearance-none{
  appearance: none;
}
.auto-cols-max{
  grid-auto-columns: max-content;
}
.grid-flow-col{
  grid-auto-flow: column;
}
.grid-cols-1{
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2{
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3{
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-4{
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.grid-cols-7{
  grid-template-columns: repeat(7, minmax(0, 1fr));
}
.flex-row{
  flex-direction: row;
}
.flex-col{
  flex-direction: column;
}
.flex-col-reverse{
  flex-direction: column-reverse;
}
.flex-wrap{
  flex-wrap: wrap;
}
.flex-nowrap{
  flex-wrap: nowrap;
}
.place-items-center{
  place-items: center;
}
.items-start{
  align-items: flex-start;
}
.items-end{
  align-items: flex-end;
}
.items-center{
  align-items: center;
}
.justify-start{
  justify-content: flex-start;
}
.justify-end{
  justify-content: flex-end;
}
.justify-center{
  justify-content: center;
}
.justify-between{
  justify-content: space-between;
}
.justify-around{
  justify-content: space-around;
}
.gap-1{
  gap: 0.25rem;
}
.gap-1\\.5{
  gap: 0.375rem;
}
.gap-10{
  gap: 2.5rem;
}
.gap-2{
  gap: 0.5rem;
}
.gap-3{
  gap: 0.75rem;
}
.gap-3\\.5{
  gap: 0.875rem;
}
.gap-4{
  gap: 1rem;
}
.gap-5{
  gap: 1.25rem;
}
.gap-6{
  gap: 1.5rem;
}
.gap-7{
  gap: 1.75rem;
}
.gap-8{
  gap: 2rem;
}
.gap-\\[0px\\]{
  gap: 0px;
}
.gap-\\[10px\\]{
  gap: 10px;
}
.gap-\\[19px\\]{
  gap: 19px;
}
.gap-\\[1px\\]{
  gap: 1px;
}
.gap-\\[1rem\\]{
  gap: 1rem;
}
.gap-\\[20px\\]{
  gap: 20px;
}
.gap-\\[30px\\]{
  gap: 30px;
}
.gap-\\[36px\\]{
  gap: 36px;
}
.gap-\\[3px\\]{
  gap: 3px;
}
.gap-\\[4px\\]{
  gap: 4px;
}
.gap-\\[50px\\]{
  gap: 50px;
}
.gap-\\[5px\\]{
  gap: 5px;
}
.gap-\\[6px\\]{
  gap: 6px;
}
.gap-\\[93px\\]{
  gap: 93px;
}
.gap-x-1\\.5{
  column-gap: 0.375rem;
}
.gap-x-4{
  column-gap: 1rem;
}
.gap-x-6{
  column-gap: 1.5rem;
}
.gap-x-\\[100px\\]{
  column-gap: 100px;
}
.gap-y-12{
  row-gap: 3rem;
}
.gap-y-3{
  row-gap: 0.75rem;
}
.gap-y-6{
  row-gap: 1.5rem;
}
.gap-y-8{
  row-gap: 2rem;
}
.-space-x-px > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(-1px * var(--tw-space-x-reverse));
  margin-left: calc(-1px * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.75rem * var(--tw-space-x-reverse));
  margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-8 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(2rem * var(--tw-space-x-reverse));
  margin-left: calc(2rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.space-y-8 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2rem * var(--tw-space-y-reverse));
}
.divide-y > :not([hidden]) ~ :not([hidden]){
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-gray-200 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-divide-opacity, 1));
}
.overflow-auto{
  overflow: auto;
}
.overflow-hidden{
  overflow: hidden;
}
.overflow-visible{
  overflow: visible;
}
.overflow-x-auto{
  overflow-x: auto;
}
.overflow-y-auto{
  overflow-y: auto;
}
.overflow-x-hidden{
  overflow-x: hidden;
}
.overflow-y-hidden{
  overflow-y: hidden;
}
.truncate{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.overflow-ellipsis{
  text-overflow: ellipsis;
}
.whitespace-nowrap{
  white-space: nowrap;
}
.whitespace-pre-wrap{
  white-space: pre-wrap;
}
.text-nowrap{
  text-wrap: nowrap;
}
.break-words{
  overflow-wrap: break-word;
}
.\\!rounded-\\[6px\\]{
  border-radius: 6px !important;
}
.rounded{
  border-radius: 0.25rem;
}
.rounded-2xl{
  border-radius: 1rem;
}
.rounded-3xl{
  border-radius: 1.5rem;
}
.rounded-\\[0rem\\]{
  border-radius: 0rem;
}
.rounded-\\[100\\%\\]{
  border-radius: 100%;
}
.rounded-\\[10px\\]{
  border-radius: 10px;
}
.rounded-\\[20px\\]{
  border-radius: 20px;
}
.rounded-\\[5px\\]{
  border-radius: 5px;
}
.rounded-\\[8px\\]{
  border-radius: 8px;
}
.rounded-box{
  border-radius: var(--rounded-box, 1rem);
}
.rounded-full{
  border-radius: 9999px;
}
.rounded-lg{
  border-radius: 0.5rem;
}
.rounded-md{
  border-radius: 0.375rem;
}
.rounded-sm{
  border-radius: 0.125rem;
}
.rounded-xl{
  border-radius: 0.75rem;
}
.rounded-b{
  border-bottom-right-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.rounded-b-\\[10px\\]{
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
}
.rounded-b-lg{
  border-bottom-right-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
.rounded-l-md{
  border-top-left-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}
.rounded-r-\\[10px\\]{
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}
.rounded-r-lg{
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}
.rounded-r-md{
  border-top-right-radius: 0.375rem;
  border-bottom-right-radius: 0.375rem;
}
.rounded-t-\\[10px\\]{
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.rounded-t-\\[50px\\]{
  border-top-left-radius: 50px;
  border-top-right-radius: 50px;
}
.rounded-t-lg{
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}
.\\!border{
  border-width: 1px !important;
}
.\\!border-\\[1px\\]{
  border-width: 1px !important;
}
.border{
  border-width: 1px;
}
.border-0{
  border-width: 0px;
}
.border-2{
  border-width: 2px;
}
.border-4{
  border-width: 4px;
}
.border-\\[1px\\]{
  border-width: 1px;
}
.border-\\[2px\\]{
  border-width: 2px;
}
.border-\\[3px\\]{
  border-width: 3px;
}
.border-b{
  border-bottom-width: 1px;
}
.border-b-2{
  border-bottom-width: 2px;
}
.border-b-\\[1px\\]{
  border-bottom-width: 1px;
}
.border-b-\\[2px\\]{
  border-bottom-width: 2px;
}
.border-l-4{
  border-left-width: 4px;
}
.border-r{
  border-right-width: 1px;
}
.border-t{
  border-top-width: 1px;
}
.border-t-2{
  border-top-width: 2px;
}
.border-solid{
  border-style: solid;
}
.border-dashed{
  border-style: dashed;
}
.border-none{
  border-style: none;
}
.\\!border-\\[\\#000000\\]{
  --tw-border-opacity: 1 !important;
  border-color: rgb(0 0 0 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-\\[\\#0072BB\\]{
  --tw-border-opacity: 1 !important;
  border-color: rgb(0 114 187 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-\\[\\#0077BB\\]{
  --tw-border-opacity: 1 !important;
  border-color: rgb(0 119 187 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-\\[\\#e5f1f8\\]{
  --tw-border-opacity: 1 !important;
  border-color: rgb(229 241 248 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-black{
  --tw-border-opacity: 1 !important;
  border-color: rgb(0 0 0 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-white{
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1)) !important;
}
.border-\\[\\#000000\\]{
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity, 1));
}
.border-\\[\\#0072BB26\\]{
  border-color: #0072BB26;
}
.border-\\[\\#0072BB\\]{
  --tw-border-opacity: 1;
  border-color: rgb(0 114 187 / var(--tw-border-opacity, 1));
}
.border-\\[\\#0072bb\\]{
  --tw-border-opacity: 1;
  border-color: rgb(0 114 187 / var(--tw-border-opacity, 1));
}
.border-\\[\\#0077BB\\]{
  --tw-border-opacity: 1;
  border-color: rgb(0 119 187 / var(--tw-border-opacity, 1));
}
.border-\\[\\#0081c8\\]{
  --tw-border-opacity: 1;
  border-color: rgb(0 129 200 / var(--tw-border-opacity, 1));
}
.border-\\[\\#212121\\]{
  --tw-border-opacity: 1;
  border-color: rgb(33 33 33 / var(--tw-border-opacity, 1));
}
.border-\\[\\#CCCCCC\\]{
  --tw-border-opacity: 1;
  border-color: rgb(204 204 204 / var(--tw-border-opacity, 1));
}
.border-\\[\\#D3D3D3\\]{
  --tw-border-opacity: 1;
  border-color: rgb(211 211 211 / var(--tw-border-opacity, 1));
}
.border-\\[\\#ccc\\]{
  --tw-border-opacity: 1;
  border-color: rgb(204 204 204 / var(--tw-border-opacity, 1));
}
.border-\\[\\#e5f1f8\\]{
  --tw-border-opacity: 1;
  border-color: rgb(229 241 248 / var(--tw-border-opacity, 1));
}
.border-\\[black\\]{
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity, 1));
}
.border-\\[rgba\\(204\\2c 204\\2c 204\\2c 1\\)\\]{
  border-color: rgba(204,204,204,1);
}
.border-amber-200{
  --tw-border-opacity: 1;
  border-color: rgb(253 230 138 / var(--tw-border-opacity, 1));
}
.border-black{
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity, 1));
}
.border-blue-100{
  --tw-border-opacity: 1;
  border-color: rgb(219 234 254 / var(--tw-border-opacity, 1));
}
.border-blue-200{
  --tw-border-opacity: 1;
  border-color: rgb(191 219 254 / var(--tw-border-opacity, 1));
}
.border-blue-500{
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}
.border-blue-600{
  --tw-border-opacity: 1;
  border-color: rgb(37 99 235 / var(--tw-border-opacity, 1));
}
.border-current{
  border-color: currentColor;
}
.border-emerald-200{
  --tw-border-opacity: 1;
  border-color: rgb(167 243 208 / var(--tw-border-opacity, 1));
}
.border-gray-100{
  --tw-border-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-border-opacity, 1));
}
.border-gray-200{
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}
.border-gray-300{
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}
.border-gray-400{
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / var(--tw-border-opacity, 1));
}
.border-gray-500{
  --tw-border-opacity: 1;
  border-color: rgb(107 114 128 / var(--tw-border-opacity, 1));
}
.border-gray-600{
  --tw-border-opacity: 1;
  border-color: rgb(75 85 99 / var(--tw-border-opacity, 1));
}
.border-gray-800{
  --tw-border-opacity: 1;
  border-color: rgb(31 41 55 / var(--tw-border-opacity, 1));
}
.border-green-100{
  --tw-border-opacity: 1;
  border-color: rgb(220 252 231 / var(--tw-border-opacity, 1));
}
.border-green-200{
  --tw-border-opacity: 1;
  border-color: rgb(187 247 208 / var(--tw-border-opacity, 1));
}
.border-green-400{
  --tw-border-opacity: 1;
  border-color: rgb(74 222 128 / var(--tw-border-opacity, 1));
}
.border-green-500{
  --tw-border-opacity: 1;
  border-color: rgb(34 197 94 / var(--tw-border-opacity, 1));
}
.border-indigo-500{
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / var(--tw-border-opacity, 1));
}
.border-orange-400{
  --tw-border-opacity: 1;
  border-color: rgb(251 146 60 / var(--tw-border-opacity, 1));
}
.border-purple-200{
  --tw-border-opacity: 1;
  border-color: rgb(233 213 255 / var(--tw-border-opacity, 1));
}
.border-red-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity, 1));
}
.border-red-300{
  --tw-border-opacity: 1;
  border-color: rgb(252 165 165 / var(--tw-border-opacity, 1));
}
.border-red-400{
  --tw-border-opacity: 1;
  border-color: rgb(248 113 113 / var(--tw-border-opacity, 1));
}
.border-red-500{
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}
.border-red-600{
  --tw-border-opacity: 1;
  border-color: rgb(220 38 38 / var(--tw-border-opacity, 1));
}
.border-transparent{
  border-color: transparent;
}
.border-white{
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-yellow-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 240 138 / var(--tw-border-opacity, 1));
}
.border-yellow-400{
  --tw-border-opacity: 1;
  border-color: rgb(250 204 21 / var(--tw-border-opacity, 1));
}
.border-b-\\[\\#CCCCCC\\]{
  --tw-border-opacity: 1;
  border-bottom-color: rgb(204 204 204 / var(--tw-border-opacity, 1));
}
.border-b-\\[\\#cccccc\\]{
  --tw-border-opacity: 1;
  border-bottom-color: rgb(204 204 204 / var(--tw-border-opacity, 1));
}
.border-b-black{
  --tw-border-opacity: 1;
  border-bottom-color: rgb(0 0 0 / var(--tw-border-opacity, 1));
}
.border-b-transparent{
  border-bottom-color: transparent;
}
.border-l-blue-500{
  --tw-border-opacity: 1;
  border-left-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}
.border-l-transparent{
  border-left-color: transparent;
}
.border-r-transparent{
  border-right-color: transparent;
}
.border-t-\\[\\#CCCCCC\\]{
  --tw-border-opacity: 1;
  border-top-color: rgb(204 204 204 / var(--tw-border-opacity, 1));
}
.border-t-black{
  --tw-border-opacity: 1;
  border-top-color: rgb(0 0 0 / var(--tw-border-opacity, 1));
}
.border-t-blue-500{
  --tw-border-opacity: 1;
  border-top-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}
.border-t-blue-600{
  --tw-border-opacity: 1;
  border-top-color: rgb(37 99 235 / var(--tw-border-opacity, 1));
}
.border-t-transparent{
  border-top-color: transparent;
}
.\\!bg-black{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-green-700{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(21 128 61 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-orange-400{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(251 146 60 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-red-400{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(248 113 113 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#00000000\\]{
  background-color: #00000000;
}
.bg-\\[\\#00000065\\]{
  background-color: #00000065;
}
.bg-\\[\\#000000B2\\]{
  background-color: #000000B2;
}
.bg-\\[\\#0072BB1A\\]{
  background-color: #0072BB1A;
}
.bg-\\[\\#0072BB26\\]{
  background-color: #0072BB26;
}
.bg-\\[\\#0072BB\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(0 114 187 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0072bb\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(0 114 187 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0072ca\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(0 114 202 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0073bb6c\\]{
  background-color: #0073bb6c;
}
.bg-\\[\\#0081c8\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(0 129 200 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1c2434\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(28 36 52 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#36454F\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(54 69 79 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#365CCE\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(54 92 206 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#375cce\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(55 92 206 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#4371e5\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(67 113 229 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F9F5FF\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(249 245 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FAFAFAFA\\]{
  background-color: #FAFAFAFA;
}
.bg-\\[\\#FAFAFA\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FFFFFF\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#e5f1f8\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(229 241 248 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f1f5f9\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#fff\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#ffffff\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[gray\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(128 128 128 / var(--tw-bg-opacity, 1));
}
.bg-\\[green\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(0 128 0 / var(--tw-bg-opacity, 1));
}
.bg-\\[red\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 0 0 / var(--tw-bg-opacity, 1));
}
.bg-\\[white\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-amber-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity, 1));
}
.bg-amber-50{
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1));
}
.bg-base-200{
  --tw-bg-opacity: 1;
  background-color: var(--fallback-b2,oklch(var(--b2)/var(--tw-bg-opacity, 1)));
}
.bg-black{
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-black\\/50{
  background-color: rgb(0 0 0 / 0.5);
}
.bg-black\\/75{
  background-color: rgb(0 0 0 / 0.75);
}
.bg-blue-100{
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}
.bg-blue-200{
  --tw-bg-opacity: 1;
  background-color: rgb(191 219 254 / var(--tw-bg-opacity, 1));
}
.bg-blue-300{
  --tw-bg-opacity: 1;
  background-color: rgb(147 197 253 / var(--tw-bg-opacity, 1));
}
.bg-blue-400{
  --tw-bg-opacity: 1;
  background-color: rgb(96 165 250 / var(--tw-bg-opacity, 1));
}
.bg-blue-50{
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}
.bg-blue-500{
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}
.bg-blue-600{
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
.bg-blue-700{
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
}
.bg-current{
  background-color: currentColor;
}
.bg-emerald-100{
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity, 1));
}
.bg-gray-100{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.bg-gray-200{
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
.bg-gray-300{
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
}
.bg-gray-400{
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity, 1));
}
.bg-gray-50{
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
.bg-gray-500{
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity, 1));
}
.bg-gray-600{
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}
.bg-gray-800{
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}
.bg-gray-900{
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity, 1));
}
.bg-green-100{
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1));
}
.bg-green-200{
  --tw-bg-opacity: 1;
  background-color: rgb(187 247 208 / var(--tw-bg-opacity, 1));
}
.bg-green-300{
  --tw-bg-opacity: 1;
  background-color: rgb(134 239 172 / var(--tw-bg-opacity, 1));
}
.bg-green-400{
  --tw-bg-opacity: 1;
  background-color: rgb(74 222 128 / var(--tw-bg-opacity, 1));
}
.bg-green-50{
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity, 1));
}
.bg-green-500{
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1));
}
.bg-green-600{
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity, 1));
}
.bg-indigo-600{
  --tw-bg-opacity: 1;
  background-color: rgb(79 70 229 / var(--tw-bg-opacity, 1));
}
.bg-orange-100{
  --tw-bg-opacity: 1;
  background-color: rgb(255 237 213 / var(--tw-bg-opacity, 1));
}
.bg-orange-200{
  --tw-bg-opacity: 1;
  background-color: rgb(254 215 170 / var(--tw-bg-opacity, 1));
}
.bg-orange-300{
  --tw-bg-opacity: 1;
  background-color: rgb(253 186 116 / var(--tw-bg-opacity, 1));
}
.bg-orange-400{
  --tw-bg-opacity: 1;
  background-color: rgb(251 146 60 / var(--tw-bg-opacity, 1));
}
.bg-orange-50{
  --tw-bg-opacity: 1;
  background-color: rgb(255 247 237 / var(--tw-bg-opacity, 1));
}
.bg-orange-500{
  --tw-bg-opacity: 1;
  background-color: rgb(249 115 22 / var(--tw-bg-opacity, 1));
}
.bg-orange-600{
  --tw-bg-opacity: 1;
  background-color: rgb(234 88 12 / var(--tw-bg-opacity, 1));
}
.bg-purple-100{
  --tw-bg-opacity: 1;
  background-color: rgb(243 232 255 / var(--tw-bg-opacity, 1));
}
.bg-purple-50{
  --tw-bg-opacity: 1;
  background-color: rgb(250 245 255 / var(--tw-bg-opacity, 1));
}
.bg-purple-500{
  --tw-bg-opacity: 1;
  background-color: rgb(168 85 247 / var(--tw-bg-opacity, 1));
}
.bg-purple-600{
  --tw-bg-opacity: 1;
  background-color: rgb(147 51 234 / var(--tw-bg-opacity, 1));
}
.bg-red-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}
.bg-red-200{
  --tw-bg-opacity: 1;
  background-color: rgb(254 202 202 / var(--tw-bg-opacity, 1));
}
.bg-red-300{
  --tw-bg-opacity: 1;
  background-color: rgb(252 165 165 / var(--tw-bg-opacity, 1));
}
.bg-red-400{
  --tw-bg-opacity: 1;
  background-color: rgb(248 113 113 / var(--tw-bg-opacity, 1));
}
.bg-red-50{
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
.bg-red-500{
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
.bg-red-600{
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}
.bg-slate-100{
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}
.bg-slate-200{
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1));
}
.bg-slate-300{
  --tw-bg-opacity: 1;
  background-color: rgb(203 213 225 / var(--tw-bg-opacity, 1));
}
.bg-slate-50{
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}
.bg-teal-100{
  --tw-bg-opacity: 1;
  background-color: rgb(204 251 241 / var(--tw-bg-opacity, 1));
}
.bg-transparent{
  background-color: transparent;
}
.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-yellow-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 249 195 / var(--tw-bg-opacity, 1));
}
.bg-yellow-400{
  --tw-bg-opacity: 1;
  background-color: rgb(250 204 21 / var(--tw-bg-opacity, 1));
}
.bg-yellow-50{
  --tw-bg-opacity: 1;
  background-color: rgb(254 252 232 / var(--tw-bg-opacity, 1));
}
.bg-yellow-500{
  --tw-bg-opacity: 1;
  background-color: rgb(234 179 8 / var(--tw-bg-opacity, 1));
}
.bg-opacity-0{
  --tw-bg-opacity: 0;
}
.bg-opacity-20{
  --tw-bg-opacity: 0.2;
}
.bg-opacity-30{
  --tw-bg-opacity: 0.3;
}
.bg-opacity-50{
  --tw-bg-opacity: 0.5;
}
.bg-opacity-70{
  --tw-bg-opacity: 0.7;
}
.bg-opacity-75{
  --tw-bg-opacity: 0.75;
}
.bg-opacity-80{
  --tw-bg-opacity: 0.8;
}
.bg-opacity-85{
  --tw-bg-opacity: 0.85;
}
.bg-opacity-90{
  --tw-bg-opacity: 0.9;
}
.bg-opacity-95{
  --tw-bg-opacity: 0.95;
}
.bg-gradient-to-br{
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.bg-gradient-to-r{
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.from-blue-50{
  --tw-gradient-from: #eff6ff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(239 246 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-500{
  --tw-gradient-from: #3b82f6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(59 130 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-600{
  --tw-gradient-from: #2563eb var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(37 99 235 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-green-50{
  --tw-gradient-from: #f0fdf4 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(240 253 244 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-green-600{
  --tw-gradient-from: #16a34a var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(22 163 74 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-50{
  --tw-gradient-from: #eef2ff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(238 242 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-500{
  --tw-gradient-from: #6366f1 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(99 102 241 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-50{
  --tw-gradient-from: #faf5ff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(250 245 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-500{
  --tw-gradient-from: #a855f7 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(168 85 247 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-600{
  --tw-gradient-from: #9333ea var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(147 51 234 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-50{
  --tw-gradient-from: #f8fafc var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(248 250 252 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-10\\%{
  --tw-gradient-from-position: 10%;
}
.via-blue-700{
  --tw-gradient-to: rgb(29 78 216 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #1d4ed8 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-purple-500{
  --tw-gradient-to: rgb(168 85 247 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #a855f7 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-sky-50{
  --tw-gradient-to: rgb(240 249 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #f0f9ff var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-white{
  --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #fff var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-30\\%{
  --tw-gradient-via-position: 30%;
}
.to-blue-100{
  --tw-gradient-to: #dbeafe var(--tw-gradient-to-position);
}
.to-blue-600{
  --tw-gradient-to: #2563eb var(--tw-gradient-to-position);
}
.to-blue-700{
  --tw-gradient-to: #1d4ed8 var(--tw-gradient-to-position);
}
.to-cyan-500{
  --tw-gradient-to: #06b6d4 var(--tw-gradient-to-position);
}
.to-emerald-100{
  --tw-gradient-to: #d1fae5 var(--tw-gradient-to-position);
}
.to-emerald-50{
  --tw-gradient-to: #ecfdf5 var(--tw-gradient-to-position);
}
.to-indigo-100{
  --tw-gradient-to: #e0e7ff var(--tw-gradient-to-position);
}
.to-indigo-600{
  --tw-gradient-to: #4f46e5 var(--tw-gradient-to-position);
}
.to-indigo-800{
  --tw-gradient-to: #3730a3 var(--tw-gradient-to-position);
}
.to-pink-500{
  --tw-gradient-to: #ec4899 var(--tw-gradient-to-position);
}
.to-pink-600{
  --tw-gradient-to: #db2777 var(--tw-gradient-to-position);
}
.to-slate-100{
  --tw-gradient-to: #f1f5f9 var(--tw-gradient-to-position);
}
.to-10\\%{
  --tw-gradient-to-position: 10%;
}
.bg-cover{
  background-size: cover;
}
.bg-center{
  background-position: center;
}
.bg-no-repeat{
  background-repeat: no-repeat;
}
.fill-blue-400{
  fill: #60a5fa;
}
.fill-blue-600{
  fill: #2563eb;
}
.fill-current{
  fill: currentColor;
}
.object-contain{
  object-fit: contain;
}
.object-cover{
  object-fit: cover;
}
.object-center{
  object-position: center;
}
.\\!p-0{
  padding: 0px !important;
}
.\\!p-3{
  padding: 0.75rem !important;
}
.p-0\\.5{
  padding: 0.125rem;
}
.p-1{
  padding: 0.25rem;
}
.p-1\\.5{
  padding: 0.375rem;
}
.p-10{
  padding: 2.5rem;
}
.p-12{
  padding: 3rem;
}
.p-2{
  padding: 0.5rem;
}
.p-2\\.5{
  padding: 0.625rem;
}
.p-3{
  padding: 0.75rem;
}
.p-4{
  padding: 1rem;
}
.p-5{
  padding: 1.25rem;
}
.p-6{
  padding: 1.5rem;
}
.p-8{
  padding: 2rem;
}
.p-\\[10px\\]{
  padding: 10px;
}
.p-\\[13px\\]{
  padding: 13px;
}
.p-\\[15px\\]{
  padding: 15px;
}
.p-\\[1rem\\]{
  padding: 1rem;
}
.p-\\[20px\\]{
  padding: 20px;
}
.p-\\[22px\\]{
  padding: 22px;
}
.p-\\[2px\\]{
  padding: 2px;
}
.p-\\[30px\\]{
  padding: 30px;
}
.p-\\[3px_15px\\]{
  padding: 3px 15px;
}
.p-\\[4px\\]{
  padding: 4px;
}
.p-\\[5px_10px\\]{
  padding: 5px 10px;
}
.\\!px-2{
  padding-left: 0.5rem !important;
  padding-right: 0.5rem !important;
}
.\\!px-3{
  padding-left: 0.75rem !important;
  padding-right: 0.75rem !important;
}
.px-0{
  padding-left: 0px;
  padding-right: 0px;
}
.px-1{
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-10{
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.px-2{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5{
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-20{
  padding-left: 5rem;
  padding-right: 5rem;
}
.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5{
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-7{
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}
.px-8{
  padding-left: 2rem;
  padding-right: 2rem;
}
.px-\\[100px\\]{
  padding-left: 100px;
  padding-right: 100px;
}
.px-\\[10px\\]{
  padding-left: 10px;
  padding-right: 10px;
}
.px-\\[12px\\]{
  padding-left: 12px;
  padding-right: 12px;
}
.px-\\[15px\\]{
  padding-left: 15px;
  padding-right: 15px;
}
.px-\\[18px\\]{
  padding-left: 18px;
  padding-right: 18px;
}
.px-\\[20px\\]{
  padding-left: 20px;
  padding-right: 20px;
}
.px-\\[4px\\]{
  padding-left: 4px;
  padding-right: 4px;
}
.px-\\[8px\\]{
  padding-left: 8px;
  padding-right: 8px;
}
.py-0\\.5{
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-10{
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-12{
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-16{
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5{
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-20{
  padding-top: 5rem;
  padding-bottom: 5rem;
}
.py-3{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4{
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5{
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6{
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-7{
  padding-top: 1.75rem;
  padding-bottom: 1.75rem;
}
.py-8{
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.py-\\[100px\\]{
  padding-top: 100px;
  padding-bottom: 100px;
}
.py-\\[10px\\]{
  padding-top: 10px;
  padding-bottom: 10px;
}
.py-\\[11\\.5px\\]{
  padding-top: 11.5px;
  padding-bottom: 11.5px;
}
.py-\\[11px\\]{
  padding-top: 11px;
  padding-bottom: 11px;
}
.py-\\[12px\\]{
  padding-top: 12px;
  padding-bottom: 12px;
}
.py-\\[13px\\]{
  padding-top: 13px;
  padding-bottom: 13px;
}
.py-\\[14px\\]{
  padding-top: 14px;
  padding-bottom: 14px;
}
.py-\\[20px\\]{
  padding-top: 20px;
  padding-bottom: 20px;
}
.py-\\[25px\\]{
  padding-top: 25px;
  padding-bottom: 25px;
}
.py-\\[30px\\]{
  padding-top: 30px;
  padding-bottom: 30px;
}
.py-\\[33px\\]{
  padding-top: 33px;
  padding-bottom: 33px;
}
.py-\\[45px\\]{
  padding-top: 45px;
  padding-bottom: 45px;
}
.py-\\[50px\\]{
  padding-top: 50px;
  padding-bottom: 50px;
}
.py-\\[5px\\]{
  padding-top: 5px;
  padding-bottom: 5px;
}
.py-\\[6px\\]{
  padding-top: 6px;
  padding-bottom: 6px;
}
.py-\\[8px\\]{
  padding-top: 8px;
  padding-bottom: 8px;
}
.py-\\[90px\\]{
  padding-top: 90px;
  padding-bottom: 90px;
}
.py-\\[9px\\]{
  padding-top: 9px;
  padding-bottom: 9px;
}
.\\!pl-2{
  padding-left: 0.5rem !important;
}
.\\!pl-3{
  padding-left: 0.75rem !important;
}
.\\!pl-4{
  padding-left: 1rem !important;
}
.pb-10{
  padding-bottom: 2.5rem;
}
.pb-12{
  padding-bottom: 3rem;
}
.pb-2{
  padding-bottom: 0.5rem;
}
.pb-20{
  padding-bottom: 5rem;
}
.pb-3{
  padding-bottom: 0.75rem;
}
.pb-4{
  padding-bottom: 1rem;
}
.pb-5{
  padding-bottom: 1.25rem;
}
.pb-6{
  padding-bottom: 1.5rem;
}
.pb-\\[100px\\]{
  padding-bottom: 100px;
}
.pb-\\[20px\\]{
  padding-bottom: 20px;
}
.pb-\\[25px\\]{
  padding-bottom: 25px;
}
.pb-\\[30px\\]{
  padding-bottom: 30px;
}
.pb-\\[36\\.72px\\]{
  padding-bottom: 36.72px;
}
.pb-\\[50px\\]{
  padding-bottom: 50px;
}
.pb-\\[60px\\]{
  padding-bottom: 60px;
}
.pl-10{
  padding-left: 2.5rem;
}
.pl-11{
  padding-left: 2.75rem;
}
.pl-12{
  padding-left: 3rem;
}
.pl-3{
  padding-left: 0.75rem;
}
.pl-4{
  padding-left: 1rem;
}
.pl-5{
  padding-left: 1.25rem;
}
.pl-6{
  padding-left: 1.5rem;
}
.pl-8{
  padding-left: 2rem;
}
.pl-\\[20px\\]{
  padding-left: 20px;
}
.pl-\\[40px\\]{
  padding-left: 40px;
}
.pr-10{
  padding-right: 2.5rem;
}
.pr-12{
  padding-right: 3rem;
}
.pr-2{
  padding-right: 0.5rem;
}
.pr-3{
  padding-right: 0.75rem;
}
.pr-4{
  padding-right: 1rem;
}
.pr-8{
  padding-right: 2rem;
}
.pr-\\[50px\\]{
  padding-right: 50px;
}
.ps-10{
  padding-inline-start: 2.5rem;
}
.ps-3{
  padding-inline-start: 0.75rem;
}
.pt-1{
  padding-top: 0.25rem;
}
.pt-2{
  padding-top: 0.5rem;
}
.pt-20{
  padding-top: 5rem;
}
.pt-3{
  padding-top: 0.75rem;
}
.pt-4{
  padding-top: 1rem;
}
.pt-5{
  padding-top: 1.25rem;
}
.pt-6{
  padding-top: 1.5rem;
}
.pt-8{
  padding-top: 2rem;
}
.pt-\\[100px\\]{
  padding-top: 100px;
}
.pt-\\[10px\\]{
  padding-top: 10px;
}
.pt-\\[30px\\]{
  padding-top: 30px;
}
.pt-\\[44px\\]{
  padding-top: 44px;
}
.pt-\\[80px\\]{
  padding-top: 80px;
}
.text-left{
  text-align: left;
}
.text-center{
  text-align: center;
}
.text-right{
  text-align: right;
}
.text-start{
  text-align: start;
}
.text-end{
  text-align: end;
}
.align-middle{
  vertical-align: middle;
}
.align-bottom{
  vertical-align: bottom;
}
.font-mono{
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.font-sans{
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}
.\\!text-2xl{
  font-size: 1.5rem !important;
  line-height: 2rem !important;
}
.\\!text-\\[14px\\]{
  font-size: 14px !important;
}
.\\!text-\\[18px\\]{
  font-size: 18px !important;
}
.\\!text-\\[20px\\]{
  font-size: 20px !important;
}
.\\!text-sm{
  font-size: 0.875rem !important;
  line-height: 1.25rem !important;
}
.\\!text-xs{
  font-size: 0.75rem !important;
  line-height: 1rem !important;
}
.text-2xl{
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl{
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl{
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-\\[1\\.875rem\\]{
  font-size: 1.875rem;
}
.text-\\[10px\\]{
  font-size: 10px;
}
.text-\\[11px\\]{
  font-size: 11px;
}
.text-\\[12px\\]{
  font-size: 12px;
}
.text-\\[13px\\]{
  font-size: 13px;
}
.text-\\[14px\\]{
  font-size: 14px;
}
.text-\\[16px\\]{
  font-size: 16px;
}
.text-\\[18px\\]{
  font-size: 18px;
}
.text-\\[20px\\]{
  font-size: 20px;
}
.text-\\[22px\\]{
  font-size: 22px;
}
.text-\\[25px\\]{
  font-size: 25px;
}
.text-\\[26px\\]{
  font-size: 26px;
}
.text-\\[30px\\]{
  font-size: 30px;
}
.text-\\[40px\\]{
  font-size: 40px;
}
.text-base{
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg{
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl{
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs{
  font-size: 0.75rem;
  line-height: 1rem;
}
.\\!font-\\[600\\]{
  font-weight: 600 !important;
}
.\\!font-bold{
  font-weight: 700 !important;
}
.\\!font-semibold{
  font-weight: 600 !important;
}
.font-\\[300\\]{
  font-weight: 300;
}
.font-\\[400\\]{
  font-weight: 400;
}
.font-\\[500\\]{
  font-weight: 500;
}
.font-\\[600\\]{
  font-weight: 600;
}
.font-\\[700\\]{
  font-weight: 700;
}
.font-\\[800\\]{
  font-weight: 800;
}
.font-bold{
  font-weight: 700;
}
.font-light{
  font-weight: 300;
}
.font-medium{
  font-weight: 500;
}
.font-normal{
  font-weight: 400;
}
.font-semibold{
  font-weight: 600;
}
.uppercase{
  text-transform: uppercase;
}
.lowercase{
  text-transform: lowercase;
}
.capitalize{
  text-transform: capitalize;
}
.normal-case{
  text-transform: none;
}
.italic{
  font-style: italic;
}
.not-italic{
  font-style: normal;
}
.leading-4{
  line-height: 1rem;
}
.leading-5{
  line-height: 1.25rem;
}
.leading-6{
  line-height: 1.5rem;
}
.leading-7{
  line-height: 1.75rem;
}
.leading-\\[28px\\]{
  line-height: 28px;
}
.leading-\\[normal\\]{
  line-height: normal;
}
.leading-none{
  line-height: 1;
}
.leading-relaxed{
  line-height: 1.625;
}
.leading-tight{
  line-height: 1.25;
}
.tracking-tight{
  letter-spacing: -0.025em;
}
.tracking-wide{
  letter-spacing: 0.025em;
}
.tracking-wider{
  letter-spacing: 0.05em;
}
.tracking-widest{
  letter-spacing: 0.1em;
}
.\\!text-\\[\\#0072BB\\]{
  --tw-text-opacity: 1 !important;
  color: rgb(0 114 187 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-\\[\\#0081c8\\]{
  --tw-text-opacity: 1 !important;
  color: rgb(0 129 200 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-white{
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#000000\\]{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.text-\\[\\#0072BB\\]{
  --tw-text-opacity: 1;
  color: rgb(0 114 187 / var(--tw-text-opacity, 1));
}
.text-\\[\\#0081c8\\]{
  --tw-text-opacity: 1;
  color: rgb(0 129 200 / var(--tw-text-opacity, 1));
}
.text-\\[\\#0c4a72\\]{
  --tw-text-opacity: 1;
  color: rgb(12 74 114 / var(--tw-text-opacity, 1));
}
.text-\\[\\#101828\\]{
  --tw-text-opacity: 1;
  color: rgb(16 24 40 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1f77b4\\]{
  --tw-text-opacity: 1;
  color: rgb(31 119 180 / var(--tw-text-opacity, 1));
}
.text-\\[\\#212121\\]{
  --tw-text-opacity: 1;
  color: rgb(33 33 33 / var(--tw-text-opacity, 1));
}
.text-\\[\\#2ca02c\\]{
  --tw-text-opacity: 1;
  color: rgb(44 160 44 / var(--tw-text-opacity, 1));
}
.text-\\[\\#365CCE\\]{
  --tw-text-opacity: 1;
  color: rgb(54 92 206 / var(--tw-text-opacity, 1));
}
.text-\\[\\#458ad4\\]{
  --tw-text-opacity: 1;
  color: rgb(69 138 212 / var(--tw-text-opacity, 1));
}
.text-\\[\\#475467\\]{
  --tw-text-opacity: 1;
  color: rgb(71 84 103 / var(--tw-text-opacity, 1));
}
.text-\\[\\#626262\\]{
  --tw-text-opacity: 1;
  color: rgb(98 98 98 / var(--tw-text-opacity, 1));
}
.text-\\[\\#777777\\]{
  --tw-text-opacity: 1;
  color: rgb(119 119 119 / var(--tw-text-opacity, 1));
}
.text-\\[\\#777\\]{
  --tw-text-opacity: 1;
  color: rgb(119 119 119 / var(--tw-text-opacity, 1));
}
.text-\\[\\#888888\\]{
  --tw-text-opacity: 1;
  color: rgb(136 136 136 / var(--tw-text-opacity, 1));
}
.text-\\[\\#FFFFFF\\]{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-\\[\\#d62728\\]{
  --tw-text-opacity: 1;
  color: rgb(214 39 40 / var(--tw-text-opacity, 1));
}
.text-\\[\\#ff7f0e\\]{
  --tw-text-opacity: 1;
  color: rgb(255 127 14 / var(--tw-text-opacity, 1));
}
.text-\\[\\#fff\\]{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-\\[black\\]{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.text-\\[cap\\]{
  color: cap;
}
.text-\\[gray\\]{
  --tw-text-opacity: 1;
  color: rgb(128 128 128 / var(--tw-text-opacity, 1));
}
.text-\\[green\\]{
  --tw-text-opacity: 1;
  color: rgb(0 128 0 / var(--tw-text-opacity, 1));
}
.text-\\[red\\]{
  --tw-text-opacity: 1;
  color: rgb(255 0 0 / var(--tw-text-opacity, 1));
}
.text-\\[white\\]{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-amber-500{
  --tw-text-opacity: 1;
  color: rgb(245 158 11 / var(--tw-text-opacity, 1));
}
.text-amber-600{
  --tw-text-opacity: 1;
  color: rgb(217 119 6 / var(--tw-text-opacity, 1));
}
.text-black{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.text-blue-500{
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity, 1));
}
.text-blue-600{
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.text-blue-700{
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}
.text-blue-800{
  --tw-text-opacity: 1;
  color: rgb(30 64 175 / var(--tw-text-opacity, 1));
}
.text-emerald-800{
  --tw-text-opacity: 1;
  color: rgb(6 95 70 / var(--tw-text-opacity, 1));
}
.text-gray-100{
  --tw-text-opacity: 1;
  color: rgb(243 244 246 / var(--tw-text-opacity, 1));
}
.text-gray-200{
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity, 1));
}
.text-gray-300{
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}
.text-gray-400{
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.text-gray-500{
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-gray-600{
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.text-gray-700{
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.text-gray-800{
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}
.text-gray-900{
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}
.text-green-500{
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity, 1));
}
.text-green-600{
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity, 1));
}
.text-green-700{
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity, 1));
}
.text-green-800{
  --tw-text-opacity: 1;
  color: rgb(22 101 52 / var(--tw-text-opacity, 1));
}
.text-orange-400{
  --tw-text-opacity: 1;
  color: rgb(251 146 60 / var(--tw-text-opacity, 1));
}
.text-orange-500{
  --tw-text-opacity: 1;
  color: rgb(249 115 22 / var(--tw-text-opacity, 1));
}
.text-orange-600{
  --tw-text-opacity: 1;
  color: rgb(234 88 12 / var(--tw-text-opacity, 1));
}
.text-orange-800{
  --tw-text-opacity: 1;
  color: rgb(154 52 18 / var(--tw-text-opacity, 1));
}
.text-purple-500{
  --tw-text-opacity: 1;
  color: rgb(168 85 247 / var(--tw-text-opacity, 1));
}
.text-purple-600{
  --tw-text-opacity: 1;
  color: rgb(147 51 234 / var(--tw-text-opacity, 1));
}
.text-purple-700{
  --tw-text-opacity: 1;
  color: rgb(126 34 206 / var(--tw-text-opacity, 1));
}
.text-purple-800{
  --tw-text-opacity: 1;
  color: rgb(107 33 168 / var(--tw-text-opacity, 1));
}
.text-red-400{
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}
.text-red-500{
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.text-red-600{
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.text-red-700{
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.text-red-800{
  --tw-text-opacity: 1;
  color: rgb(153 27 27 / var(--tw-text-opacity, 1));
}
.text-teal-500{
  --tw-text-opacity: 1;
  color: rgb(20 184 166 / var(--tw-text-opacity, 1));
}
.text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-yellow-400{
  --tw-text-opacity: 1;
  color: rgb(250 204 21 / var(--tw-text-opacity, 1));
}
.text-yellow-500{
  --tw-text-opacity: 1;
  color: rgb(234 179 8 / var(--tw-text-opacity, 1));
}
.text-yellow-600{
  --tw-text-opacity: 1;
  color: rgb(202 138 4 / var(--tw-text-opacity, 1));
}
.text-yellow-700{
  --tw-text-opacity: 1;
  color: rgb(161 98 7 / var(--tw-text-opacity, 1));
}
.text-yellow-800{
  --tw-text-opacity: 1;
  color: rgb(133 77 14 / var(--tw-text-opacity, 1));
}
.underline{
  text-decoration-line: underline;
}
.placeholder-gray-400::placeholder{
  --tw-placeholder-opacity: 1;
  color: rgb(156 163 175 / var(--tw-placeholder-opacity, 1));
}
.placeholder-gray-500::placeholder{
  --tw-placeholder-opacity: 1;
  color: rgb(107 114 128 / var(--tw-placeholder-opacity, 1));
}
.opacity-0{
  opacity: 0;
}
.opacity-100{
  opacity: 1;
}
.opacity-25{
  opacity: 0.25;
}
.opacity-50{
  opacity: 0.5;
}
.opacity-70{
  opacity: 0.7;
}
.opacity-75{
  opacity: 0.75;
}
.shadow{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-2xl{
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_2px_1px_0px_\\#00000040\\]{
  --tw-shadow: 0px 2px 1px 0px #00000040;
  --tw-shadow-colored: 0px 2px 1px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_2px_4px_0px_\\#0000001A\\]{
  --tw-shadow: 0px 2px 4px 0px #0000001A;
  --tw-shadow-colored: 0px 2px 4px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-inner{
  --tw-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: inset 0 2px 4px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl{
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-gray-900\\/10{
  --tw-shadow-color: rgb(17 24 39 / 0.1);
  --tw-shadow: var(--tw-shadow-colored);
}
.\\!outline-none{
  outline: 2px solid transparent !important;
  outline-offset: 2px !important;
}
.outline-none{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline{
  outline-style: solid;
}
.ring{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-1{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-inset{
  --tw-ring-inset: inset;
}
.ring-black{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(0 0 0 / var(--tw-ring-opacity, 1));
}
.ring-gray-300{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(209 213 219 / var(--tw-ring-opacity, 1));
}
.ring-opacity-5{
  --tw-ring-opacity: 0.05;
}
.drop-shadow-2xl{
  --tw-drop-shadow: drop-shadow(0 25px 25px rgb(0 0 0 / 0.15));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur-sm{
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity{
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-shadow{
  transition-property: box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform{
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.delay-100{
  transition-delay: 100ms;
}
.delay-150{
  transition-delay: 150ms;
}
.delay-\\[300ms\\]{
  transition-delay: 300ms;
}
.duration-100{
  transition-duration: 100ms;
}
.duration-150{
  transition-duration: 150ms;
}
.duration-200{
  transition-duration: 200ms;
}
.duration-300{
  transition-duration: 300ms;
}
.duration-500{
  transition-duration: 500ms;
}
.duration-75{
  transition-duration: 75ms;
}
.duration-\\[500ms\\]{
  transition-duration: 500ms;
}
.duration-\\[600ms\\]{
  transition-duration: 600ms;
}
.ease-in-out{
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-linear{
  transition-timing-function: linear;
}
.ease-out{
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.scrollbar::-webkit-scrollbar {
    width: 3px;
    height: 3px;
  }
.scrollbar::-webkit-scrollbar-track {
    border-radius: 100vh;
    background: rgb(180, 177, 177);
  }
.scrollbar::-webkit-scrollbar-thumb {
    background: rgb(180, 177, 177);
    border-radius: 100vh;
    border: 1px solid gray;
  }
.scrollbar::-webkit-scrollbar-thumb:hover {
    background: gray;
  }

* {
  font-family: "Montserrat", sans-serif;
}

*::-webkit-scrollbar {
    width: 3px;
    height: 3px;
  }

*::-webkit-scrollbar-track {
    border-radius: 100vh;
    background: rgb(180, 177, 177);
  }

*::-webkit-scrollbar-thumb {
    background: rgb(180, 177, 177);
    border-radius: 100vh;
    border: 1px solid gray;
  }

*::-webkit-scrollbar-thumb:hover {
    background: gray;
  }

.safety-item:nth-child(even){
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}

.safety-item:nth-child(odd){
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}

.safety-item:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}

.input-logo {
  position: absolute;
  top: 50%;
  left: 5%;
  transform: translate(0%, -50%);
}

.password-input-logo {
  position: absolute;
  top: 50%;
  right: 5%;
  transform: translate(0%, -50%);
}

input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] {
  -moz-appearance: textfield;
}

input[type="text"],
input[type="email"],
input[type="number"],
input[type="password"]{
  height: 50px;
  width: 100%;
  border-radius: 5px;
  border-width: 2px;
  --tw-border-opacity: 1;
  border-color: rgb(204 204 204 / var(--tw-border-opacity, 1));
  padding-left: 40px;
}

input[type="text"]::placeholder,
input[type="email"]::placeholder,
input[type="number"]::placeholder,
input[type="password"]::placeholder{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}

input[type="text"]:focus,
input[type="email"]:focus,
input[type="number"]:focus,
input[type="date"]:focus,
input[type="password"]:focus {
  outline: none;
  border: 2px solid #0072bb !important;
}

input[type="text"].project-name-input:focus {
  outline: none;
  border: 1px solid #cccccc !important;
}

input[type="text"].input-without-icon,
input[type="email"].input-without-icon,
input[type="number"].input-without-icon,
input[type="date"].input-without-icon,
input[type="password"].input-without-icon{
  height: 50px;
  width: 100%;
  border-radius: 5px;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(204 204 204 / var(--tw-border-opacity, 1));
  padding-left: 20px;
}

input[type="text"].input-without-icon::placeholder,
input[type="email"].input-without-icon::placeholder,
input[type="number"].input-without-icon::placeholder,
input[type="date"].input-without-icon::placeholder,
input[type="password"].input-without-icon::placeholder{
  font-size: 14px;
  font-weight: 400;
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}

input[type="text"].popup-input{
  height: 50px;
  width: 100%;
  border-top-left-radius: 10px !important;
  border-bottom-left-radius: 10px !important;
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(204 204 204 / var(--tw-border-opacity, 1));
  padding-left: 20px;
}

input[type="text"].popup-input::placeholder{
  font-size: 14px;
  font-weight: 400;
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}

input[type="text"].custom-search{
  height: 50px;
  width: 100%;
  border-radius: 5px !important;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(204 204 204 / var(--tw-border-opacity, 1));
  padding-left: 40px;
}

input[type="text"].custom-search::placeholder{
  font-size: 14px;
  font-weight: 400;
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}

input[type="text"].project-name-input{
  height: 50px;
  width: 300px;
  border-width: 1px !important;
  --tw-border-opacity: 1 !important;
  border-color: rgb(204 204 204 / var(--tw-border-opacity, 1)) !important;
  padding-left: 0px !important;
  font-size: 20px;
  font-weight: 700;
  --tw-text-opacity: 1;
  color: rgb(0 114 187 / var(--tw-text-opacity, 1));
  outline: 2px solid transparent;
  outline-offset: 2px;
}

input[type="text"].project-name-input::placeholder{
  font-size: 20px;
  font-weight: 400;
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}

@media (min-width: 768px){
  input[type="text"].project-name-input{
    font-size: 25px;
  }
}

@media (min-width: 1024px){
  input[type="text"].project-name-input{
    font-size: 28px;
  }
}

@media (min-width: 1280px){
  input[type="text"].project-name-input{
    font-size: 30px;
  }
}

textarea{
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(204 204 204 / var(--tw-border-opacity, 1));
  font-size: 14px;
  font-weight: 400;
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}

.step-one::after {
  content: "";
  width: 100px;
  height: 1px;
  position: absolute;
  z-index: 100;
  left: 100%;
  background-color: #0072bb;
}

.custom-bg {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  height: 100vh !important;
  width: 100% !important;
  object-fit: cover;
}

button[type="submit"]{
  border-radius: 5px;
  --tw-bg-opacity: 1;
  background-color: rgb(0 114 187 / var(--tw-bg-opacity, 1));
  padding-left: 18px;
  padding-right: 18px;
  padding-top: 10px;
  padding-bottom: 10px;
  font-size: 16px;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

button[type="submit"]:disabled{
  border-radius: 5px;
  --tw-bg-opacity: 1;
  background-color: rgb(54 69 79 / var(--tw-bg-opacity, 1));
  padding-left: 18px;
  padding-right: 18px;
  padding-top: 10px;
  padding-bottom: 10px;
  font-size: 16px;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.page-text{
  font-size: 20px;
  font-weight: 700;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

@media (min-width: 768px){
  .page-text{
    font-size: 25px;
  }
}

@media (min-width: 1024px){
  .page-text{
    font-size: 28px;
  }
}

@media (min-width: 1280px){
  .page-text{
    font-size: 30px;
  }
}

.title-text{
  font-size: 20px;
  font-weight: 700;
  --tw-text-opacity: 1;
  color: rgb(0 114 187 / var(--tw-text-opacity, 1));
}

@media (min-width: 768px){
  .title-text{
    font-size: 25px;
  }
}

@media (min-width: 1024px){
  .title-text{
    font-size: 28px;
  }
}

@media (min-width: 1280px){
  .title-text{
    font-size: 30px;
  }
}

.normal-text{
  font-size: 16px;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(33 33 33 / var(--tw-text-opacity, 1));
}

.service-description{
  font-size: 16px;
  font-weight: 500;
}

.service-title,
.faqs-title,
.page-subtitle{
  font-size: 16px;
  font-weight: 500;
}

.medium-title{
  font-size: 15px;
  font-weight: 700;
}

@media (min-width: 768px){
  .medium-title{
    font-size: 17px;
  }
}

@media (min-width: 1024px){
  .medium-title{
    font-size: 19px;
  }
}

@media (min-width: 1280px){
  .medium-title{
    font-size: 20px;
  }
}

.medium-lite-title{
  font-size: 15px;
  font-weight: 500;
}

@media (min-width: 768px){
  .medium-lite-title{
    font-size: 17px;
  }
}

@media (min-width: 1024px){
  .medium-lite-title{
    font-size: 19px;
  }
}

@media (min-width: 1280px){
  .medium-lite-title{
    font-size: 15px;
  }
}

.button-text{
  font-size: 16px;
  font-weight: 600;
}

.footer-text{
  font-size: 16px;
  font-weight: 400;
}

.copyright-text{
  font-size: 12px;
  font-weight: 400;
}

.project-number{
  font-size: 14px;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(12 74 114 / var(--tw-text-opacity, 1));
}

.custom-container{
  margin-left: auto;
  margin-right: auto;
  margin-top: 0px;
  margin-bottom: 0px;
  max-width: 1200px;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}

@media only screen and (max-width: 600px) {
  .custom-container{
    padding-left: 1rem;
    padding-right: 1rem;
  }
}

.header-links{
  font-size: 11px;
  font-weight: 500;
}

@media (min-width: 1024px){
  .header-links{
    font-size: 13px;
  }
}

.form-bg {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-repeat: round;
  width: 100%;
  object-fit: cover;
}

.formNew-bg {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-repeat: round;
  width: 100%;
  object-fit: cover;
}

.input-form {
  position: absolute;
  top: 70%;
  left: 3%;
  gap: 1%;
  transform: translate(0%, -50%);
}

input::placeholder::after {
  content: "*";
  color: red;
  opacity: 1;
}

input[type="text"].input-without-icon-1,
input[type="date"].input-without-icon-1,
input[type="date"].input-without-icon-1,
input[type="password"].input-without-icon-1{
  height: 50px;
  width: 100%;
  border-radius: 5px;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(204 204 204 / var(--tw-border-opacity, 1));
  padding-left: 20px;
}

input[type="text"].input-without-icon-1::placeholder,
input[type="date"].input-without-icon-1::placeholder,
input[type="date"].input-without-icon-1::placeholder,
input[type="password"].input-without-icon-1::placeholder{
  font-size: 14px;
  font-weight: 400;
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}

@media (min-width: 768px){
  input[type="text"].input-without-icon-1,
input[type="date"].input-without-icon-1,
input[type="date"].input-without-icon-1,
input[type="password"].input-without-icon-1{
    width: 380px;
  }
}

.input-without-icon-1.fullWidth{
  width: 100% !important;
}

textarea[type="text"].textarea-without-icon-1{
  height: 70px;
  width: 100%;
  border-radius: 5px;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(204 204 204 / var(--tw-border-opacity, 1));
  padding-left: 20px;
}

textarea[type="text"].textarea-without-icon-1::placeholder{
  font-size: 14px;
  font-weight: 400;
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}

@media (min-width: 768px){
  textarea[type="text"].textarea-without-icon-1{
    width: 380px;
  }
}

.project-slider .slick-track{
  margin-left: 0px;
  display: flex;
  gap: 20px;
}

.project-slider .slick-track::after,
.project-slider .slick-track::before {
  display: none;
}

.table-style {
  width: 90%;
  margin: auto;
  border-collapse: collapse;
  background-color: #fff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
}

.table-header {
  background-color: #337ab7;
  color: #fff;
  padding: 10px;
  border: 1px solid #ddd;
  text-align: left;
}

.table-cell {
  padding: 10px;
  border: 1px solid #ddd;
  text-align: left;
}

.even-row {
  background-color: #f5f5f5;
}

.signature-link {
  color: #337ab7;
  text-decoration: none;
  transition: color 0.3s ease;
}

.signature-link:hover {
  color: #23527c;
}

.signature-image {
  width: 50%;
  height: 50%;
  display: block;
  margin: auto;
  transition: transform 0.3s ease;
}

.signature-image:hover {
  transform: scale(1.1);
}

.sigbtn {
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 20px;
}

.tableZoom .react-transform-wrapper,
.tableZoom .react-transform-component {
  width: 100%;
}

/* .new-test::placeholder::after {
  content: "*";
  color: red !important;
}

.new-test::placeholder::after {
  content: " ::after content";
  /* Add your content here */
/* color: #999; */
/* Color of the pseudo-element */
/* font-size: 0.8em; */
/* Font size of the pseudo-element */
/* Add any other styles you want for the pseudo-element */
/* } */

/* input[required]::after {
  content: '*';
  color: red;
} */
.placeholder {
  color: black;
  position: relative;
  top: -35px;
  left: 22px;
}

.placeholder:after {
  content: "*";
  color: red;
}

.placeholderAnth {
  color: black;
  position: relative;
  left: 22px;
}

.placeholderAnth:after {
  content: "*";
  color: red;
}

.form-control:focus + .placeholder {
  display: none;
}

.red-asterisk {
  color: red;
}

@keyframes slideInOut {
  0% {
    transform: translateX(100%);
  }
  10% {
    transform: translateX(0);
  }
}

.animated-element {
  width: 35vw; /* Set the desired width of the element */
  z-index: 50;
  display: flex;
  justify-content: flex-end;
  animation: slideInOut 5s ease-in-out;
}

.gradient-border {
  position: relative;
  padding: 1rem;
}

.gradient-border::before {
  content: "";
  position: absolute;
  top: -2px;
  left: -2px;
  right: -2px;
  bottom: -2px;
  z-index: -1;
  background: linear-gradient(45deg, #83b9fa, #73bfe8, #5dcdf2);
  background-size: 200% 200%;
  animation: gradientBorder 5s ease infinite;
  border-radius: inherit;
}

@keyframes gradientBorder {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

button:hover span {
  /* transform: translateX(0) translateY(-50%); */
  opacity: 1;
}

.placeholder\\:text-black::placeholder{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}

.last\\:border-b-0:last-child{
  border-bottom-width: 0px;
}

.odd\\:bg-white:nth-child(odd){
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.even\\:bg-gray-100:nth-child(even){
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}

.even\\:bg-gray-50:nth-child(even){
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}

.hover\\:-translate-y-1:hover{
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:-translate-y-2:hover{
  --tw-translate-y: -0.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:scale-105:hover{
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:scale-95:hover{
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:border-blue-400:hover{
  --tw-border-opacity: 1;
  border-color: rgb(96 165 250 / var(--tw-border-opacity, 1));
}

.hover\\:border-blue-800:hover{
  --tw-border-opacity: 1;
  border-color: rgb(30 64 175 / var(--tw-border-opacity, 1));
}

.hover\\:border-gray-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}

.hover\\:border-gray-400:hover{
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / var(--tw-border-opacity, 1));
}

.hover\\:border-gray-500:hover{
  --tw-border-opacity: 1;
  border-color: rgb(107 114 128 / var(--tw-border-opacity, 1));
}

.hover\\:bg-\\[\\#005388\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(0 83 136 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#005a94\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(0 90 148 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#0072BB\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(0 114 187 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#0072bb\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(0 114 187 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#0072ca\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(0 114 202 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#0073bb6a\\]:hover{
  background-color: #0073bb6a;
}

.hover\\:bg-\\[\\#0073bbc3\\]:hover{
  background-color: #0073bbc3;
}

.hover\\:bg-\\[\\#0073bbde\\]:hover{
  background-color: #0073bbde;
}

.hover\\:bg-\\[\\#0084D3\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(0 132 211 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#0e598a\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(14 89 138 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#398cc0\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(57 140 192 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#4371e5\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(67 113 229 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#5295f7\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(82 149 247 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[gray\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(128 128 128 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-amber-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-blue-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-blue-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(191 219 254 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-blue-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-blue-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-blue-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-blue-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-blue-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(30 64 175 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-emerald-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(167 243 208 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-300:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-400:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-900\\/10:hover{
  background-color: rgb(17 24 39 / 0.1);
}

.hover\\:bg-green-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-green-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(187 247 208 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-green-300:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(134 239 172 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-green-400:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(74 222 128 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-green-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-green-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-green-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(21 128 61 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-indigo-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(67 56 202 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-orange-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 215 170 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-orange-300:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(253 186 116 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-orange-400:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(251 146 60 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-orange-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(249 115 22 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-orange-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(194 65 12 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-purple-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(233 213 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-purple-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(250 245 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 202 202 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-300:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(252 165 165 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-400:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(248 113 113 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-slate-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-slate-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-slate-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-transparent:hover{
  background-color: transparent;
}

.hover\\:bg-yellow-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 249 195 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-yellow-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 240 138 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-yellow-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 252 232 / var(--tw-bg-opacity, 1));
}

.hover\\:from-green-700:hover{
  --tw-gradient-from: #15803d var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(21 128 61 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-purple-700:hover{
  --tw-gradient-from: #7e22ce var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(126 34 206 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:to-blue-700:hover{
  --tw-gradient-to: #1d4ed8 var(--tw-gradient-to-position);
}

.hover\\:to-pink-700:hover{
  --tw-gradient-to: #be185d var(--tw-gradient-to-position);
}

.hover\\:text-\\[\\#0072bb\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(0 114 187 / var(--tw-text-opacity, 1));
}

.hover\\:text-\\[\\#212121\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(33 33 33 / var(--tw-text-opacity, 1));
}

.hover\\:text-\\[white\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.hover\\:text-amber-900:hover{
  --tw-text-opacity: 1;
  color: rgb(120 53 15 / var(--tw-text-opacity, 1));
}

.hover\\:text-black:hover{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}

.hover\\:text-blue-600:hover{
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}

.hover\\:text-blue-800:hover{
  --tw-text-opacity: 1;
  color: rgb(30 64 175 / var(--tw-text-opacity, 1));
}

.hover\\:text-blue-900:hover{
  --tw-text-opacity: 1;
  color: rgb(30 58 138 / var(--tw-text-opacity, 1));
}

.hover\\:text-gray-200:hover{
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity, 1));
}

.hover\\:text-gray-400:hover{
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}

.hover\\:text-gray-500:hover{
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}

.hover\\:text-gray-600:hover{
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}

.hover\\:text-gray-700:hover{
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}

.hover\\:text-gray-800:hover{
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}

.hover\\:text-gray-900:hover{
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}

.hover\\:text-green-900:hover{
  --tw-text-opacity: 1;
  color: rgb(20 83 45 / var(--tw-text-opacity, 1));
}

.hover\\:text-purple-600:hover{
  --tw-text-opacity: 1;
  color: rgb(147 51 234 / var(--tw-text-opacity, 1));
}

.hover\\:text-purple-900:hover{
  --tw-text-opacity: 1;
  color: rgb(88 28 135 / var(--tw-text-opacity, 1));
}

.hover\\:text-red-800:hover{
  --tw-text-opacity: 1;
  color: rgb(153 27 27 / var(--tw-text-opacity, 1));
}

.hover\\:text-red-900:hover{
  --tw-text-opacity: 1;
  color: rgb(127 29 29 / var(--tw-text-opacity, 1));
}

.hover\\:text-white:hover{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.hover\\:text-yellow-500:hover{
  --tw-text-opacity: 1;
  color: rgb(234 179 8 / var(--tw-text-opacity, 1));
}

.hover\\:underline:hover{
  text-decoration-line: underline;
}

.hover\\:opacity-100:hover{
  opacity: 1;
}

.hover\\:opacity-80:hover{
  opacity: 0.8;
}

.hover\\:opacity-90:hover{
  opacity: 0.9;
}

.hover\\:shadow-lg:hover{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-md:hover{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-xl:hover{
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-gray-900\\/20:hover{
  --tw-shadow-color: rgb(17 24 39 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:ease-in:hover{
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}

.odd\\:hover\\:bg-blue-200:hover:nth-child(odd){
  --tw-bg-opacity: 1;
  background-color: rgb(191 219 254 / var(--tw-bg-opacity, 1));
}

.even\\:hover\\:bg-blue-200:hover:nth-child(even){
  --tw-bg-opacity: 1;
  background-color: rgb(191 219 254 / var(--tw-bg-opacity, 1));
}

.focus\\:z-20:focus{
  z-index: 20;
}

.focus\\:border-\\[\\#0081c8\\]:focus{
  --tw-border-opacity: 1;
  border-color: rgb(0 129 200 / var(--tw-border-opacity, 1));
}

.focus\\:border-blue-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}

.focus\\:border-gray-200:focus{
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}

.focus\\:border-indigo-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / var(--tw-border-opacity, 1));
}

.focus\\:border-purple-400:focus{
  --tw-border-opacity: 1;
  border-color: rgb(192 132 252 / var(--tw-border-opacity, 1));
}

.focus\\:border-red-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}

.focus\\:border-transparent:focus{
  border-color: transparent;
}

.focus\\:text-gray-700:focus{
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}

.focus\\:placeholder-gray-400:focus::placeholder{
  --tw-placeholder-opacity: 1;
  color: rgb(156 163 175 / var(--tw-placeholder-opacity, 1));
}

.focus\\:outline-none:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:outline-offset-0:focus{
  outline-offset: 0px;
}

.focus\\:ring-0:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-1:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-2:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-4:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-blue-300:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(147 197 253 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-blue-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-blue-600:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(37 99 235 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-gray-300:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(209 213 219 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-gray-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(107 114 128 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-indigo-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(99 102 241 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-purple-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(168 85 247 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-red-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(239 68 68 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-opacity-50:focus{
  --tw-ring-opacity: 0.5;
}

.focus\\:ring-offset-0:focus{
  --tw-ring-offset-width: 0px;
}

.focus\\:ring-offset-2:focus{
  --tw-ring-offset-width: 2px;
}

.hover\\:focus\\:border-\\[\\#0081c8\\]:focus:hover{
  --tw-border-opacity: 1;
  border-color: rgb(0 129 200 / var(--tw-border-opacity, 1));
}

.focus-visible\\:outline:focus-visible{
  outline-style: solid;
}

.focus-visible\\:outline-0:focus-visible{
  outline-width: 0px;
}

.focus-visible\\:outline-2:focus-visible{
  outline-width: 2px;
}

.focus-visible\\:outline-offset-2:focus-visible{
  outline-offset: 2px;
}

.focus-visible\\:outline-blue-600:focus-visible{
  outline-color: #2563eb;
}

.active\\:bg-blue-800:active{
  --tw-bg-opacity: 1;
  background-color: rgb(30 64 175 / var(--tw-bg-opacity, 1));
}

.active\\:bg-gray-900\\/20:active{
  background-color: rgb(17 24 39 / 0.2);
}

.disabled\\:pointer-events-none:disabled{
  pointer-events: none;
}

.disabled\\:cursor-not-allowed:disabled{
  cursor: not-allowed;
}

.disabled\\:bg-blue-300:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(147 197 253 / var(--tw-bg-opacity, 1));
}

.disabled\\:opacity-20:disabled{
  opacity: 0.2;
}

.disabled\\:opacity-50:disabled{
  opacity: 0.5;
}

.disabled\\:shadow-none:disabled{
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.group:hover .group-hover\\:rotate-12{
  --tw-rotate: 12deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group\\/item:hover .group-hover\\/item\\:text-purple-600{
  --tw-text-opacity: 1;
  color: rgb(147 51 234 / var(--tw-text-opacity, 1));
}

@media (min-width: 640px){
  .sm\\:top-0{
    top: 0px;
  }
  .sm\\:top-\\[26\\%\\]{
    top: 26%;
  }
  .sm\\:top-\\[3\\%\\]{
    top: 3%;
  }
  .sm\\:col-span-1{
    grid-column: span 1 / span 1;
  }
  .sm\\:col-span-2{
    grid-column: span 2 / span 2;
  }
  .sm\\:col-span-3{
    grid-column: span 3 / span 3;
  }
  .sm\\:col-span-9{
    grid-column: span 9 / span 9;
  }
  .sm\\:mx-0{
    margin-left: 0px;
    margin-right: 0px;
  }
  .sm\\:mx-\\[100px\\]{
    margin-left: 100px;
    margin-right: 100px;
  }
  .sm\\:my-8{
    margin-top: 2rem;
    margin-bottom: 2rem;
  }
  .sm\\:mb-12{
    margin-bottom: 3rem;
  }
  .sm\\:mb-5{
    margin-bottom: 1.25rem;
  }
  .sm\\:ml-3{
    margin-left: 0.75rem;
  }
  .sm\\:ml-4{
    margin-left: 1rem;
  }
  .sm\\:mt-0{
    margin-top: 0px;
  }
  .sm\\:mt-11{
    margin-top: 2.75rem;
  }
  .sm\\:mt-12{
    margin-top: 3rem;
  }
  .sm\\:mt-4{
    margin-top: 1rem;
  }
  .sm\\:mt-8{
    margin-top: 2rem;
  }
  .sm\\:mt-\\[30px\\]{
    margin-top: 30px;
  }
  .sm\\:mt-\\[40px\\]{
    margin-top: 40px;
  }
  .sm\\:mt-\\[60px\\]{
    margin-top: 60px;
  }
  .sm\\:mt-\\[6rem\\]{
    margin-top: 6rem;
  }
  .sm\\:block{
    display: block;
  }
  .sm\\:inline-block{
    display: inline-block;
  }
  .sm\\:flex{
    display: flex;
  }
  .sm\\:table-cell{
    display: table-cell;
  }
  .sm\\:hidden{
    display: none;
  }
  .sm\\:h-10{
    height: 2.5rem;
  }
  .sm\\:h-11{
    height: 2.75rem;
  }
  .sm\\:h-\\[100vh\\]{
    height: 100vh;
  }
  .sm\\:h-\\[40vh\\]{
    height: 40vh;
  }
  .sm\\:h-\\[70vh\\]{
    height: 70vh;
  }
  .sm\\:h-auto{
    height: auto;
  }
  .sm\\:h-full{
    height: 100%;
  }
  .sm\\:h-screen{
    height: 100vh;
  }
  .sm\\:min-h-\\[100px\\]{
    min-height: 100px;
  }
  .sm\\:w-1\\/2{
    width: 50%;
  }
  .sm\\:w-10{
    width: 2.5rem;
  }
  .sm\\:w-11{
    width: 2.75rem;
  }
  .sm\\:w-96{
    width: 24rem;
  }
  .sm\\:w-\\[350px\\]{
    width: 350px;
  }
  .sm\\:w-\\[400px\\]{
    width: 400px;
  }
  .sm\\:w-\\[45\\%\\]{
    width: 45%;
  }
  .sm\\:w-\\[600px\\]{
    width: 600px;
  }
  .sm\\:w-\\[60vw\\]{
    width: 60vw;
  }
  .sm\\:w-\\[70vw\\]{
    width: 70vw;
  }
  .sm\\:w-\\[77\\%\\]{
    width: 77%;
  }
  .sm\\:w-\\[90vw\\]{
    width: 90vw;
  }
  .sm\\:w-auto{
    width: auto;
  }
  .sm\\:w-full{
    width: 100%;
  }
  .sm\\:max-w-3xl{
    max-width: 48rem;
  }
  .sm\\:max-w-lg{
    max-width: 32rem;
  }
  .sm\\:max-w-md{
    max-width: 28rem;
  }
  .sm\\:flex-1{
    flex: 1 1;
  }
  .sm\\:grid-cols-1{
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  .sm\\:grid-cols-12{
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
  .sm\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .sm\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .sm\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .sm\\:flex-row{
    flex-direction: row;
  }
  .sm\\:flex-row-reverse{
    flex-direction: row-reverse;
  }
  .sm\\:flex-col{
    flex-direction: column;
  }
  .sm\\:flex-nowrap{
    flex-wrap: nowrap;
  }
  .sm\\:items-start{
    align-items: flex-start;
  }
  .sm\\:items-center{
    align-items: center;
  }
  .sm\\:justify-end{
    justify-content: flex-end;
  }
  .sm\\:justify-between{
    justify-content: space-between;
  }
  .sm\\:gap-0{
    gap: 0px;
  }
  .sm\\:gap-10{
    gap: 2.5rem;
  }
  .sm\\:gap-12{
    gap: 3rem;
  }
  .sm\\:gap-2{
    gap: 0.5rem;
  }
  .sm\\:gap-4{
    gap: 1rem;
  }
  .sm\\:gap-5{
    gap: 1.25rem;
  }
  .sm\\:gap-7{
    gap: 1.75rem;
  }
  .sm\\:gap-8{
    gap: 2rem;
  }
  .sm\\:gap-\\[1rem\\]{
    gap: 1rem;
  }
  .sm\\:gap-\\[20px\\]{
    gap: 20px;
  }
  .sm\\:gap-\\[30px\\]{
    gap: 30px;
  }
  .sm\\:gap-\\[50px\\]{
    gap: 50px;
  }
  .sm\\:space-y-0 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }
  .sm\\:truncate{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .sm\\:rounded-lg{
    border-radius: 0.5rem;
  }
  .sm\\:border-b-0{
    border-bottom-width: 0px;
  }
  .sm\\:border-r{
    border-right-width: 1px;
  }
  .sm\\:p-0{
    padding: 0px;
  }
  .sm\\:p-10{
    padding: 2.5rem;
  }
  .sm\\:p-4{
    padding: 1rem;
  }
  .sm\\:p-6{
    padding: 1.5rem;
  }
  .sm\\:p-8{
    padding: 2rem;
  }
  .sm\\:px-5{
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
  .sm\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .sm\\:px-\\[20px\\]{
    padding-left: 20px;
    padding-right: 20px;
  }
  .sm\\:py-14{
    padding-top: 3.5rem;
    padding-bottom: 3.5rem;
  }
  .sm\\:py-3{
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }
  .sm\\:py-8{
    padding-top: 2rem;
    padding-bottom: 2rem;
  }
  .sm\\:py-\\[100px\\]{
    padding-top: 100px;
    padding-bottom: 100px;
  }
  .sm\\:py-\\[10px\\]{
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .sm\\:py-\\[12px\\]{
    padding-top: 12px;
    padding-bottom: 12px;
  }
  .sm\\:py-\\[20px\\]{
    padding-top: 20px;
    padding-bottom: 20px;
  }
  .sm\\:pb-12{
    padding-bottom: 3rem;
  }
  .sm\\:pb-4{
    padding-bottom: 1rem;
  }
  .sm\\:pb-\\[50px\\]{
    padding-bottom: 50px;
  }
  .sm\\:pr-10{
    padding-right: 2.5rem;
  }
  .sm\\:pt-12{
    padding-top: 3rem;
  }
  .sm\\:text-left{
    text-align: left;
  }
  .sm\\:text-center{
    text-align: center;
  }
  .sm\\:align-middle{
    vertical-align: middle;
  }
  .sm\\:\\!text-2xl{
    font-size: 1.5rem !important;
    line-height: 2rem !important;
  }
  .sm\\:\\!text-\\[16px\\]{
    font-size: 16px !important;
  }
  .sm\\:\\!text-xl{
    font-size: 1.25rem !important;
    line-height: 1.75rem !important;
  }
  .sm\\:text-2xl{
    font-size: 1.5rem;
    line-height: 2rem;
  }
  .sm\\:text-3xl{
    font-size: 1.875rem;
    line-height: 2.25rem;
  }
  .sm\\:text-5xl{
    font-size: 3rem;
    line-height: 1;
  }
  .sm\\:text-\\[16px\\]{
    font-size: 16px;
  }
  .sm\\:text-\\[18px\\]{
    font-size: 18px;
  }
  .sm\\:text-base{
    font-size: 1rem;
    line-height: 1.5rem;
  }
  .sm\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
  .sm\\:text-xl{
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
  .sm\\:text-xs{
    font-size: 0.75rem;
    line-height: 1rem;
  }
}

@media (min-width: 768px){
  .md\\:static{
    position: static;
  }
  .md\\:right-\\[12\\%\\]{
    right: 12%;
  }
  .md\\:top-\\[27\\%\\]{
    top: 27%;
  }
  .md\\:col-span-2{
    grid-column: span 2 / span 2;
  }
  .md\\:mb-8{
    margin-bottom: 2rem;
  }
  .md\\:mb-\\[100px\\]{
    margin-bottom: 100px;
  }
  .md\\:mb-\\[40px\\]{
    margin-bottom: 40px;
  }
  .md\\:ml-4{
    margin-left: 1rem;
  }
  .md\\:mt-0{
    margin-top: 0px;
  }
  .md\\:mt-\\[100px\\]{
    margin-top: 100px;
  }
  .md\\:mt-\\[1rem\\]{
    margin-top: 1rem;
  }
  .md\\:mt-\\[20px\\]{
    margin-top: 20px;
  }
  .md\\:mt-\\[50px\\]{
    margin-top: 50px;
  }
  .md\\:mt-\\[60px\\]{
    margin-top: 60px;
  }
  .md\\:block{
    display: block;
  }
  .md\\:flex{
    display: flex;
  }
  .md\\:hidden{
    display: none;
  }
  .md\\:h-\\[500px\\]{
    height: 500px;
  }
  .md\\:h-auto{
    height: auto;
  }
  .md\\:h-full{
    height: 100%;
  }
  .md\\:max-h-\\[100\\%\\]{
    max-height: 100%;
  }
  .md\\:min-h-\\[271px\\]{
    min-height: 271px;
  }
  .md\\:w-1\\/2{
    width: 50%;
  }
  .md\\:w-\\[150px\\]{
    width: 150px;
  }
  .md\\:w-\\[22\\%\\]{
    width: 22%;
  }
  .md\\:w-\\[24px\\]{
    width: 24px;
  }
  .md\\:w-\\[25\\%\\]{
    width: 25%;
  }
  .md\\:w-\\[30\\%\\]{
    width: 30%;
  }
  .md\\:w-\\[50\\%\\]{
    width: 50%;
  }
  .md\\:w-\\[70\\%\\]{
    width: 70%;
  }
  .md\\:w-\\[calc\\(100\\%\\)\\]{
    width: calc(100%);
  }
  .md\\:w-\\[calc\\(100\\%-170px\\)\\]{
    width: calc(100% - 170px);
  }
  .md\\:w-\\[calc\\(20\\%-10px\\)\\]{
    width: calc(20% - 10px);
  }
  .md\\:w-\\[calc\\(30\\%-10px\\)\\]{
    width: calc(30% - 10px);
  }
  .md\\:w-auto{
    width: auto;
  }
  .md\\:w-full{
    width: 100%;
  }
  .md\\:min-w-\\[700px\\]{
    min-width: 700px;
  }
  .md\\:max-w-\\[500px\\]{
    max-width: 500px;
  }
  .md\\:max-w-\\[50vw\\]{
    max-width: 50vw;
  }
  .md\\:max-w-lg{
    max-width: 32rem;
  }
  .md\\:translate-x-0{
    --tw-translate-x: 0px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
  .md\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .md\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .md\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .md\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  .md\\:flex-row{
    flex-direction: row;
  }
  .md\\:flex-col{
    flex-direction: column;
  }
  .md\\:items-end{
    align-items: flex-end;
  }
  .md\\:items-center{
    align-items: center;
  }
  .md\\:justify-between{
    justify-content: space-between;
  }
  .md\\:gap-14{
    gap: 3.5rem;
  }
  .md\\:gap-6{
    gap: 1.5rem;
  }
  .md\\:gap-\\[30px\\]{
    gap: 30px;
  }
  .md\\:space-y-0 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }
  .md\\:space-y-6 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
  }
  .md\\:p-20{
    padding: 5rem;
  }
  .md\\:p-6{
    padding: 1.5rem;
  }
  .md\\:p-8{
    padding: 2rem;
  }
  .md\\:px-\\[10px\\]{
    padding-left: 10px;
    padding-right: 10px;
  }
  .md\\:px-\\[12px\\]{
    padding-left: 12px;
    padding-right: 12px;
  }
  .md\\:py-\\[11px\\]{
    padding-top: 11px;
    padding-bottom: 11px;
  }
  .md\\:py-\\[50px\\]{
    padding-top: 50px;
    padding-bottom: 50px;
  }
  .md\\:py-\\[6px\\]{
    padding-top: 6px;
    padding-bottom: 6px;
  }
  .md\\:pb-\\[50px\\]{
    padding-bottom: 50px;
  }
  .md\\:pl-16{
    padding-left: 4rem;
  }
  .md\\:text-left{
    text-align: left;
  }
  .md\\:text-3xl{
    font-size: 1.875rem;
    line-height: 2.25rem;
  }
  .md\\:text-4xl{
    font-size: 2.25rem;
    line-height: 2.5rem;
  }
  .md\\:text-\\[20px\\]{
    font-size: 20px;
  }
}

@media (min-width: 1024px){
  .lg\\:static{
    position: static;
  }
  .lg\\:absolute{
    position: absolute;
  }
  .lg\\:relative{
    position: relative;
  }
  .lg\\:right-\\[17\\%\\]{
    right: 17%;
  }
  .lg\\:right-\\[9\\%\\]{
    right: 9%;
  }
  .lg\\:top-\\[12\\%\\]{
    top: 12%;
  }
  .lg\\:col-span-1{
    grid-column: span 1 / span 1;
  }
  .lg\\:col-span-2{
    grid-column: span 2 / span 2;
  }
  .lg\\:mx-\\[85px\\]{
    margin-left: 85px;
    margin-right: 85px;
  }
  .lg\\:mb-0{
    margin-bottom: 0px;
  }
  .lg\\:mb-\\[30px\\]{
    margin-bottom: 30px;
  }
  .lg\\:mb-\\[60px\\]{
    margin-bottom: 60px;
  }
  .lg\\:mb-\\[78px\\]{
    margin-bottom: 78px;
  }
  .lg\\:ml-0{
    margin-left: 0px;
  }
  .lg\\:mt-0{
    margin-top: 0px;
  }
  .lg\\:mt-\\[0px\\]{
    margin-top: 0px;
  }
  .lg\\:block{
    display: block;
  }
  .lg\\:flex{
    display: flex;
  }
  .lg\\:hidden{
    display: none;
  }
  .lg\\:h-\\[70px\\]{
    height: 70px;
  }
  .lg\\:h-\\[80vh\\]{
    height: 80vh;
  }
  .lg\\:h-full{
    height: 100%;
  }
  .lg\\:min-h-\\[134px\\]{
    min-height: 134px;
  }
  .lg\\:min-h-\\[141px\\]{
    min-height: 141px;
  }
  .lg\\:min-h-\\[203px\\]{
    min-height: 203px;
  }
  .lg\\:min-h-\\[350px\\]{
    min-height: 350px;
  }
  .lg\\:min-h-\\[40vh\\]{
    min-height: 40vh;
  }
  .lg\\:\\!w-\\[380px\\]{
    width: 380px !important;
  }
  .lg\\:\\!w-\\[580px\\]{
    width: 580px !important;
  }
  .lg\\:w-1\\/2{
    width: 50%;
  }
  .lg\\:w-1\\/3{
    width: 33.333333%;
  }
  .lg\\:w-2\\/5{
    width: 40%;
  }
  .lg\\:w-3\\/5{
    width: 60%;
  }
  .lg\\:w-6\\/12{
    width: 50%;
  }
  .lg\\:w-\\[1150px\\]{
    width: 1150px;
  }
  .lg\\:w-\\[180px\\]{
    width: 180px;
  }
  .lg\\:w-\\[20\\%\\]{
    width: 20%;
  }
  .lg\\:w-\\[280px\\]{
    width: 280px;
  }
  .lg\\:w-\\[30\\%\\]{
    width: 30%;
  }
  .lg\\:w-\\[358px\\]{
    width: 358px;
  }
  .lg\\:w-\\[380px\\]{
    width: 380px;
  }
  .lg\\:w-\\[500px\\]{
    width: 500px;
  }
  .lg\\:w-\\[580px\\]{
    width: 580px;
  }
  .lg\\:w-\\[70\\%\\]{
    width: 70%;
  }
  .lg\\:w-\\[70vw\\]{
    width: 70vw;
  }
  .lg\\:w-\\[780px\\]{
    width: 780px;
  }
  .lg\\:w-\\[calc\\(100\\%-300px\\)\\]{
    width: calc(100% - 300px);
  }
  .lg\\:w-\\[calc\\(33\\.33\\%\\)\\]{
    width: calc(33.33%);
  }
  .lg\\:w-\\[calc\\(50\\%-10px\\)\\]{
    width: calc(50% - 10px);
  }
  .lg\\:w-\\[calc\\(50\\%-12px\\)\\]{
    width: calc(50% - 12px);
  }
  .lg\\:w-\\[calc\\(50\\%-20px\\)\\]{
    width: calc(50% - 20px);
  }
  .lg\\:w-\\[calc\\(50\\%-50px\\)\\]{
    width: calc(50% - 50px);
  }
  .lg\\:w-\\[calc\\(50\\%-5px\\)\\]{
    width: calc(50% - 5px);
  }
  .lg\\:w-auto{
    width: auto;
  }
  .lg\\:w-full{
    width: 100%;
  }
  .lg\\:min-w-\\[180px\\]{
    min-width: 180px;
  }
  .lg\\:min-w-\\[450px\\]{
    min-width: 450px;
  }
  .lg\\:min-w-\\[80px\\]{
    min-width: 80px;
  }
  .lg\\:min-w-\\[900px\\]{
    min-width: 900px;
  }
  .lg\\:max-w-\\[1200px\\]{
    max-width: 1200px;
  }
  .lg\\:max-w-\\[480px\\]{
    max-width: 480px;
  }
  .lg\\:max-w-\\[500px\\]{
    max-width: 500px;
  }
  .lg\\:max-w-\\[90vw\\]{
    max-width: 90vw;
  }
  .lg\\:translate-x-0{
    --tw-translate-x: 0px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
  .lg\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .lg\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .lg\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .lg\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  .lg\\:grid-cols-6{
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
  .lg\\:grid-cols-7{
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }
  .lg\\:flex-row{
    flex-direction: row;
  }
  .lg\\:flex-row-reverse{
    flex-direction: row-reverse;
  }
  .lg\\:flex-col{
    flex-direction: column;
  }
  .lg\\:flex-nowrap{
    flex-wrap: nowrap;
  }
  .lg\\:items-start{
    align-items: flex-start;
  }
  .lg\\:items-center{
    align-items: center;
  }
  .lg\\:justify-end{
    justify-content: flex-end;
  }
  .lg\\:justify-between{
    justify-content: space-between;
  }
  .lg\\:gap-8{
    gap: 2rem;
  }
  .lg\\:gap-\\[200px\\]{
    gap: 200px;
  }
  .lg\\:gap-\\[30px\\]{
    gap: 30px;
  }
  .lg\\:gap-\\[40px\\]{
    gap: 40px;
  }
  .lg\\:gap-\\[64px\\]{
    gap: 64px;
  }
  .lg\\:gap-\\[70px\\]{
    gap: 70px;
  }
  .lg\\:space-x-4 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(1rem * var(--tw-space-x-reverse));
    margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
  }
  .lg\\:border{
    border-width: 1px;
  }
  .lg\\:border-b-0{
    border-bottom-width: 0px;
  }
  .lg\\:border-b-\\[0px\\]{
    border-bottom-width: 0px;
  }
  .lg\\:border-r{
    border-right-width: 1px;
  }
  .lg\\:border-b-\\[\\#00000000\\]{
    border-bottom-color: #00000000;
  }
  .lg\\:border-r-\\[\\#CCCCCC\\]{
    --tw-border-opacity: 1;
    border-right-color: rgb(204 204 204 / var(--tw-border-opacity, 1));
  }
  .lg\\:px-5{
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
  .lg\\:px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .lg\\:px-\\[100px\\]{
    padding-left: 100px;
    padding-right: 100px;
  }
  .lg\\:px-\\[150px\\]{
    padding-left: 150px;
    padding-right: 150px;
  }
  .lg\\:px-\\[18px\\]{
    padding-left: 18px;
    padding-right: 18px;
  }
  .lg\\:px-\\[25px\\]{
    padding-left: 25px;
    padding-right: 25px;
  }
  .lg\\:px-\\[40px\\]{
    padding-left: 40px;
    padding-right: 40px;
  }
  .lg\\:py-14{
    padding-top: 3.5rem;
    padding-bottom: 3.5rem;
  }
  .lg\\:py-\\[100px\\]{
    padding-top: 100px;
    padding-bottom: 100px;
  }
  .lg\\:py-\\[12px\\]{
    padding-top: 12px;
    padding-bottom: 12px;
  }
  .lg\\:py-\\[50px\\]{
    padding-top: 50px;
    padding-bottom: 50px;
  }
  .lg\\:py-\\[80px\\]{
    padding-top: 80px;
    padding-bottom: 80px;
  }
  .lg\\:py-\\[90px\\]{
    padding-top: 90px;
    padding-bottom: 90px;
  }
  .lg\\:pl-\\[100px\\]{
    padding-left: 100px;
  }
  .lg\\:pl-\\[px\\]{
    padding-left: px;
  }
  .lg\\:pt-\\[90px\\]{
    padding-top: 90px;
  }
  .lg\\:text-\\[13px\\]{
    font-size: 13px;
  }
  .lg\\:text-\\[18px\\]{
    font-size: 18px;
  }
}

@media (min-width: 1280px){
  .xl\\:h-\\[50px\\]{
    height: 50px;
  }
  .xl\\:min-h-\\[650px\\]{
    min-height: 650px;
  }
  .xl\\:w-\\[29\\%\\]{
    width: 29%;
  }
  .xl\\:w-\\[450px\\]{
    width: 450px;
  }
  .xl\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .xl\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .xl\\:p-0{
    padding: 0px;
  }
}

@media (min-width: 1536px){
  .\\32xl\\:col-span-2{
    grid-column: span 2 / span 2;
  }
  .\\32xl\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

.rtl\\:right-0:where([dir="rtl"], [dir="rtl"] *){
  right: 0px;
}

.rtl\\:text-right:where([dir="rtl"], [dir="rtl"] *){
  text-align: right;
}

@media (prefers-color-scheme: dark){
  .dark\\:divide-neutral-700 > :not([hidden]) ~ :not([hidden]){
    --tw-divide-opacity: 1;
    border-color: rgb(64 64 64 / var(--tw-divide-opacity, 1));
  }
  .dark\\:border{
    border-width: 1px;
  }
  .dark\\:border-black{
    --tw-border-opacity: 1;
    border-color: rgb(0 0 0 / var(--tw-border-opacity, 1));
  }
  .dark\\:border-gray-200{
    --tw-border-opacity: 1;
    border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
  }
  .dark\\:border-gray-600{
    --tw-border-opacity: 1;
    border-color: rgb(75 85 99 / var(--tw-border-opacity, 1));
  }
  .dark\\:border-gray-700{
    --tw-border-opacity: 1;
    border-color: rgb(55 65 81 / var(--tw-border-opacity, 1));
  }
  .dark\\:border-gray-800{
    --tw-border-opacity: 1;
    border-color: rgb(31 41 55 / var(--tw-border-opacity, 1));
  }
  .dark\\:border-neutral-700{
    --tw-border-opacity: 1;
    border-color: rgb(64 64 64 / var(--tw-border-opacity, 1));
  }
  .dark\\:bg-blue-600{
    --tw-bg-opacity: 1;
    background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
  }
  .dark\\:bg-blue-900{
    --tw-bg-opacity: 1;
    background-color: rgb(30 58 138 / var(--tw-bg-opacity, 1));
  }
  .dark\\:bg-gray-300{
    --tw-bg-opacity: 1;
    background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
  }
  .dark\\:bg-neutral-800{
    --tw-bg-opacity: 1;
    background-color: rgb(38 38 38 / var(--tw-bg-opacity, 1));
  }
  .dark\\:bg-white{
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  }
  .dark\\:text-black{
    --tw-text-opacity: 1;
    color: rgb(0 0 0 / var(--tw-text-opacity, 1));
  }
  .dark\\:text-blue-200{
    --tw-text-opacity: 1;
    color: rgb(191 219 254 / var(--tw-text-opacity, 1));
  }
  .dark\\:text-blue-500{
    --tw-text-opacity: 1;
    color: rgb(59 130 246 / var(--tw-text-opacity, 1));
  }
  .dark\\:text-gray-300{
    --tw-text-opacity: 1;
    color: rgb(209 213 219 / var(--tw-text-opacity, 1));
  }
  .dark\\:text-gray-400{
    --tw-text-opacity: 1;
    color: rgb(156 163 175 / var(--tw-text-opacity, 1));
  }
  .dark\\:text-gray-600{
    --tw-text-opacity: 1;
    color: rgb(75 85 99 / var(--tw-text-opacity, 1));
  }
  .dark\\:text-green-400{
    --tw-text-opacity: 1;
    color: rgb(74 222 128 / var(--tw-text-opacity, 1));
  }
  .dark\\:text-red-400{
    --tw-text-opacity: 1;
    color: rgb(248 113 113 / var(--tw-text-opacity, 1));
  }
  .dark\\:placeholder-gray-400::placeholder{
    --tw-placeholder-opacity: 1;
    color: rgb(156 163 175 / var(--tw-placeholder-opacity, 1));
  }
  .dark\\:placeholder-gray-600::placeholder{
    --tw-placeholder-opacity: 1;
    color: rgb(75 85 99 / var(--tw-placeholder-opacity, 1));
  }
  .dark\\:odd\\:bg-white:nth-child(odd){
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  }
  .odd\\:dark\\:bg-gray-300:nth-child(odd){
    --tw-bg-opacity: 1;
    background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
  }
  .even\\:dark\\:bg-gray-300:nth-child(even){
    --tw-bg-opacity: 1;
    background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
  }
  .dark\\:checked\\:border-blue-500:checked{
    --tw-border-opacity: 1;
    border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
  }
  .dark\\:checked\\:bg-blue-500:checked{
    --tw-bg-opacity: 1;
    background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
  }
  .dark\\:hover\\:border-gray-200:hover{
    --tw-border-opacity: 1;
    border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
  }
  .dark\\:hover\\:bg-blue-700:hover{
    --tw-bg-opacity: 1;
    background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
  }
  .dark\\:hover\\:bg-gray-100:hover{
    --tw-bg-opacity: 1;
    background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
  }
  .dark\\:focus\\:border-blue-500:focus{
    --tw-border-opacity: 1;
    border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
  }
  .dark\\:focus\\:ring-blue-500:focus{
    --tw-ring-opacity: 1;
    --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity, 1));
  }
  .dark\\:focus\\:ring-blue-800:focus{
    --tw-ring-opacity: 1;
    --tw-ring-color: rgb(30 64 175 / var(--tw-ring-opacity, 1));
  }
  .dark\\:focus\\:ring-offset-gray-800:focus{
    --tw-ring-offset-color: #1f2937;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/App.css"],"names":[],"mappings":"AAEA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;AAAd;;CAAc;AAAd;;;CAAc;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;AAAd;;EAAA,gBAAc;AAAA;AAAd;;;;;;;;CAAc;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;AAAd;;;CAAc;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;AAAd;;;;CAAc;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;AAAd;;CAAc;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,mBAAc;AAAA;AAAd;;;;;CAAc;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,cAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;AAAd;EAAA,eAAc;AAAA;AAAd;EAAA,WAAc;AAAA;AAAd;;;;CAAc;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;AAAd;;;;CAAc;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,oBAAc;AAAA;AAAd;;;CAAc;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,aAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,gBAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,wBAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,YAAc;AAAA;AAAd;;;CAAc;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,wBAAc;AAAA;AAAd;;;CAAc;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,kBAAc;AAAA;AAAd;;CAAc;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;AAAd;EAAA,UAAc;AAAA;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,gBAAc;AAAA;AAAd;;;CAAc;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,eAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;AAAd;;;;CAAc;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;AAAd;;EAAA,uDAAc;EAAd;AAAc;AAAd;EAAA;IAAA,mBAAc;IAAd,qBAAc;IAAd,sBAAc;IAAd,qBAAc;IAAd,sBAAc;IAAd,qBAAc;IAAd,sBAAc;IAAd,qBAAc;IAAd,sBAAc;IAAd,sBAAc;IAAd,sBAAc;IAAd,sBAAc;IAAd,sBAAc;IAAd,sBAAc;IAAd,uBAAc;IAAd,sBAAc;IAAd,uBAAc;IAAd,sBAAc;IAAd,uBAAc;IAAd,sBAAc;IAAd;EAAc;EAAd;IAAA;MAAA,kBAAc;MAAd,qBAAc;MAAd,sBAAc;MAAd,qBAAc;MAAd,sBAAc;MAAd,qBAAc;MAAd,sBAAc;MAAd,qBAAc;MAAd,sBAAc;MAAd,sBAAc;MAAd,sBAAc;MAAd,sBAAc;MAAd,sBAAc;MAAd,sBAAc;MAAd,uBAAc;MAAd,sBAAc;MAAd,uBAAc;MAAd,sBAAc;MAAd,uBAAc;MAAd,sBAAc;MAAd;IAAc;EAAA;AAAA;AAAd;EAAA;AAAc;AAAd;EAAA;AAAc;AAAd;EAAA;AAAc;AAAd;EAAA,mBAAc;EAAd,wBAAc;EAAd,qBAAc;EAAd,wBAAc;EAAd,wBAAc;EAAd,4BAAc;EAAd,2BAAc;EAAd,aAAc;EAAd,aAAc;EAAd,aAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,uBAAc;EAAd,sBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,iBAAc;EAAd,iBAAc;EAAd,oBAAc;EAAd,yBAAc;EAAd,wBAAc;EAAd,0BAAc;EAAd,wBAAc;EAAd,gCAAc;EAAd,kCAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,iCAAc;EAAd;AAAc;AAAd;EAAA;IAAA,kBAAc;IAAd,wBAAc;IAAd,qBAAc;IAAd,wBAAc;IAAd,wBAAc;IAAd,2BAAc;IAAd,yBAAc;IAAd,2BAAc;IAAd,aAAc;IAAd,aAAc;IAAd,aAAc;IAAd,aAAc;IAAd,mBAAc;IAAd,qBAAc;IAAd,uBAAc;IAAd,sBAAc;IAAd,sBAAc;IAAd,uBAAc;IAAd,iBAAc;IAAd,iBAAc;IAAd,oBAAc;IAAd,wBAAc;IAAd,sBAAc;IAAd,wBAAc;IAAd,iCAAc;IAAd,gCAAc;IAAd,kCAAc;IAAd,kCAAc;IAAd,iCAAc;IAAd;EAAc;AAAA;AAAd;EAAA,mBAAc;EAAd,wBAAc;EAAd,qBAAc;EAAd,wBAAc;EAAd,wBAAc;EAAd,4BAAc;EAAd,2BAAc;EAAd,aAAc;EAAd,aAAc;EAAd,aAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,uBAAc;EAAd,sBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,iBAAc;EAAd,iBAAc;EAAd,oBAAc;EAAd,yBAAc;EAAd,wBAAc;EAAd,0BAAc;EAAd,wBAAc;EAAd,gCAAc;EAAd,kCAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,iCAAc;EAAd;AAAc;AAAd;EAAA,kBAAc;EAAd,wBAAc;EAAd,qBAAc;EAAd,wBAAc;EAAd,wBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,2BAAc;EAAd,aAAc;EAAd,aAAc;EAAd,aAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,uBAAc;EAAd,sBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,iBAAc;EAAd,iBAAc;EAAd,oBAAc;EAAd,wBAAc;EAAd,sBAAc;EAAd,wBAAc;EAAd,iCAAc;EAAd,gCAAc;EAAd,kCAAc;EAAd,kCAAc;EAAd,iCAAc;EAAd;AAAc;AACd;EAAA;AAAoB;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA,aAAoB;EAApB,WAAoB;EAApB,mBAAoB;EAApB,yBAAoB;EAApB,mBAAoB;EAApB,qBAAoB;EAApB,SAAoB;EAApB,kBAAoB;EAApB,uCAAoB;EAApB,iBAAoB;EAApB,sBAAoB;EAApB,0EAAoB;EAApB,aAAoB;EAApB,oBAAoB;EAApB,iEAAoB;EAApB,iDAAoB;EAApB,qDAAoB;EAApB;AAAoB;AAApB;EAAA;IAAA,sBAAoB;IAApB,4CAAoB;IAApB,oBAAoB;IAApB;EAAoB;AAAA;AAApB;EAAA,aAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB,mBAAoB;EAApB,uBAAoB;EAApB,wJAAoB;EAApB,wDAAoB;EAApB,sDAAoB;EAApB,0BAAoB;EAApB,eAAoB;EAApB,mBAAoB;EAApB,oBAAoB;EAApB,kBAAoB;EAApB,sBAAoB;EAApB,uBAAoB;EAApB,2CAAoB;EAApB,iBAAoB;EAApB,sBAAoB;EAApB,0EAAoB;EAApB,kBAAoB;EAApB,0EAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA;IAAA,oBAAoB;IAApB;EAAoB;EAApB;;;IAAA,kBAAoB;IAApB,wEAAoB;IAApB,oBAAoB;IAApB;EAAoB;EAApB;IAAA,sBAAoB;IAApB;EAAoB;EAApB;IAAA,sBAAoB;IAApB;EAAoB;EAApB;IAAA,sBAAoB;IAApB;EAAoB;EAApB;IAAA,sBAAoB;IAApB;EAAoB;EAApB;IAAA;EAAoB;EAApB;;IAAA,kBAAoB;IAApB;EAAoB;EAApB;;IAAA,kBAAoB;IAApB;EAAoB;AAAA;AAApB;EAAA,kBAAoB;EAApB,aAAoB;EAApB,sBAAoB;EAApB;AAAoB;AAApB;EAAA,8BAAoB;EAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB,cAAoB;EAApB,sBAAoB;EAApB,kCAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,aAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,kBAAoB;EAApB,WAAoB;EAApB,WAAoB;EAApB,uCAAoB;EAApB,kBAAoB;EAApB,wEAAoB;EAApB;AAAoB;AAApB;;EAAA,oBAAoB;EAApB;AAAoB;AAApB;EAAA,YAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,WAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,cAAoB;EAApB,8CAAoB;EAApB,8CAAoB;EAApB,cAAoB;EAApB,aAAoB;EAApB,eAAoB;EAApB,gBAAoB;EAApB,yCAAoB;EAApB,iBAAoB;EAApB,0EAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,kBAAoB;EAApB,aAAoB;EAApB,gBAAoB;EAApB,mCAAoB;EAApB,mCAAoB;EAApB,WAAoB;EAApB;AAAoB;AAApB;;;;EAAA,oBAAoB;EAApB;AAAoB;AAApB;;EAAA,gBAAoB;EAApB;AAAoB;AAApB;;EAAA,YAAoB;EAApB,WAAoB;EAApB;AAAoB;AAApB;;;EAAA;AAAoB;AAApB;;EAAA;AAAoB;AAApB;;;;;EAAA,mBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,WAAoB;EAApB,qBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,8fAAoB;EAApB,gBAAoB;EAApB,8BAAoB;EAApB,kBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,aAAoB;EAApB,WAAoB;EAApB,gBAAoB;EAApB,cAAoB;EAApB,2BAAoB;EAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB,mBAAoB;EAApB,mBAAoB;EAApB,mBAAoB;EAApB,gBAAoB;EAApB,mBAAoB;EAApB,YAAoB;EAApB;AAAoB;AAApB;;EAAA,gBAAoB;EAApB,WAAoB;EAApB,YAAoB;EAApB,gBAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA,8BAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,kBAAoB;EAApB,UAAoB;EAApB,qBAAoB;EAApB,iBAAoB;EAApB,iBAAoB;EAApB,+LAAoB;EAApB,wJAAoB;EAApB,wDAAoB;EAApB,sDAAoB;EAApB;AAAoB;AAApB;;;EAAA,mBAAoB;EAApB;AAAoB;AAApB;EAAA;IAAA,mBAAoB;IAApB;EAAoB;EAApB;;IAAA,oBAAoB;IAApB,sBAAoB;IAApB,wEAAoB;IAApB,oBAAoB;IAApB,iEAAoB;IAApB;EAAoB;EAApB;IAAA,eAAoB;IAApB,eAAoB;IAApB;EAAoB;EAApB;IAAA,eAAoB;IAApB,8BAAoB;IAApB;EAAoB;EAApB;IAAA;MAAA;IAAoB;EAAA;EAApB;;IAAA,mBAAoB;IAApB,iEAAoB;IAApB;EAAoB;AAAA;AAApB;EAAA;AAAoB;AAApB;EAAA,aAAoB;EAApB,WAAoB;EAApB,mBAAoB;EAApB,kBAAoB;EAApB,gBAAoB;EAApB,eAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB,kBAAoB;EAApB;AAAoB;AAApB;EAAA;IAAA;EAAoB;EAApB;IAAA;EAAoB;AAAA;AAApB;EAAA,aAAoB;EAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB,yBAAoB;UAApB,iBAAoB;EAApB,mBAAoB;EAApB,8BAAoB;EAApB,qBAAoB;EAApB,sBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,UAAoB;EAApB,kBAAoB;EAApB,+LAAoB;EAApB;AAAoB;AAApB;EAAA,cAAoB;EAApB,gBAAoB;EAApB,YAAoB;EAApB,kBAAoB;EAApB,mBAAoB;EAApB,eAAoB;EAApB,cAAoB;EAApB,mBAAoB;EAApB,yCAAoB;EAApB,iBAAoB;EAApB,yBAAoB;EAApB,kBAAoB;EAApB;AAAoB;AAApB;;EAAA,iBAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,0BAAoB;EAApB,wBAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;;EAAA,0BAAoB;EAApB,wBAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;;EAAA,0BAAoB;EAApB;AAAoB;AAApB;;EAAA,gCAAoB;EAApB;AAAoB;AAApB;;EAAA,gCAAoB;EAApB;AAAoB;AAApB;;EAAA,0BAAoB;EAApB;AAAoB;AAApB;;EAAA,gCAAoB;EAApB;AAAoB;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA,eAAoB;EAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB,sBAAoB;EAApB,eAAoB;EAApB,mBAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,mBAAoB;EAApB,yBAAoB;EAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB,sBAAoB;EAApB,yBAAoB;EAApB,mBAAoB;EAApB,WAAoB;EAApB,6DAAoB;EAApB,yBAAoB;UAApB;AAAoB;AAApB;EAAA,mBAAoB;EAApB,yBAAoB;UAApB,iBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,kBAAoB;EAApB,aAAoB;EAApB,cAAoB;EAApB,sBAAoB;EAApB,eAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,oBAAoB;EAApB,eAAoB;EAApB,UAAoB;EAApB,WAAoB;EAApB,aAAoB;EAApB,YAAoB;EAApB,gBAAoB;EAApB,WAAoB;EAApB,eAAoB;EAApB,qBAAoB;EAApB,YAAoB;EAApB,UAAoB;EAApB,4BAAoB;EAApB,YAAoB;EAApB,6BAAoB;EAApB,cAAoB;EAApB,0BAAoB;EAApB,sDAAoB;EAApB,mDAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;;;;EAAA,oBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,WAAoB;EAApB,gBAAoB;EAApB,gBAAoB;EAApB,cAAoB;EAApB,uCAAoB;EAApB;AAAoB;AAApB;EAAA,cAAoB;EAApB,kBAAoB;EAApB,cAAoB;EAApB,aAAoB;EAApB,eAAoB;EAApB,gBAAoB;EAApB,qBAAoB;EAApB,iBAAoB;EAApB,0EAAoB;EAApB;AAAoB;AAApB;EAAA,cAAoB;EAApB,WAAoB;EAApB,eAAoB;EAApB,gBAAoB;EAApB,wBAAoB;EAApB,mDAAoB;EAApB,gBAAoB;EAApB,uCAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,oBAAoB;EAApB,eAAoB;EAApB,yBAAoB;UAApB,iBAAoB;EAApB,gBAAoB;EAApB,YAAoB;EAApB,gBAAoB;EAApB,0BAAoB;EAApB,0BAAoB;EAApB,mBAAoB;EAApB,oBAAoB;EAApB,cAAoB;EAApB,yCAAoB;EAApB,iBAAoB;EAApB,yBAAoB;EAApB,kBAAoB;EAApB,0EAAoB;EAApB;8DAAoB;EAApB;uCAAoB;EAApB;WAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,oBAAoB;EAApB,uCAAoB;EAApB,kBAAoB;EAApB,0EAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB,WAAoB;EAApB,qCAAoB;EAApB,gBAAoB;EAApB,0EAAoB;EAApB,wBAAoB;EAApB,oBAAoB;EAApB,qBAAoB;EAApB,iBAAoB;EAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB,gDAAoB;EAApB,2BAAoB;EAApB,6CAAoB;EAApB,4BAAoB;EAApB,mBAAoB;EAApB,kBAAoB;EAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB;AAAoB;AAApB;;;EAAA;AAAoB;AAApB;EAAA,kBAAoB;EAApB,iBAAoB;EAApB,oBAAoB;EAApB,YAAoB;EAApB,eAAoB;EAApB,yBAAoB;UAApB,iBAAoB;EAApB,gBAAoB;EAApB,eAAoB;EAApB,mBAAoB;EAApB,uBAAoB;EAApB,kBAAoB;EAApB,mBAAoB;EAApB,oBAAoB;EAApB,cAAoB;EAApB,mBAAoB;EAApB,sBAAoB;EAApB,kDAAoB;EAApB,+CAAoB;EAApB,yDAAoB;EAApB,uBAAoB;EAApB,8CAAoB;EAApB;AAAoB;AAApB;EAAA,WAAoB;EAApB,+BAAoB;EAApB;AAAoB;AAApB;EAAA,8BAAoB;EAApB;AAAoB;AAApB;EAAA,eAAoB;EAApB;AAAoB;AAApB;;EAAA;AAAoB;AAApB;EAAA,kBAAoB;EAApB,WAAoB;EAApB,uCAAoB;EAApB,gBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB,QAAoB;EAApB,UAAoB;EAApB,kBAAoB;EAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB,WAAoB;EAApB,UAAoB;EAApB,kBAAoB;EAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB,SAAoB;EAApB,UAAoB;EAApB,kBAAoB;EAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB,cAAoB;EAApB,kBAAoB;EAApB,mBAAoB;EAApB,mBAAoB;EAApB,sBAAoB;EAApB,mBAAoB;EAApB,oBAAoB;EAApB,cAAoB;EAApB,yCAAoB;EAApB,iBAAoB;EAApB,yBAAoB;EAApB,kBAAoB;EAApB;AAAoB;AAApB;EAAA,eAAoB;EAApB,aAAoB;EAApB,sBAAoB;EAApB,sBAAoB;EAApB,mBAAoB;EAApB,WAAoB;EAApB;AAAoB;AAApB;EAAA,cAAoB;EAApB,8CAAoB;EAApB,sBAAoB;EAApB,wDAAoB;EAApB,yBAAoB;EAApB,cAAoB;EAApB,WAAoB;EAApB,eAAoB;EAApB,gBAAoB;EAApB,2CAAoB;EAApB,iBAAoB;EAApB,0BAAoB;EAApB,8BAAoB;EAApB,8CAAoB;EAApB;oDAAoB;EAApB;;;AAAoB;AAApB;EAAA,qBAAoB;EAApB,kBAAoB;EAApB;AAAoB;AAApB;;EAAA,oBAAoB;EAApB,sBAAoB;EAApB,wEAAoB;EAApB,oBAAoB;EAApB,iEAAoB;EAApB;AAAoB;AAApB;EAAA,eAAoB;EAApB;AAAoB;AAApB;EAAA;IAAA;EAAoB;EAApB;IAAA;EAAoB;EAApB;IAAA;EAAoB;AAAA;AAApB;EAAA,gBAAoB;EAApB,kCAAoB;EAApB,gCAAoB;EAApB,8BAAoB;EAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB,gCAAoB;EAApB,8BAAoB;EAApB,gCAAoB;EAApB;AAAoB;AAApB;EAAA,+BAAoB;EAApB;AAAoB;AAApB;EAAA,iBAAoB;EAApB,sBAAoB;EAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB,mBAAoB;EAApB,WAAoB;EAApB,kBAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,oBAAoB;EAApB,kBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA,iBAAoB;EAApB,mBAAoB;EAApB,yBAAoB;EAApB,kBAAoB;EAApB,0EAAoB;EAApB;AAAoB;AAApB;;EAAA,4BAAoB;EAApB,0DAAoB;EAApB,8BAAoB;EAApB;;;;;;;;;;;AAAoB;AAApB;EAAA,kBAAoB;EAApB,0EAAoB;EAApB,4BAAoB;EAApB,0DAAoB;EAApB;;;AAAoB;AAApB;EAAA;IAAA;EAAoB;EAApB;IAAA;EAAoB;EAApB;IAAA;EAAoB;AAAA;AAApB;EAAA;AAAoB;AAApB;EAAA,kBAAoB;EAApB,cAAoB;EAApB,8BAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,oBAAoB;EAApB,kBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;;;EAAA,oBAAoB;EAApB,kBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;;;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;;;EAAA,aAAoB;EAApB,wBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;;;;;EAAA,oBAAoB;EAApB;;AAAoB;AAApB;;;;;EAAA,sBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;;;;;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;;;EAAA,eAAoB;EAApB,eAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,wEAAoB;EAApB;AAAoB;AAApB;EAAA,8BAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;;EAAA,gBAAoB;EAApB,qDAAoB;EAApB,oBAAoB;EAApB,kBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;;;;EAAA,mBAAoB;EAApB,sBAAoB;EAApB,0EAAoB;EAApB,kBAAoB;EAApB,0EAAoB;EAApB;AAAoB;AAApB;;;;EAAA,wEAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,eAAoB;EAApB,kBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,8BAAoB;EAApB;AAAoB;AAApB;EAAA,+BAAoB;EAApB;AAAoB;AAApB;EAAA,+BAAoB;EAApB,gCAAoB;EAApB,8BAAoB;EAApB,wBAAoB;EAApB,yCAAoB;EAApB,0BAAoB;EAApB,iCAAoB;EAApB,gCAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB,qBAAoB;EAApB,mBAAoB;EAApB,aAAoB;EAApB,8BAAoB;EAApB,eAAoB;EAApB,sBAAoB;EAApB,qBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,kBAAoB;EAApB,0EAAoB;EAApB,YAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,eAAoB;EAApB,uBAAoB;EAApB,YAAoB;EAApB,UAAoB;EAApB,kBAAoB;EAApB,0EAAoB;EAApB,YAAoB;EAApB;AAAoB;AAApB;;EAAA,yCAAoB;EAApB,kBAAoB;EAApB,mBAAoB;EAApB,mBAAoB;EAApB,sBAAoB;EAApB,iBAAoB;EAApB,wJAAoB;EAApB,wDAAoB;EAApB,sDAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,eAAoB;EAApB,yDAAoB;EAApB,oBAAoB;EAApB,iEAAoB;EAApB,8BAAoB;EAApB;AAAoB;AAApB;;;EAAA,kBAAoB;EAApB,wEAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;;EAAA,iBAAoB;EAApB,cAAoB;EAApB,mBAAoB;EAApB,cAAoB;EAApB,aAAoB;EAApB,wBAAoB;EAApB,0CAAoB;EAApB,yBAAoB;EAApB,wDAAoB;EAApB,WAAoB;EAApB,yBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;;EAAA,yBAAoB;EAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,iBAAoB;EAApB,kBAAoB;EAApB,cAAoB;EAApB,eAAoB;EAApB,YAAoB;EAApB,gBAAoB;EAApB,uBAAoB;EAApB,mBAAoB;EAApB,kBAAoB;EAApB,0EAAoB;EAApB,kBAAoB;EAApB;AAAoB;AAApB;EAAA,WAAoB;EAApB,kBAAoB;EAApB,YAAoB;EAApB,QAAoB;EAApB,mBAAoB;EAApB,eAAoB;EAApB,sBAAoB;EAApB,+LAAoB;EAApB,qBAAoB;EAApB,iBAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,WAAoB;EAApB,kBAAoB;EAApB,aAAoB;EAApB,QAAoB;EAApB,cAAoB;EAApB,qBAAoB;EAApB,mBAAoB;EAApB,+LAAoB;EAApB,qBAAoB;EAApB,iBAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;;EAAA,uBAAoB;EAApB;AAAoB;AAApB;;;;EAAA,qBAAoB;EAApB,eAAoB;EAApB,eAAoB;EAApB;AAAoB;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA,uCAAoB;EAApB;AAAoB;AAApB;EAAA,uDAAoB;EAApB;;;;;;GAAoB;EAApB,qBAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,uCAAoB;EAApB;AAAoB;AAApB;EAAA,uCAAoB;EAApB;AAAoB;AAApB;EAAA,6BAAoB;EAApB;;;;;;GAAoB;EAApB,qBAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;AAAoB;AAApB;EAAA,oBAAoB;EAApB,kBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;;EAAA,kBAAoB;EAApB,0EAAoB;EAApB,sBAAoB;EAApB,0DAAoB;EAApB;;AAAoB;AAApB;EAAA,kBAAoB;EAApB,sBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;;EAAA,sBAAoB;EAApB,0EAAoB;EAApB,kBAAoB;EAApB,0EAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,sBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;;EAAA,sBAAoB;EAApB,0EAAoB;EAApB,kBAAoB;EAApB,0EAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,sBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;;EAAA,sBAAoB;EAApB,0EAAoB;EAApB,kBAAoB;EAApB,0EAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,sBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;;EAAA,sBAAoB;EAApB,0EAAoB;EAApB,kBAAoB;EAApB,0EAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,mBAAoB;EAApB;AAAoB;AAApB;EAAA;IAAA;;EAAoB;EAApB;IAAA;;EAAoB;EAApB;IAAA;;EAAoB;AAAA;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,cAAoB;EAApB,WAAoB;EAApB,uCAAoB;EAApB;AAAoB;AAApB;EAAA,cAAoB;EAApB,WAAoB;EAApB,uCAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,cAAoB;EAApB,aAAoB;EAApB,uCAAoB;EAApB,kBAAoB;EAApB,kBAAoB;EAApB,0EAAoB;EAApB,gBAAoB;EAApB,wBAAoB;EAApB,QAAoB;EAApB,wBAAoB;EAApB,2BAAoB;EAApB,qBAAoB;EAApB,uBAAoB;EAApB;;;AAAoB;AAApB;EAAA,kBAAoB;EAApB,cAAoB;EAApB,aAAoB;EAApB,uCAAoB;EAApB,kBAAoB;EAApB,kBAAoB;EAApB,0EAAoB;EAApB,QAAoB;EAApB,wBAAoB;EAApB,qBAAoB;EAApB,uBAAoB;EAApB;;;AAAoB;AAApB;EAAA;IAAA;EAAoB;EAApB;IAAA;EAAoB;EAApB;IAAA;EAAoB;AAAA;AAApB;EAAA;AAAoB;AAApB;EAAA,gBAAoB;EAApB,qDAAoB;EAApB,oBAAoB;EAApB,kBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;;;EAAA,mBAAoB;EAApB,sBAAoB;EAApB,0EAAoB;EAApB,kBAAoB;EAApB,0EAAoB;EAApB;AAAoB;AAApB;;;EAAA,wEAAoB;EAApB;AAAoB;AAApB;;;EAAA,sBAAoB;EAApB;AAAoB;AAApB;EAAA;;AAAoB;AAApB;EAAA,uCAAoB;EAApB,kBAAoB;EAApB,0EAAoB;EAApB,gCAAoB;EAApB,6CAAoB;EAApB;;;;;;;GAAoB;EAApB,0BAAoB;EAApB,4BAAoB;EAApB;AAAoB;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;EAApB;IAAA;EAAoB;AAAA;AAApB;EAAA,wBAAoB;EAApB,0DAAoB;EAApB,mEAAoB;EAApB,wBAAoB;EAApB,kEAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,QAAoB;EAApB,oBAAoB;EAApB,iBAAoB;EAApB,cAAoB;EAApB,WAAoB;EAApB,+LAAoB;EAApB,kBAAoB;EAApB,0EAAoB;EAApB,oBAAoB;EAApB,iEAAoB;EAApB,WAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,uBAAoB;EAApB,UAAoB;EAApB,kBAAoB;EAApB,oBAAoB;EAApB,iBAAoB;EAApB,aAAoB;EAApB,YAAoB;EAApB,WAAoB;EAApB,mBAAoB;EAApB,kBAAoB;EAApB,qBAAoB;EAApB,kBAAoB;EAApB,0EAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,wBAAoB;EAApB;AAAoB;AAApB;EAAA,0EAAoB;EAApB,sBAAoB;EAApB;AAAoB;AAApB;EAAA,8BAAoB;EAApB;AAAoB;AAApB;EAAA,+BAAoB;EAApB;AAAoB;AAApB;;EAAA,mBAAoB;EAApB,iEAAoB;EAApB;AAAoB;AAApB;EAAA,0EAAoB;EAApB,wBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA,gDAAoB;EAApB,0CAAoB;EAApB,oDAAoB;EAApB,kDAAoB;EAApB,4CAAoB;EAApB,8CAAoB;EAApB,4CAAoB;EAApB;AAAoB;AAApB;EAAA,+BAAoB;EAApB,oFAAoB;EAApB,kDAAoB;EAApB,gDAAoB;EAApB,yCAAoB;EAApB,6EAAoB;EAApB,2EAAoB;EAApB,sCAAoB;EAApB;AAAoB;AAApB;EAAA,UAAoB;EAApB,WAAoB;EAApB,cAAoB;EAApB,kBAAoB;EAApB,iDAAoB;EAApB,iCAAoB;EAApB,SAAoB;EAApB,0CAAoB;EAApB;iBAAoB;EAApB,4BAAoB;EAApB,8CAAoB;EAApB;;;;;;OAAoB;EAApB;;;;;;OAAoB;EAApB;AAAoB;AAApB;EAAA,mCAAoB;EAApB;AAAoB;AAApB;EAAA,qCAAoB;EAApB;AAAoB;AAApB;EAAA,qCAAoB;EAApB;AAAoB;AAApB;EAAA,mCAAoB;EAApB;AAAoB;AAApB;;;;EAAA,mCAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,kBAAoB;EAApB,mBAAoB;EAApB,oBAAoB;EAApB,uBAAoB;EAApB;AAAoB;AAApB;;;EAAA,kBAAoB;EAApB;AAAoB;AAApB;;;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA,wBAAoB;EAApB,sBAAoB;EAApB;AAAoB;AAApB;EAAA,mBAAoB;EAApB,kBAAoB;EAApB,iBAAoB;EAApB,gBAAoB;EAApB;AAAoB;AAApB;EAAA,qBAAoB;EAApB,sBAAoB;EAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB,qDAAoB;EAApB,oBAAoB;EAApB,kBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;;;EAAA,mBAAoB;EAApB,sBAAoB;EAApB,0EAAoB;EAApB,kBAAoB;EAApB,0EAAoB;EAApB;AAAoB;AAApB;;;EAAA,wEAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;IAAA,qBAAoB;IAApB;EAAoB;EAApB;IAAA,mBAAoB;IAApB;EAAoB;AAAA;AAApB;EAAA;AAAoB;AAApB;EAAA,oBAAoB;EAApB,kBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;;EAAA,sBAAoB;EAApB,6CAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,oBAAoB;EAApB,iEAAoB;EAApB;;;AAAoB;AAApB;EAAA;;;AAAoB;AAApB;EAAA,mBAAoB;EAApB,sBAAoB;EAApB,0EAAoB;EAApB,6BAAoB;EAApB,YAAoB;EAApB;;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,YAAoB;EAApB,qBAAoB;EAApB,wBAAoB;EAApB,QAAoB;EAApB,sBAAoB;EAApB,qBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,uBAAoB;EAApB,sBAAoB;EAApB;AAAoB;AAApB;EAAA,qBAAoB;EAApB;AAAoB;AAApB;EAAA,qBAAoB;EAApB,uBAAoB;EAApB,sBAAoB;EAApB;AAAoB;AAApB;EAAA,qBAAoB;EAApB;AAAoB;AAApB;EAAA,qBAAoB;EAApB,wBAAoB;EAApB,qBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB;AAAoB;AAApB;EAAA,WAAoB;EAApB,SAAoB;EAApB,qBAAoB;EAApB;AAAoB;AAApB;EAAA,WAAoB;EAApB,QAAoB;EAApB,sBAAoB;EAApB;AAAoB;AAApB;EAAA,YAAoB;EAApB,QAAoB;EAApB,sBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;;EAAA,0BAAoB;EAApB,wBAAoB;EAApB,kCAAoB;EAApB;AAAoB;AAApB;;EAAA,4BAAoB;EAApB,0BAAoB;EAApB,gCAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;;EAAA,wBAAoB;EAApB,0BAAoB;EAApB,gCAAoB;EAApB;AAAoB;AAApB;;EAAA,0BAAoB;EAApB,4BAAoB;EAApB,8BAAoB;EAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB,gDAAoB;EAApB,6CAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB,gDAAoB;EAApB;AAAoB;AAApB;EAAA,YAAoB;EAApB,mBAAoB;EAApB,oBAAoB;EAApB,cAAoB;EAApB;AAAoB;AAApB;EAAA,YAAoB;EAApB,mBAAoB;EAApB,oBAAoB;EAApB,cAAoB;EAApB;AAAoB;AAApB;EAAA,cAAoB;EAApB,mBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA,eAAoB;EAApB,kBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA,WAAoB;EAApB,qBAAoB;EAApB,wBAAoB;EAApB,SAAoB;EAApB,qBAAoB;EAApB,qBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,uBAAoB;EAApB,qBAAoB;EAApB;AAAoB;AAApB;EAAA,qBAAoB;EAApB,uBAAoB;EAApB,sBAAoB;EAApB;AAAoB;AAApB;EAAA,qBAAoB;EAApB;AAAoB;AAApB;EAAA,qBAAoB;EAApB,wBAAoB;EAApB,qBAAoB;EAApB;AAAoB;AAApB;EAAA,WAAoB;EAApB,SAAoB;EAApB,qBAAoB;EAApB;AAAoB;AAApB;EAAA,YAAoB;EAApB,QAAoB;EAApB,sBAAoB;EAApB;AAAoB;AAApB;EAAA,YAAoB;EAApB,QAAoB;EAApB,qBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,qBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,oBAAoB;EAApB,UAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,2BAAoB;EAApB,SAAoB;EAApB,SAAoB;EAApB,WAAoB;EAApB;AAAoB;AAApB;EAAA,WAAoB;EAApB,kBAAoB;EAApB,WAAoB;EAApB,cAAoB;EAApB,qBAAoB;EAApB,kBAAoB;EAApB,0EAAoB;EAApB,oBAAoB;EAApB,kBAAoB;EAApB,oDAAoB;EAApB,UAAoB;EAApB,WAAoB;EAApB,OAAoB;EAApB;AAAoB;AAApB;EAAA,WAAoB;EAApB,kBAAoB;EAApB,WAAoB;EAApB,cAAoB;EAApB,qBAAoB;EAApB,kBAAoB;EAApB,0EAAoB;EAApB,oBAAoB;EAApB,kBAAoB;EAApB,oDAAoB;EAApB,UAAoB;EAApB,WAAoB;EAApB,OAAoB;EAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,kCAAoB;EAApB,eAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,gBAAoB;EAApB,iBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,eAAoB;EAApB,kBAAoB;EAApB;AAAoB;AAApB;EAAA,iDAAoB;EAApB;AAAoB;AAApB;EAAA,4BAAoB;EAApB,2BAAoB;EAApB;AAAoB;AAApB;EAAA,cAAoB;EAApB,WAAoB;EAApB,qBAAoB;EAApB,qBAAoB;EAApB,+LAAoB;EAApB,WAAoB;EAApB;AAAoB;AAApB;EAAA,qBAAoB;EAApB;AAAoB;AAApB;EAAA,WAAoB;EAApB,+BAAoB;EAApB,wBAAoB;EAApB,gBAAoB;EAApB;AAAoB;AAApB;EAAA,YAAoB;EAApB,aAAoB;EAApB,sBAAoB;EAApB,sBAAoB;EAApB,+LAAoB;EAApB;AAAoB;AAApB;EAAA,qBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,qBAAoB;EAApB,kBAAoB;EAApB,yBAAoB;EAApB,oDAAoB;EAApB,2DAAoB;EAApB;AAAoB;AAApB;;EAAA,UAAoB;EAApB,wJAAoB;EAApB,uBAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,WAAoB;EAApB,mBAAoB;EAApB,oCAAoB;EAApB,QAAoB;EAApB,SAAoB;EAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB,mBAAoB;EAApB,sBAAoB;EAApB,oBAAoB;EAApB,qBAAoB;EAApB,oBAAoB;EAApB,uBAAoB;EAApB,mBAAoB;EAApB,oBAAoB;EAApB,sCAAoB;EAApB,gCAAoB;EAApB;AAAoB;AAApB;EAAA,UAAoB;EAApB;AAAoB;AAApB;EAAA,UAAoB;EAApB;AAAoB;AAApB;EAAA,UAAoB;EAApB;AAAoB;AAApB;EAAA,UAAoB;EAApB;AAAoB;AAApB;;EAAA,UAAoB;EAApB;AAAoB;AAApB;;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA,2BAAoB;EAApB,sEAAoB;EAApB,SAAoB;EAApB,SAAoB;EAApB,WAAoB;EAApB;AAAoB;AACpB;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,cAAmB;EAAnB;AAAmB;AAAnB;EAAA,aAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAEjB;IACE,UAAU;IACV,WAAW;EACb;AAEA;IACE,oBAAoB;IACpB,8BAA8B;EAChC;AAEA;IACE,8BAA8B;IAC9B,oBAAoB;IACpB,sBAAsB;EACxB;AAEA;IACE,gBAAgB;EAClB;;AAGF;EACE,qCAAqC;AAEvC;;AADE;IAAA,UAAgB;IAAhB,WAAgB;EAAA;;AAAhB;IAAA,oBAAgB;IAAhB,8BAAgB;EAAA;;AAAhB;IAAA,8BAAgB;IAAhB,oBAAgB;IAAhB,sBAAgB;EAAA;;AAAhB;IAAA,gBAAgB;EAAA;;AAIhB;EAAA,kBAAkB;EAAlB;AAAkB;;AAIlB;EAAA,kBAAiB;EAAjB;AAAiB;;AAIjB;EAAA,kBAAkB;EAAlB;AAAkB;;AAGpB;EACE,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,8BAA8B;AAChC;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B;;AAME;;;;EAAA,YAAmG;EAAnG,WAAmG;EAAnG,kBAAmG;EAAnG,iBAAmG;EAAnG,sBAAmG;EAAnG,4DAAmG;EAAnG;AAAmG;;AAAnG;;;;EAAA,oBAAmG;EAAnG;AAAmG;;AAGrG;;;;;EAKE,aAAa;EACb,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,oCAAoC;AACtC;;AAOE;;;;;EAAA,YAAgJ;EAAhJ,WAAgJ;EAAhJ,kBAAgJ;EAAhJ,iBAAgJ;EAAhJ,sBAAgJ;EAAhJ,4DAAgJ;EAAhJ;AAAgJ;;AAAhJ;;;;;EAAA,eAAgJ;EAAhJ,gBAAgJ;EAAhJ,oBAAgJ;EAAhJ;AAAgJ;;AAIhJ;EAAA,YAAqK;EAArK,WAAqK;EAArK,uCAAqK;EAArK,0CAAqK;EAArK,uCAAqK;EAArK,0CAAqK;EAArK,iBAAqK;EAArK,sBAAqK;EAArK,4DAAqK;EAArK;AAAqK;;AAArK;EAAA,eAAqK;EAArK,gBAAqK;EAArK,oBAAqK;EAArK;AAAqK;;AAIrK;EAAA,YAAiJ;EAAjJ,WAAiJ;EAAjJ,6BAAiJ;EAAjJ,iBAAiJ;EAAjJ,sBAAiJ;EAAjJ,4DAAiJ;EAAjJ;AAAiJ;;AAAjJ;EAAA,eAAiJ;EAAjJ,gBAAiJ;EAAjJ,oBAAiJ;EAAjJ;AAAiJ;;AAIjJ;EAAA,YAAqO;EAArO,YAAqO;EAArO,4BAAqO;EAArO,iCAAqO;EAArO,uEAAqO;EAArO,4BAAqO;EAArO,eAAqO;EAArO,gBAAqO;EAArO,oBAAqO;EAArO,iDAAqO;EAArO,8BAAqO;EAArO;AAAqO;;AAArO;EAAA,eAAqO;EAArO,gBAAqO;EAArO,oBAAqO;EAArO;AAAqO;;AAArO;EAAA;IAAA;EAAqO;AAAA;;AAArO;EAAA;IAAA;EAAqO;AAAA;;AAArO;EAAA;IAAA;EAAqO;AAAA;;AAIrO;EAAA,iBAAkE;EAAlE,sBAAkE;EAAlE,4DAAkE;EAAlE,eAAkE;EAAlE,gBAAkE;EAAlE,oBAAkE;EAAlE;AAAkE;;AAGpE;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,yDAAiD;EACjD,wBAAwB;EACxB,sBAAsB;EACtB,iBAAiB;AACnB;;AAGE;EAAA,kBAAuF;EAAvF,kBAAuF;EAAvF,0DAAuF;EAAvF,kBAAuF;EAAvF,mBAAuF;EAAvF,iBAAuF;EAAvF,oBAAuF;EAAvF,eAAuF;EAAvF,gBAAuF;EAAvF,oBAAuF;EAAvF;AAAuF;;AAIvF;EAAA,kBAAuF;EAAvF,kBAAuF;EAAvF,yDAAuF;EAAvF,kBAAuF;EAAvF,mBAAuF;EAAvF,iBAAuF;EAAvF,oBAAuF;EAAvF,eAAuF;EAAvF,gBAAuF;EAAvF,oBAAuF;EAAvF;AAAuF;;AAIvF;EAAA,eAAyF;EAAzF,gBAAyF;EAAzF,oBAAyF;EAAzF;AAAyF;;AAAzF;EAAA;IAAA;EAAyF;AAAA;;AAAzF;EAAA;IAAA;EAAyF;AAAA;;AAAzF;EAAA;IAAA;EAAyF;AAAA;;AAIzF;EAAA,eAAyF;EAAzF,gBAAyF;EAAzF,oBAAyF;EAAzF;AAAyF;;AAAzF;EAAA;IAAA;EAAyF;AAAA;;AAAzF;EAAA;IAAA;EAAyF;AAAA;;AAAzF;EAAA;IAAA;EAAyF;AAAA;;AAIzF;EAAA,eAA4C;EAA5C,gBAA4C;EAA5C,oBAA4C;EAA5C;AAA4C;;AAI5C;EAAA,eAA6B;EAA7B;AAA6B;;AAM7B;;;EAAA,eAA6B;EAA7B;AAA6B;;AAI7B;EAAA,eAA0E;EAA1E;AAA0E;;AAA1E;EAAA;IAAA;EAA0E;AAAA;;AAA1E;EAAA;IAAA;EAA0E;AAAA;;AAA1E;EAAA;IAAA;EAA0E;AAAA;;AAI1E;EAAA,eAA0E;EAA1E;AAA0E;;AAA1E;EAAA;IAAA;EAA0E;AAAA;;AAA1E;EAAA;IAAA;EAA0E;AAAA;;AAA1E;EAAA;IAAA;EAA0E;AAAA;;AAI1E;EAAA,eAA6B;EAA7B;AAA6B;;AAI7B;EAAA,eAA6B;EAA7B;AAA6B;;AAI7B;EAAA,eAA6B;EAA7B;AAA6B;;AAI7B;EAAA,eAA4C;EAA5C,gBAA4C;EAA5C,oBAA4C;EAA5C;AAA4C;;AAI5C;EAAA,iBAAuC;EAAvC,kBAAuC;EAAvC,eAAuC;EAAvC,kBAAuC;EAAvC,iBAAuC;EAAvC,oBAAuC;EAAvC;AAAuC;;AAGzC;EAEI;IAAA,kBAAW;IAAX;EAAW;AAEf;;AAGE;EAAA,eAA4C;EAA5C;AAA4C;;AAA5C;EAAA;IAAA;EAA4C;AAAA;;AAG9C;EACE,mDAA2C;EAC3C,wBAAwB;EACxB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,mDAA4C;EAC5C,wBAAwB;EACxB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,OAAO;EACP,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,UAAU;AACZ;;AAME;;;;EAAA,YAA2J;EAA3J,WAA2J;EAA3J,kBAA2J;EAA3J,iBAA2J;EAA3J,sBAA2J;EAA3J,4DAA2J;EAA3J;AAA2J;;AAA3J;;;;EAAA,eAA2J;EAA3J,gBAA2J;EAA3J,oBAA2J;EAA3J;AAA2J;;AAA3J;EAAA;;;;IAAA;EAA2J;AAAA;;AAI3J;EAAA;AAAwB;;AAIxB;EAAA,YAA2J;EAA3J,WAA2J;EAA3J,kBAA2J;EAA3J,iBAA2J;EAA3J,sBAA2J;EAA3J,4DAA2J;EAA3J;AAA2J;;AAA3J;EAAA,eAA2J;EAA3J,gBAA2J;EAA3J,oBAA2J;EAA3J;AAA2J;;AAA3J;EAAA;IAAA;EAA2J;AAAA;;AAI3J;EAAA,gBAA2B;EAA3B,aAA2B;EAA3B;AAA2B;;AAG7B;;EAEE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,cAAc;EACd,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,WAAW;AACb;;AAEA;;;;;;;4BAO4B;AAC5B,iBAAiB;AACjB,gCAAgC;AAChC,sBAAsB;AACtB,oCAAoC;AACpC,yDAAyD;AACzD,MAAM;;AAEN;;;GAGG;AACH;EACE,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,WAAW,EAAE,yCAAyC;EACtD,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,WAAW;EACX,6DAA6D;EAC7D,0BAA0B;EAC1B,0CAA0C;EAC1C,sBAAsB;AACxB;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,+CAA+C;EAC/C,UAAU;AACZ;;AA3ZA;EAAA,oBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA;AA4ZA;;AA5ZA;EAAA,kBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,kBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,kBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,0BA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,yBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,kBA4ZA;EA5ZA,kBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,iBA4ZA;EA5ZA,iBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,sBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,sBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,sBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,sBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,sBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,kBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,kBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,kBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,kBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,kBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA;AA4ZA;;AA5ZA;EAAA;AA4ZA;;AA5ZA;EAAA;AA4ZA;;AA5ZA;EAAA,kBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,kBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,kBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,kBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,kBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,kBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,kBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,kBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,kBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,kBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,kBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,kBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,kBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,kBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,kBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,kBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,kBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,kBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,kBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,kBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,kBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,kBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA;AA4ZA;;AA5ZA;EAAA,kBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,kBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,kBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,kBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,kBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,kBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,kBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,kBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,kBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,kBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,kBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,kBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,kBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,kBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,kBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,kBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,kBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,kBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,kBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,kBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,kBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,kBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,kBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,kBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,kBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA;AA4ZA;;AA5ZA;EAAA,kBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,kBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,kBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,4DA4ZA;EA5ZA,mEA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,4DA4ZA;EA5ZA,oEA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA;AA4ZA;;AA5ZA;EAAA;AA4ZA;;AA5ZA;EAAA,oBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,oBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,oBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,oBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,oBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,oBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,oBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,oBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,oBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,oBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,oBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,oBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,oBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,oBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,oBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,oBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,oBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,oBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,oBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,oBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,oBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,oBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA;AA4ZA;;AA5ZA;EAAA;AA4ZA;;AA5ZA;EAAA;AA4ZA;;AA5ZA;EAAA;AA4ZA;;AA5ZA;EAAA,+EA4ZA;EA5ZA,mGA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,6EA4ZA;EA5ZA,iGA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,gFA4ZA;EA5ZA,oGA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,sCA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA;AA4ZA;;AA5ZA;EAAA,kBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,kBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA;AA4ZA;;AA5ZA;EAAA,sBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,sBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,sBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,sBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,sBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,sBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA;AA4ZA;;AA5ZA;EAAA,oBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,2BA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,8BA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA;AA4ZA;;AA5ZA;EAAA,2GA4ZA;EA5ZA,yGA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,2GA4ZA;EA5ZA,yGA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,2GA4ZA;EA5ZA,yGA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,2GA4ZA;EA5ZA,yGA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,oBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,oBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,oBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,oBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,oBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,oBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,oBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,oBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA;AA4ZA;;AA5ZA;EAAA;AA4ZA;;AA5ZA;EAAA;AA4ZA;;AA5ZA;EAAA,sBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA;AA4ZA;;AA5ZA;EAAA;AA4ZA;;AA5ZA;EAAA;AA4ZA;;AA5ZA;EAAA;AA4ZA;;AA5ZA;EAAA;AA4ZA;;AA5ZA;EAAA,kBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA;AA4ZA;;AA5ZA;EAAA;AA4ZA;;AA5ZA;EAAA;AA4ZA;;AA5ZA;EAAA,kBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA;AA4ZA;;AA5ZA;EAAA;AA4ZA;;AA5ZA;EAAA,sBA4ZA;EA5ZA,8BA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,kBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA,oBA4ZA;EA5ZA;AA4ZA;;AA5ZA;EAAA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA,gBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,kBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,gBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA,uBA4ZA;IA5ZA,2DA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,gBA4ZA;IA5ZA,uBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA,qBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,oBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,kBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,mBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,oBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,iBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,kBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,iBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,iBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,iBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA,4BA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA,6BA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,iBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,mBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,eA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA,eA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,mBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,kBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,kBA4ZA;IA5ZA;EA4ZA;AAAA;;AA5ZA;EAAA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA,qBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA,uBA4ZA;IA5ZA,2DA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,uBA4ZA;IA5ZA,8DA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA,kBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,kBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,iBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,iBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,gBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA,mBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,kBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA;EA4ZA;AAAA;;AA5ZA;EAAA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA,iBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA,qBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA,uBA4ZA;IA5ZA,oDA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA,sBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,qBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,kBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,mBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,mBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,kBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,kBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,kBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,mBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,kBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,iBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,iBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,iBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,iBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;AAAA;;AA5ZA;EAAA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;AAAA;;AA5ZA;EAAA;IAAA;EA4ZA;EA5ZA;IAAA;EA4ZA;AAAA;;AA5ZA;EAAA;AA4ZA;;AA5ZA;EAAA;AA4ZA;;AA5ZA;EAAA;IAAA,sBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA;EA4ZA;EA5ZA;IAAA,sBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,sBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,sBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,sBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,sBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,sBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,kBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,kBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,kBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,kBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,kBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,oBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,oBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,oBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,oBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,oBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,oBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,oBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,oBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,2BA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,2BA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,kBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,kBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,kBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,sBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,kBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,sBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,kBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,kBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,sBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,oBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA,oBA4ZA;IA5ZA;EA4ZA;EA5ZA;IAAA;EA4ZA;AAAA","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Montserrat:wght@100;200;300;400;500;600;700;800;900&display=swap\");\n@import \"flatpickr/dist/flatpickr.min.css\";\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n@layer utilities {\n  .scrollbar::-webkit-scrollbar {\n    width: 3px;\n    height: 3px;\n  }\n\n  .scrollbar::-webkit-scrollbar-track {\n    border-radius: 100vh;\n    background: rgb(180, 177, 177);\n  }\n\n  .scrollbar::-webkit-scrollbar-thumb {\n    background: rgb(180, 177, 177);\n    border-radius: 100vh;\n    border: 1px solid gray;\n  }\n\n  .scrollbar::-webkit-scrollbar-thumb:hover {\n    background: gray;\n  }\n}\n\n* {\n  font-family: \"Montserrat\", sans-serif;\n  @apply scrollbar;\n}\n\n.safety-item:nth-child(even) {\n  @apply bg-gray-100;\n}\n\n.safety-item:nth-child(odd) {\n  @apply bg-gray-50;\n}\n\n.safety-item:hover {\n  @apply bg-blue-100;\n}\n\n.input-logo {\n  position: absolute;\n  top: 50%;\n  left: 5%;\n  transform: translate(0%, -50%);\n}\n\n.password-input-logo {\n  position: absolute;\n  top: 50%;\n  right: 5%;\n  transform: translate(0%, -50%);\n}\n\ninput[type=\"number\"]::-webkit-outer-spin-button,\ninput[type=\"number\"]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\ninput[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n\ninput[type=\"text\"],\ninput[type=\"email\"],\ninput[type=\"number\"],\ninput[type=\"password\"] {\n  @apply border-2 border-[#CCCCCC] pl-[40px] w-[100%] h-[50px] rounded-[5px] placeholder:text-[black];\n}\n\ninput[type=\"text\"]:focus,\ninput[type=\"email\"]:focus,\ninput[type=\"number\"]:focus,\ninput[type=\"date\"]:focus,\ninput[type=\"password\"]:focus {\n  outline: none;\n  border: 2px solid #0072bb !important;\n}\n\ninput[type=\"text\"].project-name-input:focus {\n  outline: none;\n  border: 1px solid #cccccc !important;\n}\n\ninput[type=\"text\"].input-without-icon,\ninput[type=\"email\"].input-without-icon,\ninput[type=\"number\"].input-without-icon,\ninput[type=\"date\"].input-without-icon,\ninput[type=\"password\"].input-without-icon {\n  @apply border border-[#CCCCCC] pl-[20px] w-[100%] h-[50px] rounded-[5px] placeholder:text-[black] placeholder:text-[14px] placeholder:font-[400];\n}\n\ninput[type=\"text\"].popup-input {\n  @apply border border-[#CCCCCC] pl-[20px] w-[100%] h-[50px] !rounded-l-[10px] !rounded-r-[0px] placeholder:text-[black] placeholder:text-[14px] placeholder:font-[400];\n}\n\ninput[type=\"text\"].custom-search {\n  @apply border border-[#CCCCCC] pl-[40px] w-[100%] h-[50px] !rounded-[5px] placeholder:text-[black] placeholder:text-[14px] placeholder:font-[400];\n}\n\ninput[type=\"text\"].project-name-input {\n  @apply outline-none !border !border-[#CCCCCC] !pl-[0px] w-[300px] h-[50px] placeholder:text-[black] placeholder:text-[20px] placeholder:font-[400] text-[20px] md:text-[25px] lg:text-[28px] xl:text-[30px] font-[700] text-[#0072BB];\n}\n\ntextarea {\n  @apply border border-[#CCCCCC] text-[black] text-[14px] font-[400];\n}\n\n.step-one::after {\n  content: \"\";\n  width: 100px;\n  height: 1px;\n  position: absolute;\n  z-index: 100;\n  left: 100%;\n  background-color: #0072bb;\n}\n\n.custom-bg {\n  background-image: url(\"../../public/side-bg.jpg\");\n  height: 100vh !important;\n  width: 100% !important;\n  object-fit: cover;\n}\n\nbutton[type=\"submit\"] {\n  @apply bg-[#0072BB] text-[16px] font-[600] px-[18px] py-[10px] text-white rounded-[5px];\n}\n\nbutton[type=\"submit\"]:disabled {\n  @apply bg-[#36454F] text-[16px] font-[600] px-[18px] py-[10px] text-white rounded-[5px];\n}\n\n.page-text {\n  @apply text-[20px] md:text-[25px] lg:text-[28px] xl:text-[30px] font-[700] text-[#FFFFFF];\n}\n\n.title-text {\n  @apply text-[20px] md:text-[25px] lg:text-[28px] xl:text-[30px] font-[700] text-[#0072BB];\n}\n\n.normal-text {\n  @apply text-[#212121] text-[16px] font-[500];\n}\n\n.service-description {\n  @apply text-[16px] font-[500];\n}\n\n.service-title,\n.faqs-title,\n.page-subtitle {\n  @apply text-[16px] font-[500];\n}\n\n.medium-title {\n  @apply text-[15px] md:text-[17px] lg:text-[19px] xl:text-[20px] font-[700];\n}\n\n.medium-lite-title {\n  @apply text-[15px] md:text-[17px] lg:text-[19px] xl:text-[15px] font-[500];\n}\n\n.button-text {\n  @apply text-[16px] font-[600];\n}\n\n.footer-text {\n  @apply text-[16px] font-[400];\n}\n\n.copyright-text {\n  @apply text-[12px] font-[400];\n}\n\n.project-number {\n  @apply text-[14px] font-[600] text-[#0c4a72];\n}\n\n.custom-container {\n  @apply max-w-[1200px] mx-auto my-0 px-6;\n}\n\n@media only screen and (max-width: 600px) {\n  .custom-container {\n    @apply px-4;\n  }\n}\n\n.header-links {\n  @apply text-[11px] lg:text-[13px] font-[500];\n}\n\n.form-bg {\n  background: url(\"../../public/side-bg.jpg\");\n  background-repeat: round;\n  width: 100%;\n  object-fit: cover;\n}\n\n.formNew-bg {\n  background: url(\"../../public/about-us.jpg\");\n  background-repeat: round;\n  width: 100%;\n  object-fit: cover;\n}\n\n.input-form {\n  position: absolute;\n  top: 70%;\n  left: 3%;\n  gap: 1%;\n  transform: translate(0%, -50%);\n}\n\ninput::placeholder::after {\n  content: \"*\";\n  color: red;\n  opacity: 1;\n}\n\ninput[type=\"text\"].input-without-icon-1,\ninput[type=\"date\"].input-without-icon-1,\ninput[type=\"date\"].input-without-icon-1,\ninput[type=\"password\"].input-without-icon-1 {\n  @apply border border-[#CCCCCC] pl-[20px] w-full md:w-[380px] h-[50px] rounded-[5px] placeholder:text-[black] placeholder:text-[14px] placeholder:font-[400];\n}\n\n.input-without-icon-1.fullWidth {\n  @apply w-full !important;\n}\n\ntextarea[type=\"text\"].textarea-without-icon-1 {\n  @apply border border-[#CCCCCC] pl-[20px] w-full md:w-[380px] h-[70px] rounded-[5px] placeholder:text-[black] placeholder:text-[14px] placeholder:font-[400];\n}\n\n.project-slider .slick-track {\n  @apply flex gap-[20px] ml-0;\n}\n\n.project-slider .slick-track::after,\n.project-slider .slick-track::before {\n  display: none;\n}\n\n.table-style {\n  width: 90%;\n  margin: auto;\n  border-collapse: collapse;\n  background-color: #fff;\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);\n}\n\n.table-header {\n  background-color: #337ab7;\n  color: #fff;\n  padding: 10px;\n  border: 1px solid #ddd;\n  text-align: left;\n}\n\n.table-cell {\n  padding: 10px;\n  border: 1px solid #ddd;\n  text-align: left;\n}\n\n.even-row {\n  background-color: #f5f5f5;\n}\n\n.signature-link {\n  color: #337ab7;\n  text-decoration: none;\n  transition: color 0.3s ease;\n}\n\n.signature-link:hover {\n  color: #23527c;\n}\n\n.signature-image {\n  width: 50%;\n  height: 50%;\n  display: block;\n  margin: auto;\n  transition: transform 0.3s ease;\n}\n\n.signature-image:hover {\n  transform: scale(1.1);\n}\n\n.sigbtn {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.tableZoom .react-transform-wrapper,\n.tableZoom .react-transform-component {\n  width: 100%;\n}\n\n/* .new-test::placeholder::after {\n  content: \"*\";\n  color: red !important;\n}\n\n.new-test::placeholder::after {\n  content: \" ::after content\";\n  /* Add your content here */\n/* color: #999; */\n/* Color of the pseudo-element */\n/* font-size: 0.8em; */\n/* Font size of the pseudo-element */\n/* Add any other styles you want for the pseudo-element */\n/* } */\n\n/* input[required]::after {\n  content: '*';\n  color: red;\n} */\n.placeholder {\n  color: black;\n  position: relative;\n  top: -35px;\n  left: 22px;\n}\n\n.placeholder:after {\n  content: \"*\";\n  color: red;\n}\n\n.placeholderAnth {\n  color: black;\n  position: relative;\n  left: 22px;\n}\n\n.placeholderAnth:after {\n  content: \"*\";\n  color: red;\n}\n\n.form-control:focus + .placeholder {\n  display: none;\n}\n\n.red-asterisk {\n  color: red;\n}\n\n@keyframes slideInOut {\n  0% {\n    transform: translateX(100%);\n  }\n  10% {\n    transform: translateX(0);\n  }\n}\n\n.animated-element {\n  width: 35vw; /* Set the desired width of the element */\n  z-index: 50;\n  display: flex;\n  justify-content: flex-end;\n  animation: slideInOut 5s ease-in-out;\n}\n\n.gradient-border {\n  position: relative;\n  padding: 1rem;\n}\n\n.gradient-border::before {\n  content: \"\";\n  position: absolute;\n  top: -2px;\n  left: -2px;\n  right: -2px;\n  bottom: -2px;\n  z-index: -1;\n  background: linear-gradient(45deg, #83b9fa, #73bfe8, #5dcdf2);\n  background-size: 200% 200%;\n  animation: gradientBorder 5s ease infinite;\n  border-radius: inherit;\n}\n\n@keyframes gradientBorder {\n  0% {\n    background-position: 0% 50%;\n  }\n  50% {\n    background-position: 100% 50%;\n  }\n  100% {\n    background-position: 0% 50%;\n  }\n}\n\nbutton:hover span {\n  /* transform: translateX(0) translateY(-50%); */\n  opacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
